import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  ar: {
    appName: 'كوجنسي',
    login: 'تسجيل الدخول',
    register: 'اشتراك',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    name: 'الاسم الكامل',
    access: 'الدخول إلى كوجنسي',
    subscribersOnly: 'للمشتركين فقط',
    premiumPersonaMessage: 'مخصص للمشتركين بخطة بريميوم كحد أدنى',
    cannotStartTitle: 'التكوين غير جاهز',
    cannotStartDetail: 'يجب أن يكون لجميع الوكلاء والموّلف نموذج تشغيلي للبدء.',
    collapseSidebar: 'طي القائمة',
    expandSidebar: 'توسيع القائمة',
    pendingTitle: 'الاشتراك قيد الانتظار',
    pendingDesc: 'حسابك بانتظار موافقة المسؤول.',
    logout: 'تسجيل الخروج',
    startCollaborating: 'ابدأ التعاون',
    configureAgents: 'إعداد الوكلاء',
    apiKeys: 'مفاتيح API السحابية',
    discussionRounds: 'جولات النقاش',
    addAgent: 'إضافة وكيل',
    synthesizer: 'الموّلف',
    readyToCollaborate: 'جاهز للتعاون',
    askAnything: 'اسأل أي شيء...',
    connected: 'متصل',
    disconnected: 'غير متصل',
    collaborators: 'المتعاونون',
    share: 'مشاركة',
    invite: 'دعوة',
    save: 'حفظ',
    reconfigure: 'إعادة الإعداد',
    howItWorks: 'كيف يعمل',
    yourAgents: 'وكلاؤك',
    settings: 'الإعدادات',
    interfaceSettings: 'واجهة العرض',
    interfaceSettingsDesc: 'خصص مظهر التطبيق وخيارات المشاركة.',
    rounds: 'جولات',
    debateMode: 'وضع النقاش',
    sequentialMode: 'متسلسل',
    parallelMode: 'متزامن',
    sequentialModeDesc: 'كل وكيل ينتظر رد الوكيل السابق قبل البدء.',
    parallelModeDesc: 'جميع الوكلاء يفكرون في نفس الوقت.',
    session: 'الجلسة',
    finalAnswer: 'الإجابة النهائية',
    copy: 'نسخ',
    showDebate: 'عرض النقاش الكامل',
    hideDebate: 'إخفاء النقاش',
    adminPanel: 'لوحة المسؤول',
    verifyUsers: 'التحقق من المشتركين',
    noPendingUsers: 'لا يوجد مشتركين قيد الانتظار',
    verify: 'تحقق',
    footer: '© شركة حلول وتقنيات سينابتيكس المحدودة. جميع الحقوق محفوظة.',
    poweredBy: 'مدعوم من كوجنسي',
    joinSession: 'الانضمام إلى جلسة',
    enterSessionId: 'أدخل معرف الجلسة أو الرابط',
    subscriberWelcome: 'أهلاً بك! انضم إلى جلسة للتعاون مع وكلاء الذكاء الاصطناعي.',
    lockedForAdmin: 'الإعدادات مقفلة — للمسؤول فقط',
    reject: 'رفض',
    inviteToSession: 'دعوة إلى الجلسة',
    invited: 'تمت الدعوة',
    subscribers: 'المشتركون',
    plans: 'الخطط',
    cogency: 'كوجنسي',
    status: 'الحالة',
    agents: 'الوكلاء',
    admin: 'المسؤول',
    checkingProviders: 'التحقق من المزودين',
    connecting: 'جاري الاتصال...',
    connectedTo: 'متصل',
    noProvidersAvailable: 'لا يوجد مزودون متاحون',
    availableModels: 'النماذج المتاحة',
    loading: 'جاري التحميل...',
    startSharedSession: 'ابدأ جلسة مشتركة',
    sharedSessionsHint: 'الجلسات المشتركة تتيح للآخرين المشاهدة والتعاون في الوقت الفعلي.',
    connectionFailed: 'فشل الاتصال',
    noProvidersAvailableDetail: 'لا توجد مزودات ذكاء اصطناعي متاحة. تأكد من تشغيل Ollama، أو أضف مفاتيح API للمزودين السحابيين.',
    tryAgain: 'حاول مرة أخرى',
    agent: 'وكيل',
    remove: 'إزالة',
    persona: 'شخصية',
    model: 'النموذج',
    powerUser: 'المستخدم المتقدم',
    locked: 'مقفل',
    unlockPowerUser: 'فتح المستخدم المتقدم',
    enterUnlockCode: 'أدخل رمز الفتح',
    unlock: 'فتح',
    incorrectUnlockCode: 'رمز الفتح غير صحيح.',
    addKeysDesc: 'أضف المفاتيح لاستخدام نماذج Claude وKimi وHugging Face أو TchadGPT. يعمل Ollama بدون مفاتيح.',
    powerUserFeature: 'ميزة المستخدم المتقدم. افتح لإعداد المزودين السحابيين.',
    combinesAllAgentArguments: 'يجمع جميع حجج الوكلاء في إجابة واحدة واضحة ومتوازنة.',
    eachRoundEveryAgentSpeaks: 'في كل جولة، يتحدث كل وكيل مرة واحدة. المزيد من الجولات = نقاش أعمق.',
    backToHome: 'العودة إلى الرئيسية',
    help: 'مساعدة',
    collaborate: 'تعاون',
    exportPDF: 'تصدير PDF',
    exportDOCX: 'تصدير DOCX',
    exportPPTX: 'تصدير PPTX',
    exportLaTeX: 'تصدير LaTeX',
    export: 'تصدير',
    processing: 'جاري المعالجة...',
    welcome: 'مرحباً',
    startAsking: 'اكتب سؤالاً أدناه أو استخدم الميكروفون للتحدث، وشاهد وكلاء الذكاء الاصطناعي يناقشون الإجابة.',
    initialAnalysis: 'التحليل الأولي',
    debateRound1: 'جولة النقاش 1',
    debateRound2: 'جولة النقاش 2',
    send: 'إرسال',
    listeningSpeakNow: 'جاري الاستماع... تكلم الآن',
    stop: 'إيقاف',
    processingYourVoice: 'جاري معالجة صوتك...',
    cancel: 'إلغاء',
    enterYourIntervention: 'أدخل تدخلك...',
    pass: 'تخطي',
    noIntervention: 'لا يوجد تدخل',
    pressEnterToSend: 'اضغط Enter للإرسال',
    useSendButton: 'استخدم زر الإرسال للإرسال',
    clickToSpeak: 'اضغط 🎤 للتحدث',
    voiceOutputOn: 'الإخراج الصوتي مفعل',
    textVoiceOutput: 'نص + إخراج صوتي',
    textOutputOnly: 'إخراج نصي فقط',
    readAloud: 'قراءة بصوت عالٍ',
    mindMap: 'خريطة الذهن',
    generateImage: 'إنشاء صورة / مخطط',
    describeImageToGenerate: 'صف الصورة المراد إنشاؤها…',
    detailedImageOptions: 'خيارات مفصلة',
    generatedImage: 'صورة مولدة',
    actions: 'إجراءات',
    regenerateImage: 'إعادة إنشاء الصورة',
    exportImagePPTX: 'تصدير كـ PPTX',
    exportImagePDF: 'تصدير كـ PDF',
    deleteImage: 'حذف الصورة',
    imageGenIntro: 'قبل إنشاء الصورة، يُرجى توضيح احتياجاتك للحصول على نتيجة مفيدة وموضوعية.',
    failedToGenerateImage: 'فشل إنشاء الصورة',
    generating: 'جاري الإنشاء…',
    generate: 'إنشاء',
    analyzingContent: 'تحليل المحتوى...',
    generatingMindMapStructure: 'إنشاء هيكل خريطة الذهن...',
    organizingBranches: 'تنظيم الفروع...',
    finalizing: 'جاري الإنهاء...',
    complete: 'اكتمل!',
    failedToGenerateMindMap: 'فشل في إنشاء خريطة الذهن',
    errorGeneratingMindMap: 'خطأ في إنشاء خريطة الذهن',
    failedToExportPDF: 'فشل في تصدير PDF',
    error: 'خطأ',
    you: 'أنت',
    humanIntervention: 'تدخل بشري',
    moderator: 'المشرف',
    voiceSettings: 'إعدادات الصوت',
    onlyAdministratorsCanChangeVoiceSettings: 'يمكن للمسؤولين فقط تغيير إعدادات الصوت.',
    voiceInput: 'الإدخال الصوتي',
    serverSTT: 'STT الخادم',
    browserSTT: 'STT المتصفح',
    voiceOutput: 'الإخراج الصوتي',
    serverTTS: 'TTS الخادم',
    browserTTS: 'TTS المتصفح',
    voiceOutputSettingsAdmin: 'إعدادات الإخراج الصوتي (مسؤول)',
    stt: 'STT',
    serverWhisper: 'الخادم (Whisper)',
    browserWebSpeech: 'المتصفح (Web Speech)',
    tts: 'TTS',
    serverEspeak: 'الخادم (eSpeak)',
    browserSpeechSynthesis: 'المتصفح (SpeechSynthesis)',
    outputMode: 'وضع الإخراج',
    textOnly: 'نص فقط',
    textOnlyDesc: 'تظهر الردود كنص فقط',
    voiceOnly: 'صوت فقط',
    voiceOnlyDesc: 'الردود تُقرأ بصوت عالٍ',
    textAndVoice: 'نص + صوت',
    textAndVoiceDesc: 'كل من النص والإخراج الصوتي',
    voiceType: 'نوع الصوت',
    human: 'بشري',
    artificial: 'اصطناعي',
    gender: 'الجنس',
    male: 'ذكر',
    female: 'أنثى',
    age: 'العمر',
    young: 'شاب',
    old: 'كبير',
    language: 'اللغة',
    voiceEnabled: 'تفعيل الصوت',
    outputVoice: 'الصوت الخارج',
    voiceCommand: 'الأوامر الصوتية',
    voiceSelection: 'اختيار الصوت',
    voiceSelectionDesc: 'اختر الصوت المستخدم لقراءة الإجابات.',
    availableVoices: 'الأصوات المتاحة',
    availableVoicesDesc: 'اختر صوتاً من الأصوات المتوفرة في متصفحك.',
    noVoicesAvailable: 'لا توجد أصوات متاحة',
    voiceRate: 'السرعة',
    voiceRateDesc: 'سرعة الكلام',
    voicePitch: 'النبرة',
    voicePitchDesc: 'نبرة الصوت',
    testVoice: 'اختبار الصوت',
    selectedVoice: 'الصوت المختار',
    voiceTestText: 'كوجنسي جاهز لمساعدتك.',
    underDevelopment: 'قيد التطوير',
    selectYourSkill: 'اختر مهارتك',
    selectYourSkillDesc: 'اختر مستوى خبرتك لتخصيص واجهتك.',
    skillBeginner: 'مبتدئ',
    skillProfessional: 'محترف',
    skillExpert: 'خبير',
    skillBeginnerDesc: 'واجهة مبسطة مع إرشادات تدريجية.',
    skillProfessionalDesc: 'واجهة كاملة مع جميع الخيارات المتاحة.',
    skillExpertDesc: 'وضع متقدم مع ضوابط دقيقة.',
    skillComingSoon: 'الواجهة قيد التطوير',
    skillComingSoonDesc: 'واجهة {skill} قيد التطوير.',
    xaiVoice: 'صوت Grok (xAI)',
    xaiVoiceDesc: 'تحويل النص إلى كلام والكلام إلى نص عبر صوت Grok من xAI.',
    xaiUnavailableHint: 'تحقق من مفتاح XAI_VOICE_API_KEY في إعدادات الخادم.',
    xaiTts: 'تحويل النص إلى كلام',
    xaiStt: 'تحويل الكلام إلى نص',
    xaiVoiceSelect: 'الصوت',
    xaiVoiceSelectDesc: 'اختر صوت التوليف',
    xaiTtsTest: 'اختبار تحويل النص إلى كلام',
    xaiSttTest: 'اختبار تحويل الكلام إلى نص',
    xaiTtsTestText: 'مرحباً، هذا اختبار لصوت Grok.',
    xaiTtsFailed: 'فشل تحويل النص إلى كلام عبر Grok',
    xaiSttFailed: 'فشل تحويل الكلام إلى نص عبر Grok',
    startRecording: 'بدء التسجيل',
    stopRecording: 'إيقاف',
    fullscreen: 'ملء الشاشة',
    connectedAs: 'متصل باسم',
    changeLogo: 'تغيير الشعار',
    customizeLogo: 'تخصيص الشعار',
    logoUploaderHint: 'اختر صورة لهذا القرص (صورتك، شعار، إلخ). لن تطبق إلا على هذه الشريط.',
    exitFullscreen: 'إنهاء ملء الشاشة',
    closeSession: 'إغلاق الجلسة',
    connectedAt: `متصل منذ`,
    ipAddress: `عنوان IP`,
    noConnectedAddresses: `لا توجد عناوين IP متصلة.`,
    connectedAddresses: `العناوين المتصلة`,
    tracking: `التتبع`,
    connectionLog: `سجل الاتصالات`,
    connectionLogDesc: `سجل الاتصالات مع عنوان IP ونظام التشغيل ونوع الجهاز.`,
    deviceType: `الجهاز`,
    uniqueIps: `عناوين IP فريدة`,
    entries: `إدخالات`,
    noConnectionLog: `لا توجد اتصالات مسجلة.`,
    searchConnectionLog: `البحث عن IP، OS، جهاز، متصفح...`,
    sortRecent: `الأحدث`,
    sortOldest: `الأقدم`,
    sortByCountry: `الدولة`,
    sortByDevice: `نوع الجهاز`,
    sortByOs: `نظام التشغيل`,
    sortByBrowser: `المتصفح`,
    sortByUser: `المستخدم`,
    sortByAction: `حالة الاتصال`,
    scrollToBottom: `الانتقال إلى الأسفل`,
    refresh: `تحديث`,
    connect: `اتصال`,
    disconnect: `قطع الاتصال`,
    date: `التاريخ`,
    action: `الإجراء`,
    sharedSessionHint: `الجلسات المشتركة تتيح للآخرين المشاهدة والتعاون في الوقت الفعلي.`,
    startSharedSession: `ابدأ جلسة مشتركة`,
    startCollaborating: `ابدأ التعاون`,
    brandTagline: 'النجاح هو الاستمرار حيث توقف الآخرون',
    statusThinking: '{label}: جميع الوكلاء يفكرون بشكل متوازي...',
    moderationPrompt: 'الجولة {round} مكتملة. هل يرغب أي مشارك في التدخل قبل الجولة {nextRound}؟',
    on: 'تشغيل',
    off: 'إيقاف',
    saving: 'جاري الحفظ...',
    saveSettings: '💾 حفظ الإعدادات',
    settingsSavedSuccessfully: '✅ تم حفظ الإعدادات بنجاح',
    failedToSaveSettings: '❌ فشل في حفظ الإعدادات',
    howItWorksTitle: 'كيف يعمل',
    youAskAQuestion: 'تطرح سؤالاً',
    typeAnything: 'اكتب أي شيء — من أسئلة بسيطة إلى نقاشات معقدة.',
    multipleAgentsAnalyze: 'تحليل متعدد الوكلاء',
    eachAgentBringsPerspective: 'كل وكيل يجلب منظوره الفريد ونموذجه.',
    theyDebateInRounds: 'يناقشون في جولات',
    everyRoundEachAgentResponds: 'في كل جولة، يستجيب كل وكيل للمحادثة الكاملة حتى الآن.',
    youGetTheBestAnswer: 'تحصل على أفضل إجابة',
    synthesizerCombinesBestPoints: 'الموّلف يجمع أفضل النقاط في إجابة واحدة واضحة.',
    helpIntro: `على عكس الذكاء الاصطناعي الفردي أو الذكاء الاصطناعي بالتوافق، لا يكتفي Cogency بإعطائك إجابة مباشرة. تطرح سؤالك أو موضوعك، ثم يناقش عدة وكلاء ذكاء اصطناعي معاً. حيث تبحث أنظمة الذكاء الاصطناعي التقليدية عن الإجابة بمفردها، يمنحك Cogency الصوت: في كل جولة، يمكنك إبداء رأيك، إضافة توضيح، انتقاد إجابة، أو النقر على تخطي لإبقاء النقاش مستمراً. تشارك بنشاط في صياغة الإجابة وتؤثر في تحليل الوكلاء أثناء عملهم.`,
    helpCoreTitle: 'سير العمل',
    helpStep1Title: `1. طرح المضيف للسؤال`,
    helpStep1Text: `المستخدم — المضيف — يطرح سؤاله أو المشكلة التي يريد مناقشتها.`,
    helpStep2Title: `2. إجابة أول وكيل ذكاء اصطناعي`,
    helpStep2Text: `يقدم أول وكيل إجابته المباشرة على السؤال.`,
    helpStep3Title: `3. إجابة ونقد الوكيل الثاني`,
    helpStep3Text: `يقدم الوكيل الثاني إجابته الخاصة، ثم ينتقد أو يكمل إجابة الوكيل الأول، ويختم مساهمته بخلاصة.`,
    helpStep4Title: `4. تكرار الآلية لكل وكيل تالي`,
    helpStep4Text: `كل وكيل لاحق يفعل الشيء نفسه تجاه جميع إجابات الوكلاء والبشر الذين سبقوه.`,
    helpStep5Title: `5. مشاركة الضيوف وانتهاء الجولة`,
    helpStep5Text: `تنتهي الجولة بدعوة المشاركين الآخرين — محليين أو عن بُعد — والمضيف للتعليق أو الإضافة. يمكن للجميع النقر على "تخطي" لمواصلة النقاش.`,
    helpStep6Title: `6. استمرار الجولات`,
    helpStep6Text: `تتكرر الجولات بنفس المنطق حتى الجولة الأخيرة.`,
    helpStep7Title: `7. نشر المشرف للإجابة النهائية`,
    helpStep7Text: `ينشر المشرف — وكيل ذكاء اصطناعي أو بشري — الإجابة النهائية، وهي خلاصة جميع المساهمات وتحليلها في ضوء البيانات المتاحة.`,
    helpStep8Title: `8. خريطة ذهنية للنقاش`,
    helpStep8Text: `ترسم خريطة ذهنية تلقائية لتسلسل أفكار وأركان النقاش.`,
    helpStep9Title: `9. تصدير المحتوى`,
    helpStep9Text: `يمكن للمضيف تصدير كامل تاريخ النقاط بصيغ PDF وPPTX وDOCX وLaTeX، كما يمكن تصدير كل إجابة على حدة.`,
    helpFeaturesTitle: 'الميزات الرئيسية',
    helpMultiAgentTitle: 'وكلاء متخصصون',
    helpMultiAgentText: `كل وكيل له شخصيته ونموذجه وخبرته الخاصة لإثراء النقاش.`,
    helpDebateRoundsTitle: 'جولات النقاش',
    helpDebateRoundsText: `يتبادل الوكلاء الردود عدة مرات ويحسنون حججهم ويتفاعلون مع أفكار الآخرين.`,
    helpSynthesisTitle: 'الإجابة النهائية',
    helpSynthesisText: `وكيل تلخيص يجمع أفضل الحجج في استنتاج منظم وقابل للتنفيذ.`,
    helpInterventionTitle: 'التدخل البشري',
    helpInterventionText: `يمكنك التدخل في أي وقت لتوجيه النقاش أو تصحيحه أو التعمق فيه.`,
    helpMoreTitle: 'أيضاً',
    helpVoiceTitle: 'التحكم الصوتي',
    helpVoiceText: `تحدث لطرح أسئلتك ودع التطبيق يقرأ الإجابات بصوت عالٍ.`,
    helpAgentsPersonasTitle: 'التخصيص',
    helpAgentsPersonasText: `اختر وكلاء جاهزين أو أنشئ شخصيات ونماذجك الخاصة.`,
    helpExportTitle: 'التصدير',
    helpExportText: `حمّل المحادثة أو الملخص بصيغ PDF أو DOCX أو PPTX أو LaTeX.`,
    helpHistoryTitle: 'السجل',
    helpHistoryText: `اعثر على جلساتك السابقة واستأنفها واطلع عليها في أي وقت.`,
    helpCollaborationTitle: 'جلسات مشتركة',
    helpCollaborationText: `ابدأ جلسة عامة وادعُ مستخدمين آخرين لمتابعة النقاش مباشرة.`,
    helpAccessibilityTitle: 'إمكانية الوصول',
    helpAccessibilityText: `اضبط التباين وحجم النص والرسوم المتحركة والأصوات حسب احتياجاتك.`,
    helpCommandsTitle: 'أوامر سريعة',
    helpCommandImage: `الوكلاء يمكنهم إدراج صورة تلقائياً عندما يفيد ذلك في إثراء إجابتهم.`,
    helpCommandMindMap: 'ينشئ خريطة ذهنية تلقائية من الموضوع.',
    helpCommandIntervene: 'يدخل رسالتك الخاصة في النقاش.',
    helpCommandVoice: 'يفعل أو يعطل التعرف على الصوت.',
    helpCommandExport: 'يصدر آخر إجابة فوراً بالصيغة المختارة.',
    helpPlansTitle: 'الباقات والتجربة',
    helpPlansText: `ابدأ بتجربة مجانية، ثم اختر الباقة المناسبة لاستخدامك. يمكن للمسؤولين إدارة الاشتراكات من لوحة الإدارة.`,
    helpPrivacyTitle: 'الخصوصية',
    helpPrivacyText: `محادثاتك مرتبطة بحسابك. يمكن لـ Cogency العمل مع نماذج محلية (Ollama) للحفاظ على بياناتك على الجهاز.`,
    helpDebateMechanismTitle: `آلية النقاش`,
    helpDebateMechanismText: `في الجولة الأولى، يقدم أول وكيل إجابته المباشرة للسؤال. منذ تدخل الوكيل الثاني، يقدم كل وكيل نسخته الخاصة وينتقد أيضاً رد من سبقه. وهكذا بالتناوب، يعبر جميع الوكلاء (وكذلك البشر) عن آرائهم وينتقدون المساهمات السابقة، مما يثري النقاش ويوجه التحليل نحو إجابة أفضل.`,
    helpAddedValueTitle: `القيمة المضافة`,
    helpAddedValueText: `تتميز الإجابات والتوجيهات التي يقدمها Cogency بطابعها الموحّد، لأنها تعتمد على تحليل يجمع بين بعدين سياقيين أساسيين. البعد الأول محلي: يأخذ في الاعتبار وضع المستخدم وخصوصيات سياقه. والبعد الثاني عالمي: يدمج أحدث المستجدات والتحديثات المتعلقة بالموضوع على المستوى العالمي. وبالتالي، لا تقتصر النتيجة على معلومة عابرة، بل تتشكل كخلاصة منظمة ومستندة إلى تحليل معمّق.`,
    helpTipTitle: '💡 نصيحة',
    helpTipText: `كن دقيقاً في أسئلتك وزد عدد الجولات للحصول على تحليلات أعمق.`,
    inviteCollaborators: 'دعوة المتعاونين',
    shareSessionLink: '🔗 مشاركة رابط الجلسة',
    anyoneWithThisLink: 'يمكن لأي شخص لديه هذا الرابط الانضمام ومشاهدة النقاش في الوقت الفعلي.',
    createSessionAndCopyLink: '💾 إنشاء جلسة ونسخ الرابط',
    inviteAIAgent: '🤖 دعوة وكيل ذكاء اصطناعي',
    addAnotherAIAgent: 'أضف وكيل ذكاء اصطناعي آخر إلى القائمة للنقاش التالي.',
    addAgent: 'إضافة وكيل',
    currentParticipants: '👥 المشاركون الحاليون',
    noParticipantsYet: 'لا يوجد مشاركون بعد',
    back: '← رجوع',
    sessionHistory: '📜 تاريخ الجلسات',
    history: 'التاريخ',
    sessions: 'جلسات',
    loadingSessions: 'جاري تحميل الجلسات...',
    noSavedSessionsYet: 'لا توجد جلسات محفوظة بعد.',
    completedDebatesWillAppear: 'ستظهر النقاشات المكتملة هنا تلقائياً.',
    selectSessionToViewDetails: 'اختر جلسة لعرض التفاصيل',
    loadingSession: 'جاري تحميل الجلسة...',
    untitledSession: 'جلسة بدون عنوان',
    purgeEmptySessions: '🧹 مسح الجلسات الفارغة',
    confirmPurgeEmptySessions: 'حذف جميع الجلسات التي لا تحتوي على رسائل؟ لا يمكن التراجع عن هذا الإجراء.',
    purgedEmptySessions: 'تم مسح الجلسات الفارغة',
    purgeFailed: 'فشل مسح الجلسات',
    translateToFrench: 'Traduire en français',
    translateToArabic: 'Traduire en arabe',
    translationFailed: 'Échec de la traduction',
    round: 'جولة',
    debateHistory: '🗣️ تاريخ النقاش',
    sendSessionByEmail: '📧 إرسال الجلسة بالبريد الإلكتروني',
    recipientEmail: 'recipient@example.com',
    sending: 'جاري الإرسال...',
    deleteSessionConfirm: 'هل أنت متأكد أنك تريد حذف هذه الجلسة نهائياً؟',
    failedToLoadSessions: 'فشل في تحميل الجلسات',
    failedToLoadSessionDetail: 'فشل في تحميل تفاصيل الجلسة',
    exportFailed: 'فشل التصدير',
    generatingDocument: `جاري إنشاء المستند…`,
    deleteFailed: 'فشل الحذف',
    failedToExportDOCX: 'فشل في تصدير DOCX',
    failedToExportPPTX: 'فشل في تصدير PPTX',
    pythonExecutionFailed: 'فشل تنفيذ Python',
    failedToSendEmail: 'فشل في إرسال البريد الإلكتروني',
    pleaseEnterValidEmail: 'الرجاء إدخال عنوان بريد إلكتروني صالح',
    emailSentSuccessfully: 'تم إرسال البريد الإلكتروني بنجاح!',
    teamChat: '💬 دردشة الفريق',
    typeAMessage: 'اكتب رسالة...',
    mindMapTitle: '🧠 خريطة الذهن',
    zoomIn: 'تكبير',
    zoomOut: 'تصغير',
    reset: 'إعادة تعيين',
    scrollToZoom: '🖱 التمرير للتكبير',
    dragToPan: 'السحب للتحريك',
    clickBranchesToExpandCollapse: 'انقر على الفروع للتوسيع/الطي',
    copySource: '📋 نسخ المصدر',
    sourceTextCopied: 'تم نسخ نص المصدر إلى الحافظة!',
    authenticating: 'جاري المصادقة...',
    loginFailed: 'فشل تسجيل الدخول',
    networkErrorPleaseTryAgain: 'خطأ في الشبكة. يرجى المحاولة مرة أخرى.',
    registrationSuccessful: 'تم التسجيل بنجاح!',
    pleaseWaitForAdminApproval: 'يرجى الانتظار حتى موافقة المسؤول.',
    registering: 'جاري التسجيل...',
    registrationFailed: 'فشل التسجيل',
    fullName: 'الاسم الكامل',
    username: 'اسم المستخدم',
    phone: 'رقم الهاتف',
    gender: 'الجنس',
    female: 'أنثى',
    male: 'ذكر',
    age: 'العمر',
    profession: 'المهنة',
    confirmPassword: 'تأكيد كلمة المرور',
    charterAgreement: 'اتفاقية الميثاق',
    iHaveReadCharter: 'لقد قرأت ميثاق كوجنسي',
    readCharter: 'اقرأ الميثاق',
    iAcceptCharter: 'أوافق على الميثاق وأتعهد باحترامه',
    iCommitNobleUse: 'أتعهد باستخدام كوجنسي لأغراض نبيلة فقط وليس لأي أغراض ضارة',
    fullNameRequired: 'الاسم الكامل مطلوب',
    usernameRequired: 'اسم المستخدم مطلوب',
    usernameTooShort: 'يجب أن يكون اسم المستخدم 3 أحرف على الأقل',
    validEmailRequired: 'بريد إلكتروني صالح مطلوب',
    phoneRequired: 'رقم الهاتف مطلوب',
    genderRequired: 'الجنس مطلوب',
    validAgeRequired: 'العمر يجب أن يكون بين 13 و 120 سنة',
    professionRequired: 'المهنة مطلوبة',
    passwordMin6Chars: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
    passwordsDoNotMatch: 'كلمتا المرور غير متطابقتين',
    mustReadCharter: 'يجب عليك قراءة الميثاق',
    mustAcceptCharter: 'يجب عليك قبول الميثاق',
    mustCommitNobleUse: 'يجب عليك الالتزام بالاستخدام النبيل',
    privacyTitle: 'خصوصيتك تهمنا',
    privacyText: 'نحن نحترم خصوصيتك. نحن ملتزمون بعدم مشاركة بياناتك مع أطراف ثالثة. تُستخدم معلوماتك فقط لتحسين تجربتك كمستخدم.',
    privacyNoShare: 'لا مشاركة للبيانات مع أطراف ثالثة',
    privacyExperience: 'البيانات تُستخدم فقط لتحسين التجربة',
    privacySecure: 'تخزين آمن ومشفر',
    understoodContinue: 'مفهوم، استمر',
    fullNamePlaceholder: 'أحمد محمد',
    usernamePlaceholder: 'ahmed_mohamed',
    phonePlaceholder: '+235 99 12 34 56',
    agePlaceholder: '25',
    professionPlaceholder: 'مهندس، طبيب، طالب...',
    passwordPlaceholder: '••••••',
    confirmPasswordPlaceholder: '••••••',
    noActiveSession: 'لا توجد جلسة نشطة',
    pendingApproval: 'قيد الموافقة',
    allUsers: 'جميع المستخدمين',
    noUsersFound: 'لم يتم العثور على مستخدمين.',
    deleteUser: 'حذف المستخدم',
    suspendUser: 'تعليق المستخدم',
    activateUser: 'تفعيل المستخدم',
    ejectUser: 'طرد المستخدم',
    notifyUsers: 'إشعار المستخدمين',
    sendNotification: 'إرسال إشعار',
    notificationTitle: 'عنوان الإشعار',
    notificationMessage: 'رسالة الإشعار',
    selectUsers: 'اختيار المستخدمين',
    all: 'الكل',
    modelGrowth: 'نمو النموذج',
    localModelStats: 'إحصائيات النموذج المحلي',
    services: 'الخدمات',
    externalServices: 'الخدمات الخارجية',
    enableElevenLabs: 'تفعيل ElevenLabs',
    elevenLabsCaption: 'استخدم واجهة ElevenLabs للأصوات عالية الجودة.',
    elevenLabsEnabled: 'ElevenLabs مفعل.',
    elevenLabsDisabled: 'ElevenLabs معطل. يتم استخدام TTS المتصفح.',
    totalLocalCalls: 'إجمالي الاستدعاءات المحلية',
    totalTokens: 'إجمالي الرموز',
    sessionsWithLocal: 'الجلسات المحلية',
    learningScore: 'درجة التعلم',
    modelUsage: 'استخدام النماذج',
    dailyGrowth: 'النمو اليومي',
    noData: 'لا توجد بيانات',
    userManagement: 'إدارة المستخدمين',
    actions: 'إجراءات',
    suspended: 'موقوف',
    active: 'نشط',
    deleted: 'تم الحذف',
    ejected: 'تم الطرد',
    confirmDeleteUser: 'هل أنت متأكد من حذف هذا المستخدم؟',
    confirmSuspendUser: 'هل أنت متأكد من تعليق هذا المستخدم؟',
    confirmEjectUser: 'هل أنت متأكد من طرد هذا المستخدم من جميع الجلسات؟',
    resetPassword: 'إعادة تعيين كلمة المرور',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور',
    passwordTooShort: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
    passwordsDoNotMatch: 'كلمتا المرور غير متطابقتين',
    passwordResetSuccess: 'تم إعادة تعيين كلمة المرور بنجاح',
    passwordResetFailed: 'فشل في إعادة تعيين كلمة المرور',
    newSession: 'جلسة جديدة',
    modeBypass: 'وضع التجاوز — لا يتوقف المنسق لطلب رأيك',
    modePresent: 'وضع الحضور — ينتظرك المنسق للتعليق',
    bypass: 'تجاوز',
    present: 'حضور',
    notificationSent: 'تم إرسال الإشعار',
    usersOnline: 'المستخدمون المتصلون',
    accessibility: 'إمكانية الوصول',
    accessibilityDesc: 'تخصيص كوجنسي لاحتياجاتك.',
    largeText: 'نص كبير',
    largeTextDesc: 'زيادة حجم النص بنسبة 15%',
    highContrast: 'تباين عالي',
    highContrastDesc: 'ألوان قوية لرؤية أفضل',
    reducedMotion: 'تقليل الحركة',
    reducedMotionDesc: 'تقليل الرسوم المتحركة',
    keyboardShortcuts: 'اختصارات لوحة المفاتيح',
    focusInput: 'تركيز حقل الإدخال',
    sendMessage: 'إرسال الرسالة',
    stopOrCancel: 'إيقاف الصوت أو الإلغاء',
    enableVoice: 'تفعيل الأوامر الصوتية',
    disableVoice: 'إيقاف الأوامر الصوتية',
    holdToSpeak: 'اضغط مع الاستمرار للتحدث',
    listening: 'يستمع...',
    heard: 'سمع',
    voiceHint: 'اضغط مفتاح المسافة أو اضغط على الميكروفون للتحدث',
    voiceHintMobile: 'اضغط على الميكروفون للتحدث',
    voiceLogin: 'فتح تسجيل الدخول',
    voiceRegister: 'فتح التسجيل',
    voiceLogout: 'تسجيل الخروج',
    voiceGoToChat: 'فتح الدردشة',
    voiceGoToSetup: 'فتح الإعدادات',
    voiceGoToHistory: 'فتح التاريخ',
    voiceHelpText: 'يمكنك أن تقول: الذهاب إلى الدردشة، الذهاب إلى الإعدادات، إضافة وكيل، اسأل متبوعاً بسؤالك، اكتب اسم الحقل متبوعاً بالقيمة، إرسال، تسجيل الخروج.',
    voiceEnabled: 'الأوامر الصوتية مفعلة',
    voiceDisabled: 'الأوامر الصوتية معطلة',
    voiceTyped: 'تمت الكتابة',
    voiceSubmitted: 'تم الإرسال',
    voiceAsking: 'يسأل',
    voiceReadingLast: 'قراءة آخر رسالة',
    voiceReadingAll: 'قراءة كل الرسائل',
    voiceStopped: 'توقف',
    voiceAgentAdded: 'تمت إضافة الوكيل',
    voiceAgentRemoved: 'تم حذف الوكيل',
    voiceDidNotUnderstand: 'لم أفهم. قول مساعدة للأوامر المتاحة.',
    voiceNotSupported: 'التعرف على الصوت غير مدعوم في هذا المتصفح.',
    policyWarning: 'تحذير السياسة: ينتهك هذا الطلب ميثاق كوجنسي (المحتوى المتعلق بالصراعات السياسية أو الدينية ممنوع صراحةً). تم تسجيل هذه المحاولة. بعد محاولات إضافية، سيتم اتخاذ إجراءات.',
    policyEnforcement: 'إجراء: تم تعليق حسابك لانتهاك سياسة كوجنسي الداخلية والميثاق. المحتوى المتعلق بالصراعات السياسية أو الدينية ممنوع صراحةً. اتصل بالمسؤول.',
    viewCharter: 'عرض الميثاق',
    policyNotice: 'ملاحظة السياسة',
    edit: 'تعديل',
    delete: 'حذف',
    cancel: 'إلغاء',
    edited: 'معدل',
    cancelDebate: 'إلغاء النقاش',
    resume: 'استئناف',
    liveSessions: 'الجلسات النشطة',
    persist: 'حفظ',
    dumpAll: 'حفظ الكل',
    inMemory: 'في الذاكرة',
    orphanedSessions: 'جلسات يتيمة',
    charterTitle: 'ميثاق الاستخدام وسياسة الاستخدام الداخلية',
    charterVersion: 'الإصدار 1.0',
    charterEffective: 'ساري المفعول من تاريخ النشر.',
    charterArt1Title: 'الموضوع ونطاق التطبيق',
    charterArt1Text: 'كوجنسي هي أداة متعددة التخصصات لمساعدة اتخاذ القرار، مصممة لتسهيل البحث العلمي والتحليل التقني والاستكشاف التعاوني للمواضيع المعقدة. ينطبق هذا الميثاق على جميع المستخدمين والمشتركين والمسؤولين والشركاء الذين يصلون إلى المنصة.',
    charterArt2Title: 'الغرض العلمي والتقني الصارم',
    charterArt2Intro: 'على الرغم من أن كوجنسي أداة متعددة التخصصات لمساعدة اتخاذ القرار، إلا أن غرضها يظل علميًا وتقنيًا بشكل صارم. يجب عدم استخدام المنصة أبدًا لـ:',
    charterArt2Item1: 'تغذية أو تبرير أو الدفاع عن أي نزاع من أي نوع؛',
    charterArt2Item2: 'ترويج أيديولوجيات سياسية أو دينية أو طائفية؛',
    charterArt2Item3: 'التحريض على الكراهية أو التمييز أو العنف؛',
    charterArt2Item4: 'إنتاج محتوى دعائي أو تضليلي أو التلاعب بالرأي العام.',
    charterArt3Title: 'الحظر الصارم للمحتوى السياسي والديني ذي الطابع النزاعي',
    charterArt3Intro: 'يُحظر صراحةً أي سؤال أو بحث أو نقاش أو تدخل يتناول مواضيع سياسية أو دينية، خاصة عندما تتعلق بالنزاعات أو الحركات المتطرفة أو الحروب أو الاضطهاد أو الكراهية بين المجتمعات.',
    charterArt3Item1: 'المصطلحات والمفاهيم المرتبطة بالنزاعات المسلحة والإرهاب والإبادة الجماعية والتطهير العرقي والانقلابات والأنظمة الشمولية؛',
    charterArt3Item2: 'المصطلحات والمفاهيم المرتبطة بالجهاد والحروب الصليبية والمحاكم التفتيشية والفتاوى والردة القسرية والتطرف الديني.',
    charterArt4Title: 'إجراءات المراقبة والعقوبة',
    charterArt4_1Title: 'التسجيل',
    charterArt4_1Text: 'يتم تسجيل أي محاولة لإرسال محتوى ينتهك هذا الميثاق تلقائيًا مع الطابع الزمني ومعرف المستخدم وطبيعة المحاولة.',
    charterArt4_2Title: 'التحذير التدريجي',
    charterArt4_2Item1: 'المحاولة الأولى والثانية — يتلقى المستخدم تحذيرًا صريحًا يذكره بالميثاق ويُشير إلى أن المحاولة قد سُجلت.',
    charterArt4_2Item2: 'المحاولة الثالثة — يتم تلقائيًا إجراء إجراء تأديبي لعدم الامتثال للميثاق. قد يؤدي إلى تعليق مؤقت أو دائم للوصول إلى المنصة.',
    charterArt4_3Title: 'الاستئناف',
    charterArt4_3Text: 'يمكن للمستخدمين الاتصال بالمسؤول في حالة عدم الاتفاق مع قرار تلقائي، بشرط تقديم عناصر تبرر الطابع العلمي أو التقني الصارم لطلبهم.',
    charterArt5Title: 'مسؤوليات المستخدمين',
    charterArt5Item1: 'الامتثال الصارم لهذا الميثاق؛',
    charterArt5Item2: 'استخدام كوجنسي فقط في إطار مهني أو أكاديمي أو بحثي؛',
    charterArt5Item3: 'الإبلاغ عن أي سلوك أو محتوى مشبوه إلى المسؤول.',
    charterArt6Title: 'تعديل الميثاق',
    charterArt6Text: 'تحتفظ كوجنسي بالحق في تعديل هذا الميثاق في أي وقت. سيتم إبلاغ المستخدمين بأي تحديث جوهري عبر المنصة.',
    themes: 'السمات',
    themesIntro: 'اختر مظهرًا يناسبك. يمكن للسمات ذات الصور أن تضيف خلفية بصرية إلى التطبيق.',
    chatTransparency: 'شفافية الدردشة',
    chatTransparencyHint: 'اجعل بطاقة الدردشة شفافة لمشاهدة صورة الخلفية',
    attachDocument: 'إرفاق مستند',
    close: 'إغلاق',
    noContactsToInvite: 'لا يوجد جهات اتصال لدعوتها',
    selectUser: 'اختر مستخدمًا',
    manageContacts: 'إدارة جهات الاتصال',
    contactManager: 'مدير جهات الاتصال',
    friend: 'صديق',
    colleague: 'زميل',
    superior: 'رئيس',
    add: 'إضافة',
    loading: 'جار التحميل',
    noContactsYet: 'لا توجد جهات اتصال بعد',
    confirmDeleteContact: 'هل أنت متأكد من حذف جهة الاتصال هذه؟',
    next: 'التالي →',
    step: 'الخطوة',
    yes: 'نعم',
    no: 'لا',
    decrease: 'تقليل',
    increase: 'زيادة',
    onboardingProgress: 'تقدم الإعداد',
    onboardingWelcomeTitle: 'مرحباً بك في كوجنسي',
    onboardingWelcomeDesc: 'أنا كوجنسي، مساعدتك متعددة الأبعاد للاجتماعات والتعاون. دعيني أساعدك في إعداد جلستك الأولى من الوكلاء.',
    onboardingStart: 'لنبدأ',
    howManyAgentsTitle: 'كم عدد الوكلاء؟',
    howManyAgentsDesc: 'اختر عدد الوكلاء الذكيين الذين تريد إضافتهم إلى هذه الجلسة.',
    howManyAgents: 'عدد الوكلاء',
    howManyAgentsHelp: 'يمكنك إضافة ما يصل إلى 10 وكيلاً خبيراً.',
    configureAgentsTitle: 'تهيئة الوكلاء',
    configureAgentsDesc: 'اختر الشخصية والنموذج لكل وكيل.',
    selectPersona: 'اختر الشخصية',
    selectModel: 'اختر النموذج',
    moderationModeTitle: 'وضع المنسق',
    moderationModeDesc: 'هل تريد أن تتوقف الجلسة بين الجولات لتطلب رأيك؟',
    presentMode: 'الحضور',
    presentModeDesc: 'تتوقف الجلسة بين الجولات وتنتظر تعليقك.',
    bypassMode: 'التجاوز',
    bypassModeDesc: 'تستمر الجلسة في جميع الجولات دون توقف.',
    inviteHumansTitle: 'دعوة متعاونين بشريين؟',
    inviteHumansDesc: 'هل تريد دعوة أشخاص من دليل كوجنسي للانضمام إلى هذه الجلسة؟',
    yesInviteHumans: 'نعم، أريد دعوة جهات اتصال.',
    noInviteHumans: 'لا، وكلاء فقط.',
    selectContactsTitle: 'اختر جهات الاتصال',
    selectContactsDesc: 'حدد جهات الاتصال التي تريد دعوتها إلى هذه الجلسة.',
    noContactsHelp: 'يمكنك دعوة جهات اتصال لاحقاً من شاشة الدردشة.',
    selectModeratorTitle: 'اختر المنسق',
    selectModeratorDesc: 'أي وكيل سيكون المنسق / المحلل لهذه الجلسة؟',
    noAgentsForModerator: 'لم يتم إضافة وكلاء. سيتم استخدام المحلل الافتراضي.',
    sessionTypeTitle: 'نوع الجلسة',
    sessionTypeDesc: 'كيف تريد تشغيل هذه الجلسة؟',
    ordinaryCollaboration: 'تعاون عادي',
    ordinaryCollaborationDesc: 'جلسة خاصة — اطرح سؤالك ويناقش الوكلاء.',
    sharedCollaboration: 'تعاون مشترك',
    sharedCollaborationDesc: 'جلسة مفتوحة — يمكن للجهات المختارة الانضمام في الوقت الفعلي.',
    launchSession: 'بدء الجلسة',
    sessionReady: 'الجلسة جاهزة',
    preparingSession: 'جاري التحضير...',
    applyingAgents: 'تطبيق الوكلاء...',
    creatingSession: 'إنشاء الجلسة...',
    applyingModerationMode: 'تطبيق وضع المنسق...',
    sendingInvitations: 'إرسال الدعوات...',
    launching: 'إطلاق الجلسة...',
    applicationDomain: 'مجال التطبيق',
    freeSession: 'جلسة حرة',
    getStarted: 'ابدأ',
    domainResearch: 'البحث العلمي',
    domainMechanics: 'الميكانيكا',
    domainBiology: 'البيولوجيا',
    domainAgriculture: 'الزراعة',
    domainMedicine: 'الطب',
    domainIT: 'علوم الحاسوب',
    domainLaw: 'القانون',
    domainEconomy: 'الاقتصاد',
    domainEducation: 'التعليم',
    domainEnergy: 'الطاقة',
    domainEnvironment: 'البيئة',
    domainConstruction: 'البناء',
    domainFinance: 'المالية / البنوك',
    domainMarketing: 'التسويق / الاتصال',
    domainHR: 'الموارد البشرية / الإدارة',
    domainCybersecurity: 'الأمن السيبراني',
    domainLogistics: 'النقل / اللوجستيات',
    domainArts: 'الفن / الثقافة',
    domainPublicHealth: 'الصحة العامة',
    domainMining: 'التعدين / الجيولوجيا',
    domainOilGas: 'النفط / الغاز',
    domainTelecom: 'الاتصالات',
    domainRobotics: 'الروبوتات / إنترنت الأشياء',
    domainPsychology: 'علم النفس',
    domainPhilosophy: 'الفلسفة / الأخلاق',
    domainLinguistics: 'اللسانيات / اللغات',
    domainSpace: 'الملاحة الجوية / الفضاء',
    domainClimate: 'المناخ / الطقس',
    tourWelcomeTitle: 'مرحبًا بك في Cogency',
    tourWelcomeText: 'Cogency هي منصة ذكاء تعاوني. بدلاً من طرح سؤال على ذكاء اصطناعي واحد، تجمع عدة وكلاء خبراء يتناقشون ويتحدون ويصقلون أفضل إجابة معًا.',
    tourDifferenceTitle: 'ما الذي يميز Cogency',
    tourDifferenceText: 'المساعدون التقليديون يعطونك إجابة واحدة. Cogency تحاكي مجموعة من الخبراء: كل وكيل يجلب وجهة نظره ونقاط قوته وحدوده، لتقديم تحليل أكثر اكتمالاً وتوازناً وموثوقية.',
    tourCollaborativeTitle: 'الذكاء التعاوني',
    tourCollaborativeText: 'Cogency لا تحل محل التفكير البشري — بل تضخمه. يتعاون الوكلاء تحت إشرافك: أنت تختار السؤال والخبراء ونمط الإدارة. النتيجة النهائية هي تركيبة متوازنة لنقاشهم.',
    tourContextTitle: 'ابقَ في السياق الصحيح',
    tourContextText: 'Cogency تتألق في الأسئلة المعقدة والتحليلية أو متعددة التخصصات. طرح أسئلة لا علاقة لها بنقاش الخبراء — مثل الطلبات التافهة أو الشخصية البحتة — لن يستفيد من قوتها. استخدمها عندما تحتاج إلى تفكير عميق.',
    tourFinish: 'ابدأ',
    remainingConnexionTime: 'الوقت المتبقي للاتصال',
    connectedTime: 'وقت الاتصال',
    trialExpiredTitle: 'انتهت فترة التجربة',
    trialExpiredText: 'انتهت فترة التجربة المجانية التي تستمر 7 أيام. قم بشراء خطة للاستمرار في استخدام Cogency.',
    trialExpiredCta: 'اطلع على الخطط',
    voice: 'الصوت',
    mute: 'كتم',
    unmute: 'تشغيل الصوت',
    strategyConfiguration: 'التكوين الاستراتيجي',
    modeAuto: 'تلقائي',
    modeCustom: 'مخصص',
    autoModeHint: 'يقوم Cogency بتشكيل المجلس الاستراتيجي تلقائياً حسب الموضوع.',
    globalStrategists: 'استراتيجيون عالميون',
    arabStrategists: 'استراتيجيون عرب',
    strategistsSelected: 'استراتيجي/استراتيجيون محددون',
    debateMode: 'نمط النقاش',
    fiveRingsHint: 'التحليل وفق نموذج الخمس حلقات لجون واردن',
    fiveRingsLabel: 'الخمس حلقات',
    fiveRingsSynthesis: 'الخلاصة حسب الخمس حلقات',
    showFiveRings: 'عرض الخمس حلقات',
    hideFiveRings: 'إخفاء الخمس حلقات',
  
    fullscreen: 'ملء الشاشة',},
  en: {
    appName: 'Cogency',
    login: 'Login',
    register: 'Subscribe',
    email: 'Email',
    password: 'Password',
    name: 'Full Name',
    access: 'Access Cogency',
    subscribersOnly: 'Subscribers Only',
    premiumPersonaMessage: 'Reserved for subscribers with at least a Premium plan',
  forgotPassword: 'Forgot Password',
  sendResetLink: 'Send reset link',
  resetLinkSent: 'A reset link has been sent to your email address.',
    cannotStartTitle: 'Configuration not ready',
    cannotStartDetail: 'All agents and the synthesizer must have an operational model to start.',
    collapseSidebar: 'Collapse menu',
    expandSidebar: 'Expand menu',
    pendingTitle: 'Subscription Pending',
    pendingDesc: 'Your account is awaiting administrator approval.',
    logout: 'Logout',
    startCollaborating: 'Start Collaborating',
    configureAgents: 'Configure Your Agents',
    apiKeys: 'Cloud API Keys',
    discussionRounds: 'Discussion Rounds',
    addAgent: 'Add Agent',
    synthesizer: 'Synthesizer',
    readyToCollaborate: 'Ready to Collaborate',
    askAnything: 'Ask anything...',
    connected: 'Connected',
    disconnected: 'Disconnected',
    collaborators: 'Collaborators',
    share: 'Share',
    invite: 'Invite',
    save: 'Save',
    reconfigure: 'Reconfigure',
    howItWorks: 'How it works',
    yourAgents: 'Your Agents',
    settings: 'Settings',
    interfaceSettings: 'Interface',
    interfaceSettingsDesc: 'Customize the application appearance and sharing options.',
    rounds: 'Rounds',
    debateMode: 'Debate mode',
    sequentialMode: 'Sequential',
    parallelMode: 'Parallel',
    sequentialModeDesc: 'Each agent waits for the previous agent to finish before starting.',
    parallelModeDesc: 'All agents think at the same time.',
    session: 'Session',
    finalAnswer: 'Final Answer',
    copy: 'Copy',
    showDebate: 'Show full debate',
    hideDebate: 'Hide full debate',
    adminPanel: 'Admin Panel',
    verifyUsers: 'Verify Subscribers',
    noPendingUsers: 'No pending subscribers',
    verify: 'Verify',
    footer: '© Synaptics Solutions and Technologies Ltd. All rights reserved.',
    poweredBy: 'Powered by Cogency',
    joinSession: 'Join Session',
    enterSessionId: 'Enter session ID or link',
    subscriberWelcome: 'Welcome! Join a session to collaborate with AI agents.',
    lockedForAdmin: 'Configuration locked — Admin only',
    reject: 'Reject',
    inviteToSession: 'Invite to Session',
    invite: 'Invite',
    invited: 'Invited',
    subscribers: 'Subscribers',
    plans: 'Plans',
    cogency: 'Cogency',
    status: 'Status',
    agents: 'Agents',
    admin: 'Admin',
    checkingProviders: 'Checking Providers',
    connecting: 'Connecting...',
    connectedTo: 'Connected',
    noProvidersAvailable: 'No providers available',
    availableModels: 'Available Models',
    loading: 'Loading...',
    startSharedSession: 'Start Shared Session',
    sharedSessionsHint: 'Shared sessions let others watch and collaborate in real-time.',
    connectionFailed: 'Connection Failed',
    noProvidersAvailableDetail: 'No AI providers are available. Make sure Ollama is running, or add API keys for cloud providers.',
    tryAgain: 'Try Again',
    agent: 'Agent',
    remove: 'Remove',
    persona: 'Persona',
    model: 'Model',
    powerUser: 'Power User',
    locked: 'Locked',
    unlockPowerUser: 'Unlock Power User',
    enterUnlockCode: 'Enter unlock code',
    unlock: 'Unlock',
    incorrectUnlockCode: 'Incorrect unlock code.',
    addKeysDesc: 'Add keys to use Kimi, Hugging Face, or TchadGPT models. Ollama works without keys.',
    powerUserFeature: 'Power user feature. Unlock to configure cloud providers.',
    combinesAllAgentArguments: 'Combines all agent arguments into one clear, balanced answer.',
    eachRoundEveryAgentSpeaks: 'Each round, every agent speaks once. More rounds = deeper debate.',
    backToHome: 'Back to Home',
    help: 'Help',
    collaborate: 'Collaborate',
    exportPDF: 'Export PDF',
    exportDOCX: 'Export DOCX',
    exportPPTX: 'Export PPTX',
    exportLaTeX: 'Export LaTeX',
    export: 'Export',
    processing: 'Processing...',
    welcome: 'Welcome',
    startAsking: 'Type a question below or use the microphone to speak, and watch AI agents debate the answer.',
    initialAnalysis: 'Initial Analysis',
    debateRound1: 'Debate Round 1',
    debateRound2: 'Debate Round 2',
    send: 'Send',
    listeningSpeakNow: 'Listening... Speak now',
    stop: 'Stop',
    processingYourVoice: 'Processing your voice...',
    cancel: 'Cancel',
    enterYourIntervention: 'Enter your intervention...',
    pass: 'Pass',
    noIntervention: 'No intervention',
    pressEnterToSend: 'Press Enter to send',
    useSendButton: 'Use the send button to send',
    clickToSpeak: 'Click 🎤 to speak',
    voiceOutputOn: 'Voice output ON',
    textVoiceOutput: 'Text + Voice output',
    textOutputOnly: 'Text output only',
    readAloud: 'Read aloud',
    mindMap: 'Mind Map',
    generateImage: 'Generate image / diagram',
    describeImageToGenerate: 'Describe the image to generate…',
    detailedImageOptions: 'Detailed options',
    generatedImage: 'Generated image',
    actions: 'Actions',
    regenerateImage: 'Regenerate image',
    exportImagePPTX: 'Export as PPTX',
    exportImagePDF: 'Export as PDF',
    deleteImage: 'Delete image',
    imageGenIntro: 'Before generating the image, please clarify your needs to get a useful and accurate result.',
    failedToGenerateImage: 'Image generation failed',
    generating: 'Generating…',
    generate: 'Generate',
    analyzingContent: 'Analyzing content...',
    generatingMindMapStructure: 'Generating mind map structure...',
    organizingBranches: 'Organizing branches...',
    finalizing: 'Finalizing...',
    complete: 'Complete!',
    failedToGenerateMindMap: 'Failed to generate mind map',
    errorGeneratingMindMap: 'Error generating mind map',
    failedToExportPDF: 'Failed to export PDF',
    pdfExportError: 'PDF export library not loaded. Please refresh the page.',
    pdfExportFailed: 'Failed to export PDF. Please try again.',
    error: 'Error',
    you: 'You',
    humanIntervention: 'Human Intervention',
    moderator: 'Moderator',
    voiceSettings: 'Voice Settings',
    onlyAdministratorsCanChangeVoiceSettings: 'Only administrators can change voice settings.',
    voiceInput: 'Voice Input',
    serverSTT: 'Server STT',
    browserSTT: 'Browser STT',
    voiceOutput: 'Voice Output',
    serverTTS: 'Server TTS',
    browserTTS: 'Browser TTS',
    voiceOutputSettingsAdmin: 'Voice Output Settings (Admin)',
    stt: 'STT',
    serverWhisper: 'Server (Whisper)',
    browserWebSpeech: 'Browser (Web Speech)',
    tts: 'TTS',
    serverEspeak: 'Server (eSpeak)',
    browserSpeechSynthesis: 'Browser (SpeechSynthesis)',
    outputMode: 'Output Mode',
    textOnly: 'Text Only',
    textOnlyDesc: 'Responses appear as text only',
    voiceOnly: 'Voice Only',
    voiceOnlyDesc: 'Responses are spoken aloud',
    textAndVoice: 'Text + Voice',
    textAndVoiceDesc: 'Both text and voice output',
    voiceType: 'Voice Type',
    human: 'Human',
    artificial: 'Artificial',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    age: 'Age',
    young: 'Young',
    old: 'Old',
    language: 'Language',
    voiceEnabled: 'Voice Enabled',
    outputVoice: 'Output Voice',
    voiceCommand: 'Voice Command',
    voiceSelection: 'Voice Selection',
    voiceSelectionDesc: 'Choose the voice to use for reading answers.',
    availableVoices: 'Available Voices',
    availableVoicesDesc: 'Select a voice from those available in your browser.',
    noVoicesAvailable: 'No voices available',
    voiceRate: 'Speed',
    voiceRateDesc: 'Speech speed',
    voicePitch: 'Pitch',
    voicePitchDesc: 'Voice pitch',
    testVoice: 'Test Voice',
    selectedVoice: 'Selected voice',
    voiceTestText: 'Cogency is ready to assist you.',
    underDevelopment: 'Under Development',
    selectYourSkill: 'Select your Skill',
    selectYourSkillDesc: 'Choose your experience level to customize your interface.',
    skillBeginner: 'Beginner',
    skillProfessional: 'Professional',
    skillExpert: 'Expert',
    skillBeginnerDesc: 'Simplified interface with step-by-step guidance.',
    skillProfessionalDesc: 'Full interface with all options available.',
    skillExpertDesc: 'Advanced mode with fine-grained controls.',
    skillComingSoon: 'Interface coming soon',
    skillComingSoonDesc: 'The {skill} interface is under development.',
    xaiVoice: 'Grok Voice (xAI)',
    xaiVoiceDesc: 'Text-to-speech and speech-to-text via xAI Grok Voice.',
    xaiUnavailableHint: 'Check XAI_VOICE_API_KEY in server configuration.',
    xaiTts: 'Text-to-Speech',
    xaiStt: 'Speech-to-Text',
    xaiVoiceSelect: 'Voice',
    xaiVoiceSelectDesc: 'Choose synthesis voice',
    xaiTtsTest: 'Test TTS',
    xaiSttTest: 'Test STT',
    xaiTtsTestText: 'Hello, this is a test of the Grok voice.',
    xaiTtsFailed: 'Grok TTS failed',
    xaiSttFailed: 'Grok STT failed',
    startRecording: 'Start recording',
    stopRecording: 'Stop',
    fullscreen: 'Fullscreen',
    connectedAs: 'Connected as',
    changeLogo: 'Change logo',
    customizeLogo: 'Customize logo',
    logoUploaderHint: 'Choose an image for this disk (your photo, a logo, etc.). It will only apply to this bar.',
    exitFullscreen: 'Exit fullscreen',
    closeSession: 'Close session',
    connectedAt: `Connected since`,
    ipAddress: `IP address`,
    noConnectedAddresses: `No connected IP addresses.`,
    costsByAgent: 'Costs by Agent / Model',
    sessionCosts: 'Session Costs',
    estimatedSessions: 'Estimated Sessions',
    averageCostPerSession: 'Average Cost per Session',
    averageTokensInPerSession: 'Average Input Tokens per Session',
    averageTokensOutPerSession: 'Average Output Tokens per Session',
    voiceServices: 'Voice Services',
    documentGeneration: 'Document Generation',
    diagramGeneration: 'Diagram Generation',
    sortBy: 'Sort by',
    sortRecent: 'Recent',
    sortOldest: 'Oldest',
    sortLongest: 'Longest',
    sortWithImages: 'With images',
    sortWithFiles: 'With files',
    sortCompleted: 'Completed',
    sortActive: 'Active',
    sessionCost: 'Session cost',
    connectedAddresses: `Connected addresses`,
    tracking: `Tracking`,
    connectionLog: `Connection Log`,
    connectionLogDesc: `Connection history with IP address, operating system and device type.`,
    deviceType: `Device`,
    uniqueIps: `Unique IPs`,
    entries: `entries`,
    noConnectionLog: `No connections recorded.`,
    searchConnectionLog: `Search IP, OS, device, browser...`,
    sortRecent: `Most recent`,
    sortOldest: `Oldest`,
    sortByCountry: `Country`,
    sortByDevice: `Device type`,
    sortByOs: `Operating system`,
    sortByBrowser: `Browser`,
    sortByUser: `User`,
    sortByAction: `Connection status`,
    scrollToBottom: `Scroll to bottom`,
    refresh: `Refresh`,
    connect: `Connect`,
    disconnect: `Disconnect`,
    date: `Date`,
    action: `Action`,
    sharedSessionHint: `Shared sessions let others watch and collaborate in real-time.`,
    startSharedSession: `Start Shared Session`,
    startCollaborating: `Start Collaborating`,
    brandTagline: 'Success is continuing where others stopped',
    statusThinking: '{label}: All agents thinking in parallel...',
    helpStep1Title: `1. The Host asks the question`,
    helpStep1Text: `The user — the Host — submits the question or issue to be discussed.`,
    helpStep2Title: `2. First AI agent answers`,
    helpStep2Text: `The first AI agent gives its direct answer to the question.`,
    helpStep3Title: `3. Second agent answers and critiques`,
    helpStep3Text: `The second AI agent gives its own answer, then critiques or complements the first agent's answer, and ends with a conclusion.`,
    helpStep4Title: `4. Each following agent does the same`,
    helpStep4Text: `Every subsequent agent does the same with respect to all AI and human responses that preceded it.`,
    helpStep5Title: `5. Guest participation and end of round`,
    helpStep5Text: `The round ends with an invitation for other participants — local or remote — and the Host to comment or add information. Anyone can click Pass to let the debate continue.`,
    helpStep6Title: `6. Rounds continue`,
    helpStep6Text: `Rounds repeat in the same way until the final round.`,
    helpStep7Title: `7. Moderator publishes the final answer`,
    helpStep7Text: `The Moderator — AI or human — publishes the final answer, a synthesis of all contributions analyzed in light of available data.`,
    helpStep8Title: `8. Mind map of the debate`,
    helpStep8Text: `An automatic mind map illustrates the structure and flow of the debate.`,
    helpStep9Title: `9. Export the content`,
    helpStep9Text: `The Host can export the full debate history as PDF, PPTX, DOCX and LaTeX, and each individual answer can also be exported separately.`,
    moderationPrompt: 'Round {round} complete. Do any participants wish to intervene before Round {nextRound}?',
    on: 'On',
    off: 'Off',
    saving: 'Saving...',
    saveSettings: '💾 Save Settings',
    settingsSavedSuccessfully: '✅ Settings saved successfully',
    failedToSaveSettings: '❌ Failed to save settings',
    howItWorksTitle: 'How It Works',
    youAskAQuestion: 'You Ask a Question',
    typeAnything: 'Type anything — from simple questions to complex debates.',
    multipleAgentsAnalyze: 'Multiple Agents Analyze',
    eachAgentBringsPerspective: 'Each agent brings their unique perspective and model.',
    theyDebateInRounds: 'They Debate in Rounds',
    everyRoundEachAgentResponds: 'Every round, each agent responds to the full conversation so far.',
    youGetTheBestAnswer: 'You Get the Best Answer',
    synthesizerCombinesBestPoints: 'The Synthesizer combines their best points into one clear answer.',
    helpIntro: `Unlike individual AI or consensus AI, Cogency does not just give you a direct answer. You ask your question or topic, then several AI agents debate together. Where classic AIs search for the answer alone, Cogency gives you a voice: at every round, you can give your opinion, add a complement, critique a response, or click Pass to let the debate continue. You actively participate in crafting the answer and influence the agents\' analysis while they work.`,
    helpCoreTitle: 'How it flows',
    helpFeaturesTitle: 'Key features',
    helpMultiAgentTitle: 'Specialized agents',
    helpMultiAgentText: `Each agent has its own persona, model and expertise to enrich the debate.`,
    helpDebateRoundsTitle: 'Debate rounds',
    helpDebateRoundsText: `Agents exchange multiple responses, refine their arguments and react to each other\'s ideas.`,
    helpSynthesisTitle: 'Final answer',
    helpSynthesisText: `A synthesizer agent gathers the best arguments into a structured, actionable conclusion.`,
    helpInterventionTitle: 'Human intervention',
    helpInterventionText: `You can step in at any time to steer, correct or deepen the discussion.`,
    helpMoreTitle: 'Also',
    helpVoiceTitle: 'Voice control',
    helpVoiceText: `Speak to ask your questions and let the app read answers aloud.`,
    helpAgentsPersonasTitle: 'Customization',
    helpAgentsPersonasText: `Choose predefined agents or create your own personas and models.`,
    helpExportTitle: 'Export',
    helpExportText: `Download the conversation or synthesis as PDF, DOCX, PPTX or LaTeX.`,
    helpHistoryTitle: 'History',
    helpHistoryText: `Find, resume and review your previous sessions at any time.`,
    helpCollaborationTitle: 'Shared sessions',
    helpCollaborationText: `Start a public session and invite other users to follow the debate live.`,
    helpAccessibilityTitle: 'Accessibility',
    helpAccessibilityText: `Adjust contrast, text size, animations and sounds to fit your needs.`,
    helpCommandsTitle: 'Quick commands',
    helpCommandImage: `agents can automatically include a generated image when it helps illustrate their response.`,
    helpCommandMindMap: 'generates an automatic mind map from the topic.',
    helpCommandIntervene: 'inserts your own message into the debate.',
    helpCommandVoice: 'enables or disables voice recognition.',
    helpCommandExport: 'immediately exports the latest answer in the chosen format.',
    helpPlansTitle: 'Plans and trial',
    helpPlansText: `Start with a free trial, then pick the plan that fits your usage. Administrators can manage subscriptions from the admin panel.`,
    helpDebateMechanismTitle: `How the debate works`,
    helpDebateMechanismText: `In the first round, the first agent gives its direct answer to the question. From the second agent onward, each agent presents its own version and also critiques the response of the one before it. In turn, all agents (and humans too) express their views and critique previous contributions, enriching the debate and guiding the analysis toward a better answer.`,
    helpAddedValueTitle: `Added value`,
    helpAddedValueText: `The responses and orientations provided by Cogency are distinguished by their standardized nature, because they rely on an analysis that combines two essential contextual dimensions. The first is local: it takes into account the situation and specific needs of the user asking the question. The second is global: it integrates the latest developments, updates and trends observed worldwide. The final response is therefore not merely raw information: it is a structured conclusion resulting from an in-depth, multi-faceted analysis.`,
    helpPrivacyTitle: 'Privacy',
    helpPrivacyText: `Your conversations are tied to your account. Cogency can run with local models (Ollama) to keep data on the machine.`,
    helpTipTitle: '💡 Tip',
    helpTipText: `Be precise in your questions and increase the number of rounds for deeper analysis.`,
    inviteCollaborators: 'Invite Collaborators',
    shareSessionLink: '🔗 Share Session Link',
    anyoneWithThisLink: 'Anyone with this link can join and watch the debate in real-time.',
    createSessionAndCopyLink: '💾 Create Session & Copy Link',
    inviteAIAgent: '🤖 Invite AI Agent',
    addAnotherAIAgent: 'Add another AI agent to the roster for the next debate.',
    addAgent: 'Add Agent',
    currentParticipants: '👥 Current Participants',
    noParticipantsYet: 'No participants yet',
    back: '← Back',
    sessionHistory: '📜 Session History',
    history: 'History',
    sessions: 'sessions',
    loadingSessions: 'Loading sessions…',
    noSavedSessionsYet: 'No saved sessions yet.',
    completedDebatesWillAppear: 'Completed debates will appear here automatically.',
    selectSessionToViewDetails: 'Select a session to view details',
    loadingSession: 'Loading session…',
    untitledSession: 'Untitled session',
    purgeEmptySessions: '🧹 Purge empty sessions',
    confirmPurgeEmptySessions: 'Delete all sessions with no messages? This action cannot be undone.',
    purgedEmptySessions: 'Empty sessions purged',
    purgeFailed: 'Failed to purge sessions',
    translateToFrench: 'Translate to French',
    translateToArabic: 'Translate to Arabic',
    translationFailed: 'Translation failed',
    round: 'Round',
    debateHistory: '🗣️ Debate History',
    sendSessionByEmail: '📧 Send Session by Email',
    recipientEmail: 'recipient@example.com',
    sending: 'Sending…',
    deleteSessionConfirm: 'Are you sure you want to permanently delete this session?',
    failedToLoadSessions: 'Failed to load sessions',
    failedToLoadSessionDetail: 'Failed to load session detail',
    exportFailed: 'Export failed',
    generatingDocument: `Generating document…`,
    deleteFailed: 'Delete failed',
    failedToExportDOCX: 'Failed to export DOCX',
    failedToExportPPTX: 'Failed to export PPTX',
    pythonExecutionFailed: 'Python execution failed',
    failedToSendEmail: 'Failed to send email',
    pleaseEnterValidEmail: 'Please enter a valid email address',
    emailSentSuccessfully: 'Email sent successfully!',
    teamChat: '💬 Team Chat',
    typeAMessage: 'Type a message...',
    mindMapTitle: '🧠 Mind Map',
    zoomIn: 'Zoom In',
    zoomOut: 'Zoom Out',
    reset: 'Reset',
    scrollToZoom: '🖱 Scroll to zoom',
    dragToPan: 'Drag to pan',
    clickBranchesToExpandCollapse: 'Click branches to expand/collapse',
    copySource: '📋 Copy Source',
    sourceTextCopied: 'Source text copied to clipboard!',
    authenticating: 'Authenticating...',
    loginFailed: 'Login failed',
    networkErrorPleaseTryAgain: 'Network error. Please try again.',
    registrationSuccessful: 'Registration successful!',
    pleaseWaitForAdminApproval: 'Please wait for admin approval.',
    registering: 'Registering...',
    registrationFailed: 'Registration failed',
    fullName: 'Full Name',
    username: 'Username',
    phone: 'Phone Number',
    gender: 'Gender',
    female: 'Female',
    male: 'Male',
    age: 'Age',
    profession: 'Profession',
    confirmPassword: 'Confirm Password',
    charterAgreement: 'Charter Agreement',
    iHaveReadCharter: 'I have read the Cogency Charter',
    readCharter: 'Read Charter',
    iAcceptCharter: 'I accept the Charter and commit to respecting it',
    iCommitNobleUse: 'I commit to using Cogency for noble purposes only and not for any harmful purposes',
    fullNameRequired: 'Full name is required',
    usernameRequired: 'Username is required',
    usernameTooShort: 'Username must be at least 3 characters',
    validEmailRequired: 'Valid email is required',
    phoneRequired: 'Phone number is required',
    genderRequired: 'Gender is required',
    validAgeRequired: 'Age must be between 13 and 120',
    professionRequired: 'Profession is required',
    passwordMin6Chars: 'Password must be at least 6 characters',
    passwordsDoNotMatch: 'Passwords do not match',
    mustReadCharter: 'You must read the Charter',
    mustAcceptCharter: 'You must accept the Charter',
    mustCommitNobleUse: 'You must commit to noble use',
    privacyTitle: 'Your Privacy Matters',
    privacyText: 'We respect your privacy. We are committed to not sharing your data with third parties. Your information is used solely to improve your user experience.',
    privacyNoShare: 'No data sharing with third parties',
    privacyExperience: 'Data used only to improve user experience',
    privacySecure: 'Secure and encrypted storage',
    understoodContinue: 'Understood, Continue',
    fullNamePlaceholder: 'John Doe',
    usernamePlaceholder: 'john_doe',
    phonePlaceholder: '+1 234 567 8900',
    agePlaceholder: '25',
    professionPlaceholder: 'Engineer, Doctor, Student...',
    passwordPlaceholder: '••••••',
    confirmPasswordPlaceholder: '••••••',
    noActiveSession: 'No active session',
    pendingApproval: 'Pending Approval',
    allUsers: 'All Users',
    noUsersFound: 'No users found.',
    deleteUser: 'Delete User',
    suspendUser: 'Suspend User',
    activateUser: 'Activate User',
    ejectUser: 'Eject User',
    notifyUsers: 'Notify Users',
    sendNotification: 'Send Notification',
    notificationTitle: 'Notification Title',
    notificationMessage: 'Notification Message',
    selectUsers: 'Select Users',
    all: 'All',
    modelGrowth: 'Model Growth',
    localModelStats: 'Local Model Stats',
    services: 'Services',
    externalServices: 'External Services',
    enableElevenLabs: 'Enable ElevenLabs',
    elevenLabsCaption: 'Use the ElevenLabs API for high-quality text-to-speech voices.',
    elevenLabsEnabled: 'ElevenLabs is enabled.',
    elevenLabsDisabled: 'ElevenLabs is disabled. Browser native TTS is used instead.',
    totalLocalCalls: 'Total Local Calls',
    totalTokens: 'Total Tokens',
    sessionsWithLocal: 'Sessions with Local',
    learningScore: 'Learning Score',
    modelUsage: 'Model Usage',
    dailyGrowth: 'Daily Growth',
    noData: 'No data',
    userManagement: 'User Management',
    actions: 'Actions',
    suspended: 'Suspended',
    active: 'Active',
    deleted: 'Deleted',
    ejected: 'Ejected',
    confirmDeleteUser: 'Are you sure you want to delete this user?',
    confirmSuspendUser: 'Are you sure you want to suspend this user?',
    confirmEjectUser: 'Are you sure you want to eject this user from all sessions?',
    resetPassword: 'Reset Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    passwordTooShort: 'Password must be at least 6 characters',
    passwordsDoNotMatch: 'Passwords do not match',
    passwordResetSuccess: 'Password reset successfully',
    passwordResetFailed: 'Failed to reset password',
    newSession: 'New Session',
    modeBypass: 'Bypass Mode — Moderator never asks for your input',
    modePresent: 'Present Mode — Moderator waits for your comment',
    bypass: 'Bypass',
    present: 'Present',
    notificationSent: 'Notification sent',
    usersOnline: 'Users Online',
    accessibility: 'Accessibility',
    accessibilityDesc: 'Customize Cogency for your needs.',
    largeText: 'Large Text',
    largeTextDesc: 'Increase text size by 15%',
    highContrast: 'High Contrast',
    highContrastDesc: 'Strong colors for better visibility',
    reducedMotion: 'Reduced Motion',
    reducedMotionDesc: 'Minimize animations',
    keyboardShortcuts: 'Keyboard Shortcuts',
    focusInput: 'Focus input field',
    sendMessage: 'Send message',
    stopOrCancel: 'Stop voice or cancel',
    enableVoice: 'Enable Voice Commands',
    disableVoice: 'Disable Voice Commands',
    holdToSpeak: 'Hold to speak',
    listening: 'Listening…',
    heard: 'Heard',
    voiceHint: 'Hold Space or click mic to speak',
    voiceHintMobile: 'Tap mic to speak',
    voiceLogin: 'Opening login',
    voiceRegister: 'Opening registration',
    voiceLogout: 'Logging out',
    voiceGoToChat: 'Opening chat',
    voiceGoToSetup: 'Opening settings',
    voiceGoToHistory: 'Opening history',
    voiceHelpText: 'You can say: go to chat, go to settings, add agent, ask followed by your question, type field name followed by value, submit, logout.',
    voiceEnabled: 'Voice commands enabled',
    voiceDisabled: 'Voice commands disabled',
    voiceTyped: 'Typed',
    voiceSubmitted: 'Submitted',
    voiceAsking: 'Asking',
    voiceReadingLast: 'Reading last message',
    voiceReadingAll: 'Reading all messages',
    voiceStopped: 'Stopped',
    voiceAgentAdded: 'Agent added',
    voiceAgentRemoved: 'Removed agent',
    voiceDidNotUnderstand: 'I did not understand. Say help for available commands.',
    voiceNotSupported: 'Voice recognition not supported in this browser.',
    policyWarning: 'POLICY WARNING: This request violates the Cogency Charter (content that threatens public order, national security, or institutional integrity is strictly prohibited). This attempt has been logged. Further attempts will trigger enforcement.',
    policyEnforcement: 'ENFORCEMENT: Your account has been suspended for violating the Cogency Internal Policy and Charter. Content that threatens public order, national security, or institutional integrity is strictly prohibited. Contact the administrator.',
    viewCharter: 'View Charter',
    policyNotice: 'Policy Notice',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    edited: 'edited',
    cancelDebate: 'Cancel Debate',
    resume: 'Resume',
    liveSessions: 'Live Sessions',
    persist: 'Persist',
    dumpAll: 'Dump All',
    inMemory: 'In Memory',
    orphanedSessions: 'Orphaned',
    charterTitle: 'Usage Charter & Internal Policy',
    charterVersion: 'Version 1.0',
    charterEffective: 'Effective as of the date of publication.',
    charterArt1Title: 'Purpose and Scope',
    charterArt1Text: 'Cogency is a strategic decision-support platform designed for governmental and institutional analysis. It facilitates rigorous, multidisciplinary, and ethically-grounded exploration of complex policy questions. This charter applies to all authorized users, administrators, and partners accessing the platform.',
    charterArt2Title: 'Strictly Scientific and Technical Purpose',
    charterArt2Intro: 'Although Cogency is a multidisciplinary decision-support tool, its purpose remains strictly scientific and technical. The platform must never be used to:',
    charterArt2Item1: 'fuel, justify, or defend conflicts of any kind;',
    charterArt2Item2: 'promote political, religious, or sectarian ideologies;',
    charterArt2Item3: 'incite hatred, discrimination, or violence;',
    charterArt2Item4: 'produce propaganda, disinformation, or opinion-manipulation content.',
    charterArt3Title: 'Strict Prohibition of Political and Religious Conflict Content',
    charterArt3Intro: 'Any question, research, debate, or intervention concerning political or religious subjects, especially when relating to conflicts, extremist movements, wars, persecutions, or intercommunal hatred, is strictly prohibited.',
    charterArt3Item1: 'Terms and concepts related to armed conflicts, terrorism, genocide, ethnic cleansing, coups, totalitarian regimes;',
    charterArt3Item2: 'Terms and concepts related to jihad, crusades, inquisitions, fatwas, forced apostasy, blasphemy, religious radicalization, holy wars.',
    charterArt4Title: 'Monitoring and Enforcement Procedure',
    charterArt4_1Title: 'Logging',
    charterArt4_1Text: 'Any attempt to submit content violating this charter is automatically logged with timestamp, user ID, and nature of the attempt.',
    charterArt4_2Title: 'Progressive Warning',
    charterArt4_2Item1: 'First and second attempt — the user receives an explicit warning reminding them of the charter and noting that the attempt has been logged.',
    charterArt4_2Item2: 'Third attempt — a disciplinary procedure is automatically initiated for non-compliance with the Cogency charter and internal policy. This may lead to temporary or permanent suspension.',
    charterArt4_3Title: 'Appeal',
    charterArt4_3Text: 'Users may contact the administrator if they disagree with an automatic decision, provided they submit evidence justifying the strictly scientific or technical nature of their request.',
    charterArt5Title: 'User Responsibilities',
    charterArt5Item1: 'Strictly comply with this charter;',
    charterArt5Item2: 'Use Cogency only in a professional, academic, or research context;',
    charterArt5Item3: 'Report any suspicious behavior or content to the administrator.',
    charterArt6Title: 'Charter Amendment',
    charterArt6Text: 'Cogency reserves the right to amend this charter at any time. Users will be informed of any substantial update via the platform.',
    themes: 'Themes',
    themesIntro: 'Choose a look that suits you. Themes with images can add a visual background to the app.',
    chatTransparency: 'Chat Transparency',
    chatTransparencyHint: 'Make the chat card transparent to see the background image',
    attachDocument: 'Attach Document',
    close: 'Close',
    noContactsToInvite: 'No contacts to invite',
    selectUser: 'Select a user',
    manageContacts: 'Manage Contacts',
    contactManager: 'Contact Manager',
    friend: 'Friend',
    colleague: 'Colleague',
    superior: 'Superior',
    add: 'Add',
    loading: 'Loading',
    noContactsYet: 'No contacts yet',
    confirmDeleteContact: 'Are you sure you want to delete this contact?',
    next: 'Next →',
    step: 'Step',
    yes: 'Yes',
    no: 'No',
    decrease: 'Decrease',
    increase: 'Increase',
    onboardingProgress: 'Setup progress',
    onboardingWelcomeTitle: 'Welcome to Cogency',
    onboardingWelcomeDesc: 'I am Cogency, your multi-dimensional meeting and collaboration assistant. Let me help you set up your first agent session.',
    onboardingStart: "Let's start",
    howManyAgentsTitle: 'How many agents?',
    howManyAgentsDesc: 'Choose how many AI agents you want to add to this session.',
    howManyAgents: 'Number of agents',
    howManyAgentsHelp: 'You can add up to 10 expert agents.',
    configureAgentsTitle: 'Configure agents',
    configureAgentsDesc: 'Pick a persona and a model for each agent.',
    selectPersona: 'Select a persona',
    selectModel: 'Select a model',
    moderationModeTitle: 'Moderator mode',
    moderationModeDesc: 'Should the session pause between rounds to ask for your input?',
    presentMode: 'Present',
    presentModeDesc: 'The session pauses between rounds and waits for your comment.',
    bypassMode: 'Bypass',
    bypassModeDesc: 'The session runs through all rounds without stopping.',
    inviteHumansTitle: 'Invite human collaborators?',
    inviteHumansDesc: 'Would you like to invite people from your Cogency directory to join this session?',
    yesInviteHumans: 'Yes, invite contacts.',
    noInviteHumans: 'No, agents only.',
    selectContactsTitle: 'Select contacts',
    selectContactsDesc: 'Choose the contacts you want to invite to this session.',
    noContactsHelp: 'You can invite contacts later from the chat screen.',
    selectModeratorTitle: 'Choose the moderator',
    selectModeratorDesc: 'Which agent will be the moderator / analyst for this session?',
    noAgentsForModerator: 'No agents were added. A default analyst will be used.',
    sessionTypeTitle: 'Session type',
    sessionTypeDesc: 'How would you like to run this session?',
    ordinaryCollaboration: 'Ordinary collaboration',
    ordinaryCollaborationDesc: 'Private session — ask a question and the agents debate.',
    sharedCollaboration: 'Shared collaboration',
    sharedCollaborationDesc: 'Open session — selected contacts can join in real time.',
    launchSession: 'Start session',
    sessionReady: 'Session ready',
    preparingSession: 'Preparing...',
    applyingAgents: 'Applying agents...',
    creatingSession: 'Creating session...',
    applyingModerationMode: 'Applying moderator mode...',
    sendingInvitations: 'Sending invitations...',
    launching: 'Launching session...',
    applicationDomain: 'Application Domain',
    freeSession: 'Free Session',
    getStarted: 'Get Started',
    domainResearch: 'Scientific Research',
    domainMechanics: 'Mechanics',
    domainBiology: 'Biology',
    domainAgriculture: 'Agriculture',
    domainMedicine: 'Medicine',
    domainIT: 'Computer Science',
    domainLaw: 'Law',
    domainEconomy: 'Economy',
    domainEducation: 'Education',
    domainEnergy: 'Energy',
    domainEnvironment: 'Environment',
    domainConstruction: 'Construction',
    domainFinance: 'Finance / Banking',
    domainMarketing: 'Marketing / Comms',
    domainHR: 'HR / Management',
    domainCybersecurity: 'Cybersecurity',
    domainLogistics: 'Transport / Logistics',
    domainArts: 'Art / Culture',
    domainPublicHealth: 'Public Health',
    domainMining: 'Mining / Geology',
    domainOilGas: 'Oil / Gas',
    domainTelecom: 'Telecommunications',
    domainRobotics: 'Robotics / IoT',
    domainPsychology: 'Psychology',
    domainPhilosophy: 'Philosophy / Ethics',
    domainLinguistics: 'Linguistics / Languages',
    domainSpace: 'Aeronautics / Space',
    domainClimate: 'Climate / Weather',
    tourWelcomeTitle: 'Welcome to Cogency',
    tourWelcomeText: 'Cogency is a collaborative intelligence platform. Instead of asking a single AI, you bring together several expert agents who debate, challenge, and refine the best answer together.',
    tourDifferenceTitle: 'What makes Cogency different',
    tourDifferenceText: 'Classic assistants give you a single answer. Cogency simulates a panel of experts: each agent brings its own perspective, strengths, and limits, to deliver a more complete, nuanced, and reliable analysis.',
    tourCollaborativeTitle: 'Collaborative intelligence',
    tourCollaborativeText: 'Cogency does not replace human thinking — it amplifies it. The agents collaborate under your supervision: you choose the question, the experts, and the moderation mode. The final result is a balanced synthesis of their discussion.',
    tourContextTitle: 'Stay in the right context',
    tourContextText: 'Cogency shines on complex, analytical, or multidisciplinary questions. Asking questions unrelated to an expert debate — such as trivial or purely personal requests — will not leverage its strength. Use it when you need in-depth thinking.',
    tourFinish: 'Start',
    remainingConnexionTime: 'Remaining Connexion Time',
    connectedTime: 'Connection time',
    trialExpiredTitle: 'Trial period ended',
    trialExpiredText: 'Your 7-day trial has ended. Purchase a plan to continue using Cogency.',
    trialExpiredCta: 'See plans',
    voice: 'Voice',
    mute: 'Mute',
    unmute: 'Unmute',
    strategyConfiguration: 'Strategic configuration',
    modeAuto: 'Auto',
    modeCustom: 'Custom',
    autoModeHint: 'Cogency automatically composes the strategic council based on the topic.',
    globalStrategists: 'Global strategists',
    arabStrategists: 'Arab strategists',
    strategistsSelected: 'strategist(s) selected',
    debateMode: 'Debate mode',
    fiveRingsHint: 'Analyze through John Warden\'s Five Rings framework',
    fiveRingsLabel: 'Five Rings',
    fiveRingsSynthesis: 'Synthesis by the Five Rings',
    showFiveRings: 'View the Five Rings',
    hideFiveRings: 'Hide the Five Rings',
  
    fullscreen: 'Fullscreen',},
  fr: {
    appName: 'Cogency',
    login: 'Connexion',
    register: "S'abonner",
    email: 'E-mail',
    password: 'Mot de passe',
    name: 'Nom complet',
    access: 'Accéder à Cogency',
    subscribersOnly: 'Réservé aux abonnés',
    premiumPersonaMessage: 'Réservé aux abonnés avec au minimum un plan Premium',
    cannotStartTitle: 'Veuillez terminer la configuration des Agents IA',
    cannotStartDetail: 'Au moins un Agent IA sélectionné n\'est pas disponible.',
    collapseSidebar: 'Réduire le menu',
    expandSidebar: 'Déplier le menu',
    pendingTitle: 'Abonnement en attente',
    pendingDesc: 'Votre compte attend la validation de l\'administrateur.',
    logout: 'Déconnexion',
    startCollaborating: 'Commencer à collaborer',
    configureAgents: 'Configurer vos agents',
    apiKeys: 'Clés API Cloud',
    discussionRounds: 'Tours de discussion',
    addAgent: 'Ajouter un agent',
    synthesizer: 'Synthétiseur',
    readyToCollaborate: 'Prêt à collaborer',
    askAnything: 'Posez une question...',
    connected: 'Connecté',
    disconnected: 'Déconnecté',
    collaborators: 'Collaborateurs',
    share: 'Partager',
    invite: 'Inviter',
    save: 'Sauvegarder',
    reconfigure: 'Reconfigurer',
    howItWorks: 'Comment ça marche',
    yourAgents: 'Vos agents',
    settings: 'Paramètres',
    interfaceSettings: 'Interface',
    interfaceSettingsDesc: 'Personnalisez l\'apparence de l\'application et les options de partage.',
    rounds: 'Tours',
    debateMode: 'Mode de débat',
    sequentialMode: 'Séquenciel',
    parallelMode: 'Parallèle',
    sequentialModeDesc: 'Chaque agent attend la réponse de l\'agent précédent avant de commencer.',
    parallelModeDesc: 'Tous les agents réfléchissent simultanément.',
    session: 'Session',
    finalAnswer: 'Réponse finale',
    copy: 'Copier',
    showDebate: 'Voir le débat complet',
    hideDebate: 'Masquer le débat',
    adminPanel: 'Panneau Admin',
    verifyUsers: 'Vérifier les abonnés',
    noPendingUsers: 'Aucun abonné en attente',
    verify: 'Vérifier',
    footer: '© Synaptics Solutions and Technologies Ltd. Tous droits réservés.',
    poweredBy: 'Propulsé par Cogency',
    joinSession: 'Rejoindre une session',
    enterSessionId: 'ID ou lien de session',
    subscriberWelcome: 'Bienvenue ! Rejoignez une session pour collaborer.',
    lockedForAdmin: 'Configuration verrouillée — Admin uniquement',
    reject: 'Rejeter',
    inviteToSession: 'Inviter à la session',
    invited: 'Invité',
    subscribers: 'Abonnés',
    plans: 'Plans',
    cogency: 'Cogency',
    status: 'Statut',
    agents: 'Agents',
    admin: 'Admin',
    checkingProviders: 'Vérification des fournisseurs',
    connecting: 'Connexion...',
    connectedTo: 'Connecté',
    noProvidersAvailable: 'Aucun fournisseur disponible',
    availableModels: 'Modèles disponibles',
    loading: 'Chargement...',
    startSharedSession: 'Démarrer une session partagée',
    sharedSessionsHint: 'Les sessions partagées permettent aux autres de regarder et collaborer en temps réel.',
    connectionFailed: 'Connexion échouée',
    noProvidersAvailableDetail: 'Aucun fournisseur IA n\'est disponible. Assurez-vous qu\'Ollama est en cours d\'exécution, ou ajoutez des clés API pour les fournisseurs cloud.',
    tryAgain: 'Réessayer',
    agent: 'Agent',
    remove: 'Retirer',
    persona: 'Persona',
    model: 'Modèle',
    powerUser: 'Utilisateur avancé',
    locked: 'Verrouillé',
    unlockPowerUser: 'Déverrouiller Utilisateur avancé',
    enterUnlockCode: 'Entrez le code de déverrouillage',
    unlock: 'Déverrouiller',
    incorrectUnlockCode: 'Code de déverrouillage incorrect.',
    addKeysDesc: 'Ajoutez des clés pour utiliser les modèles Kimi, Hugging Face ou TchadGPT. Ollama fonctionne sans clés.',
    powerUserFeature: 'Fonctionnalité utilisateur avancé. Déverrouillez pour configurer les fournisseurs cloud.',
    combinesAllAgentArguments: 'Combine tous les arguments des agents en une réponse claire et équilibrée.',
    eachRoundEveryAgentSpeaks: 'Chaque tour, chaque agent parle une fois. Plus de tours = débat plus approfondi.',
    backToHome: 'Retour à l\'accueil',
    help: 'Aide',
    collaborate: 'Collaborer',
    exportPDF: 'Exporter PDF',
    exportDOCX: 'Exporter DOCX',
    exportPPTX: 'Exporter PPTX',
    exportLaTeX: 'Exporter LaTeX',
    export: 'Exporter',
    processing: 'Traitement...',
    welcome: 'Bienvenue',
    startAsking: 'Tapez une question ci-dessous ou utilisez le micro pour parler, et regardez les agents IA débattre la réponse.',
    initialAnalysis: 'Analyse initiale',
    debateRound1: 'Tour de débat 1',
    debateRound2: 'Tour de débat 2',
    send: 'Envoyer',
    listeningSpeakNow: 'Écoute... Parlez maintenant',
    stop: 'Arrêter',
    processingYourVoice: 'Traitement de votre voix...',
    cancel: 'Annuler',
    enterYourIntervention: 'Entrez votre intervention...',
    pass: 'Passer',
    noIntervention: 'Pas d\'intervention',
    pressEnterToSend: 'Appuyez sur Entrée pour envoyer',
    useSendButton: 'Utilisez le bouton Envoyer pour envoyer',
    clickToSpeak: 'Cliquez 🎤 pour parler',
    voiceOutputOn: 'Sortie vocale ON',
    textVoiceOutput: 'Texte + Sortie vocale',
    textOutputOnly: 'Sortie texte uniquement',
    readAloud: 'Lire à haute voix',
    mindMap: 'Carte mentale',
    generateImage: 'Générer une image / schéma',
    describeImageToGenerate: 'Décrivez l\'image à générer…',
    detailedImageOptions: 'Options détaillées',
    generatedImage: 'Image générée',
    actions: 'Actions',
    regenerateImage: 'Regénérer l\'image',
    exportImagePPTX: 'Exporter en PPTX',
    exportImagePDF: 'Exporter en PDF',
    deleteImage: 'Supprimer l\'image',
    imageGenIntro: 'Avant de générer l\'image, merci de préciser votre besoin pour obtenir un résultat utile et fidèle au sujet.',
    failedToGenerateImage: 'Échec de la génération de l\'image',
    generating: 'Génération…',
    generate: 'Générer',
    analyzingContent: 'Analyse du contenu...',
    generatingMindMapStructure: 'Génération de la structure de la carte mentale...',
    organizingBranches: 'Organisation des branches...',
    finalizing: 'Finalisation...',
    complete: 'Terminé !',
    failedToGenerateMindMap: 'Échec de la génération de la carte mentale',
    errorGeneratingMindMap: 'Erreur lors de la génération de la carte mentale',
    failedToExportPDF: 'Échec de l\'export PDF',
    pdfExportError: 'La bibliothèque d\'export PDF n\'est pas chargée. Veuillez rafraîchir la page.',
    pdfExportFailed: 'Échec de l\'export PDF. Veuillez réessayer.',
    error: 'Erreur',
    you: 'Vous',
    humanIntervention: 'Intervention humaine',
    moderator: 'Modérateur',
    voiceSettings: 'Paramètres vocaux',
    onlyAdministratorsCanChangeVoiceSettings: 'Seuls les administrateurs peuvent modifier les paramètres vocaux.',
    voiceInput: 'Entrée vocale',
    serverSTT: 'STT Serveur',
    browserSTT: 'STT Navigateur',
    voiceOutput: 'Sortie vocale',
    serverTTS: 'TTS Serveur',
    browserTTS: 'TTS Navigateur',
    voiceOutputSettingsAdmin: 'Paramètres de sortie vocale (Admin)',
    stt: 'STT',
    serverWhisper: 'Serveur (Whisper)',
    browserWebSpeech: 'Navigateur (Web Speech)',
    tts: 'TTS',
    serverEspeak: 'Serveur (eSpeak)',
    browserSpeechSynthesis: 'Navigateur (SpeechSynthesis)',
    outputMode: 'Mode de sortie',
    textOnly: 'Texte uniquement',
    textOnlyDesc: 'Les réponses apparaissent uniquement en texte',
    voiceOnly: 'Voix uniquement',
    voiceOnlyDesc: 'Les réponses sont lues à haute voix',
    textAndVoice: 'Texte + Voix',
    textAndVoiceDesc: 'Sortie texte et vocale',
    voiceType: 'Type de voix',
    human: 'Humain',
    artificial: 'Artificiel',
    gender: 'Genre',
    helpStep1Title: `1. L'Hôte pose la question`,
    helpStep1Text: `L'utilisateur — l'Hôte — formule sa question ou la problématique à traiter.`,
    helpStep2Title: `2. Le premier agent IA répond`,
    helpStep2Text: `Le premier agent IA donne sa réponse directe à la question.`,
    helpStep3Title: `3. Le deuxième agent répond et critique`,
    helpStep3Text: `Le deuxième agent IA expose sa propre réponse, critique ou complète celle du premier agent, puis conclut son intervention.`,
    helpStep4Title: `4. Chaque agent suivant fait de même`,
    helpStep4Text: `Chaque agent suivant reproduit le même mécanisme à l'égard de toutes les réponses des agents IA et des humains qui l'ont précédé.`,
    helpStep5Title: `5. Participation des invités et fin du tour`,
    helpStep5Text: `Le tour se termine par une invitation adressée aux autres participants — locaux ou distants — ainsi qu'à l'Hôte, pour critiquer ou apporter un complément. Chacun peut cliquer sur Passer pour laisser le débat se poursuivre.`,
    helpStep6Title: `6. Les tours se poursuivent`,
    helpStep6Text: `Les tours se déroulent selon le même schéma jusqu'au dernier tour.`,
    helpStep7Title: `7. Le modérateur publie la réponse finale`,
    helpStep7Text: `Le Modérateur — agent IA ou humain — publie la réponse finale, synthèse de l'ensemble des interventions, analysée à la lumière des données disponibles.`,
    helpStep8Title: `8. Carte mentale du débat`,
    helpStep8Text: `Une carte mentale générée automatiquement illustre la structure et les enjeux du débat.`,
    helpStep9Title: `9. Exporter le contenu`,
    helpStep9Text: `L'Hôte peut exporter l'intégralité de l'historique du débat en PDF, PPTX, DOCX et LaTeX, et chaque réponse individuelle peut également être exportée à part.`,
    male: 'Masculin',
    female: 'Féminin',
    age: 'Âge',
    young: 'Jeune',
    old: 'Âgé',
    language: 'Langue',
    voiceEnabled: 'Voix activée',
    outputVoice: 'Voix de sortie',
    voiceCommand: 'Commande Vocale',
    voiceSelection: 'Sélection de la voix',
    voiceSelectionDesc: 'Choisissez la voix à utiliser pour lire les réponses.',
    availableVoices: 'Voix disponibles',
    availableVoicesDesc: 'Sélectionnez une voix parmi celles disponibles dans votre navigateur.',
    noVoicesAvailable: 'Aucune voix disponible',
    voiceRate: 'Vitesse',
    voiceRateDesc: 'Vitesse de parole',
    voicePitch: 'Hauteur',
    voicePitchDesc: 'Hauteur de la voix',
    testVoice: 'Tester la voix',
    selectedVoice: 'Voix sélectionnée',
    voiceTestText: 'Cogency est prêt à vous assister.',
    underDevelopment: 'En développement',
    selectYourSkill: 'Sélectionnez votre compétence',
    selectYourSkillDesc: 'Choisissez votre niveau d\'expérience pour personnaliser votre interface.',
    skillBeginner: 'Débutant',
    skillProfessional: 'Professionnel',
    skillExpert: 'Expert',
    skillBeginnerDesc: 'Interface simplifiée avec guide pas à pas.',
    skillProfessionalDesc: 'Interface complète avec toutes les options.',
    skillExpertDesc: 'Mode avancé avec contrôles fins.',
    skillComingSoon: 'Interface à venir',
    skillComingSoonDesc: 'L\'interface {skill} est en cours de développement.',
    xaiVoice: 'Voix Grok (xAI)',
    xaiVoiceDesc: 'Synthèse vocale et reconnaissance vocale via la voix Grok de xAI.',
    xaiUnavailableHint: 'Vérifiez la clé XAI_VOICE_API_KEY dans la configuration serveur.',
    xaiTts: 'Synthèse vocale',
    xaiStt: 'Reconnaissance vocale',
    xaiVoiceSelect: 'Voix',
    xaiVoiceSelectDesc: 'Choisissez la voix de synthèse',
    xaiTtsTest: 'Tester la synthèse vocale',
    xaiSttTest: 'Tester la reconnaissance vocale',
    xaiTtsTestText: 'Bonjour, ceci est un test de la voix Grok.',
    xaiTtsFailed: 'Échec TTS Grok',
    xaiSttFailed: 'Échec STT Grok',
    startRecording: 'Démarrer l\'enregistrement',
    stopRecording: 'Arrêter',
    fullscreen: 'Plein écran',
    connectedAs: 'Connecté en tant que',
    changeLogo: 'Changer le logo',
    customizeLogo: 'Personnaliser le logo',
    logoUploaderHint: 'Choisissez une image pour ce disque (votre photo, un logo, etc.). Elle ne s’appliquera qu’à cette barre.',
    exitFullscreen: 'Quitter le plein écran',
    closeSession: 'Fermer session',
    connectedAt: `Connecté depuis`,
    ipAddress: `Adresse IP`,
    noConnectedAddresses: `Aucune adresse IP connectée.`,
    connectedAddresses: `Adresses connectées`,
    tracking: `Tracking`,
    connectionLog: `Journal de connexions`,
    connectionLogDesc: `Historique des connexions avec adresse IP, système d'exploitation et type de dispositif.`,
    deviceType: `Appareil`,
    uniqueIps: `IP uniques`,
    entries: `entrées`,
    noConnectionLog: `Aucune connexion enregistrée.`,
    searchConnectionLog: `Rechercher IP, OS, appareil, navigateur...`,
    sortRecent: `Plus récente`,
    sortOldest: `Plus ancienne`,
    sortByCountry: `Pays`,
    sortByDevice: `Type de dispositif`,
    sortByOs: `Système d'exploitation`,
    sortByBrowser: `Navigateur`,
    sortByUser: `Utilisateur`,
    sortByAction: `État de la connexion`,
    scrollToBottom: `Descendre en bas`,
    refresh: `Actualiser`,
    connect: `Connexion`,
    disconnect: `Déconnexion`,
    date: `Date`,
    action: `Action`,
    sharedSessionHint: `Les sessions partagées permettent à d'autres personnes de suivre et collaborer en temps réel.`,
    startSharedSession: `Démarrer une session partagée`,
    startCollaborating: `Démarrer la collaboration`,
    brandTagline: 'La réussite, c\'est continuer là où les autres se sont arrêtés',
    statusThinking: '{label} : tous les agents réfléchissent en parallèle...',
    moderationPrompt: 'Tour {round} terminé. Un participant souhaite-t-il intervenir avant le tour {nextRound} ?',
    on: 'Activé',
    off: 'Désactivé',
    saving: 'Sauvegarde...',
    saveSettings: '💾 Sauvegarder les paramètres',
    settingsSavedSuccessfully: '✅ Paramètres sauvegardés avec succès',
    failedToSaveSettings: '❌ Échec de la sauvegarde des paramètres',
    howItWorksTitle: 'Comment ça marche',
    youAskAQuestion: 'Vous posez une question',
    typeAnything: 'Tapez n\'importe quoi — des questions simples aux débats complexes.',
    multipleAgentsAnalyze: 'Analyse multi-agents',
    eachAgentBringsPerspective: 'Chaque agent apporte sa perspective unique et son modèle.',
    theyDebateInRounds: 'Ils débattent en tours',
    everyRoundEachAgentResponds: 'Chaque tour, chaque agent répond à la conversation entière jusqu\'à présent.',
    youGetTheBestAnswer: 'Vous obtenez la meilleure réponse',
    synthesizerCombinesBestPoints: 'Le Synthétiseur combine leurs meilleurs points en une réponse claire.',
    helpIntro: `Contrairement aux IA individuelles ou aux IA en consensus, Cogency ne se contente pas de vous donner une réponse directe. Vous posez votre question ou votre thématique, puis plusieurs agents IA débattent ensemble. Là où les IA classiques cherchent la réponse seules, Cogency vous donne la parole : à chaque tour, vous pouvez donner votre avis, apporter un complément, critiquer une réponse ou cliquer sur Passer pour laisser le débat se poursuivre. Vous participez activement à l\'élaboration de la réponse et influencez l\'analyse des agents pendant qu\'ils travaillent.`,
    helpCoreTitle: 'Le déroulement',
    helpFeaturesTitle: 'Fonctionnalités clés',
    helpMultiAgentTitle: 'Agents spécialisés',
    helpMultiAgentText: `Chaque agent possède un persona, un modèle et une expertise propres pour enrichir le débat.`,
    helpDebateRoundsTitle: 'Tours de débat',
    helpDebateRoundsText: `Les agents échangent plusieurs réponses, affinent leurs arguments et réagissent aux idées des autres.`,
    helpSynthesisTitle: 'Réponse finale',
    helpSynthesisText: `Un agent synthétiseur rassemble les meilleurs arguments en une conclusion structurée et actionnable.`,
    helpInterventionTitle: 'Intervention humaine',
    helpInterventionText: `Vous pouvez intervenir à tout moment pour orienter, corriger ou approfondir la discussion.`,
    helpMoreTitle: 'Et aussi',
    helpVoiceTitle: 'Commande vocale',
    helpVoiceText: `Parlez pour poser vos questions et laissez l\'application lire les réponses à haute voix.`,
    helpAgentsPersonasTitle: 'Personnalisation',
    helpAgentsPersonasText: `Choisissez des agents prédéfinis ou créez vos propres personas et modèles.`,
    helpExportTitle: 'Export',
    helpExportText: `Téléchargez la conversation ou la synthèse en PDF, DOCX, PPTX ou LaTeX.`,
    helpHistoryTitle: 'Historique',
    helpHistoryText: `Retrouvez, reprenez et consultez vos sessions précédentes à tout moment.`,
    helpCollaborationTitle: 'Sessions partagées',
    helpCollaborationText: `Démarrez une session publique et invitez d\'autres utilisateurs à suivre le débat en direct.`,
    helpAccessibilityTitle: 'Accessibilité',
    helpAccessibilityText: `Ajustez le contraste, la taille du texte, les animations et les sons selon vos besoins.`,
    helpCommandsTitle: 'Commandes rapides',
    helpCommandImage: `les agents peuvent inclure automatiquement une image générée quand cela aide à illustrer leur réponse.`,
    helpCommandMindMap: 'génère une carte mentale automatique à partir du sujet.',
    helpCommandIntervene: 'insère votre propre message dans le débat.',
    helpCommandVoice: 'active ou désactive la reconnaissance vocale.',
    helpCommandExport: 'exporte immédiatement la dernière réponse dans le format choisi.',
    helpDebateMechanismTitle: `Le mécanisme du débat`,
    helpDebateMechanismText: `Au premier tour, le premier agent IA donne sa réponse directe à la question. À partir de l'intervention du deuxième agent, chacun présente sa propre version mais critique aussi la réponse de celui qui l'a précédé. Ainsi de suite, tous les agents (et les humains également) donnent leur version et critiquent les contributions précédentes, enrichissant le débat et orientant l'analyse vers une meilleure réponse.`,
    helpAddedValueTitle: `Valeur ajoutée`,
    helpAddedValueText: `Les réponses et orientations fournies par Cogency se distinguent par leur caractère standardisé, car elles reposent sur une analyse croisant deux dimensions contextuelles essentielles. La première est locale : elle prend en compte la situation, le profil et les besoins spécifiques de l'utilisateur qui interroge le système. La seconde est globale : elle intègre les dernières évolutions, mises à jour et tendances observables à l'échelle mondiale. La réponse finale n'est donc pas une simple information brute : elle constitue une conclusion structurée, fruit d'une analyse approfondie et multi-facettes.`,
    helpPlansTitle: 'Forfaits et essai',
    helpPlansText: `Commencez avec un essai gratuit, puis choisissez le forfait adapté à votre usage. Les administrateurs peuvent gérer les abonnements depuis le panneau admin.`,
    helpPrivacyTitle: 'Confidentialité',
    helpPrivacyText: `Vos conversations sont associées à votre compte. Cogency peut fonctionner avec des modèles locaux (Ollama) pour garder vos données sur la machine.`,
    helpTipTitle: '💡 Conseil',
    helpTipText: `Soyez précis dans vos questions et augmentez le nombre de tours pour obtenir des analyses plus approfondies.`,
    inviteCollaborators: 'Inviter des collaborateurs',
    shareSessionLink: '🔗 Partager le lien de session',
    anyoneWithThisLink: 'Toute personne disposant de ce lien peut rejoindre et regarder le débat en temps réel.',
    createSessionAndCopyLink: '💾 Créer une session et copier le lien',
    inviteAIAgent: '🤖 Inviter un agent IA',
    addAnotherAIAgent: 'Ajoutez un autre agent IA à la liste pour le prochain débat.',
    addAgent: 'Ajouter un agent',
    currentParticipants: '👥 Participants actuels',
    noParticipantsYet: 'Aucun participant pour l\'instant',
    back: '← Retour',
    sessionHistory: '📜 Historique des sessions',
    history: 'Historique',
    sessions: 'sessions',
    loadingSessions: 'Chargement des sessions...',
    noSavedSessionsYet: 'Aucune session enregistrée pour l\'instant.',
    completedDebatesWillAppear: 'Les débats terminés apparaîtront ici automatiquement.',
    selectSessionToViewDetails: 'Sélectionnez une session pour voir les détails',
    loadingSession: 'Chargement de la session...',
    untitledSession: 'Session sans titre',
    purgeEmptySessions: '🧹 Purger les sessions vides',
    confirmPurgeEmptySessions: 'Supprimer toutes les sessions sans message ? Cette action est irréversible.',
    purgedEmptySessions: 'Sessions vides purgées',
    purgeFailed: 'Échec du nettoyage',
    translateToFrench: 'Traduire en français',
    translateToArabic: 'Traduire en arabe',
    translationFailed: 'Échec de la traduction',
    round: 'Tour',
    debateHistory: '🗣️ Historique du débat',
    sendSessionByEmail: '📧 Envoyer la session par e-mail',
    recipientEmail: 'destinataire@exemple.com',
    sending: 'Envoi...',
    deleteSessionConfirm: 'Êtes-vous sûr de vouloir supprimer définitivement cette session ?',
    closeSessionConfirm: 'Fermer cette session ? Elle restera accessible dans l\'historique.',
    completeSessionConfirm: 'Marquer cette session comme complétée ?',
    actions: 'Actions',
    failedToLoadSessions: 'Échec du chargement des sessions',
    failedToLoadSessionDetail: 'Échec du chargement des détails de la session',
    exportFailed: 'Échec de l\'export',
    generatingDocument: `Génération du document…`,
    deleteFailed: 'Échec de la suppression',
    failedToExportDOCX: 'Échec de l\'export DOCX',
    failedToExportPPTX: 'Échec de l\'export PPTX',
    pythonExecutionFailed: 'Échec de l\'exécution Python',
    failedToSendEmail: 'Échec de l\'envoi de l\'e-mail',
    pleaseEnterValidEmail: 'Veuillez entrer une adresse e-mail valide',
    emailSentSuccessfully: 'E-mail envoyé avec succès !',
    teamChat: '💬 Chat d\'équipe',
    typeAMessage: 'Tapez un message...',
    mindMapTitle: '🧠 Carte mentale',
    zoomIn: 'Zoom avant',
    zoomOut: 'Zoom arrière',
    reset: 'Réinitialiser',
    scrollToZoom: '🖱 Faites défiler pour zoomer',
    dragToPan: 'Faites glisser pour déplacer',
    clickBranchesToExpandCollapse: 'Cliquez sur les branches pour développer/réduire',
    copySource: '📋 Copier la source',
    sourceTextCopied: 'Texte source copié dans le presse-papiers !',
    authenticating: 'Authentification...',
    loginFailed: 'Échec de la connexion',
    networkErrorPleaseTryAgain: 'Erreur réseau. Veuillez réessayer.',
    registrationSuccessful: 'Inscription réussie !',
    pleaseWaitForAdminApproval: 'Veuillez attendre l\'approbation de l\'administrateur.',
    registering: 'Inscription...',
    registrationFailed: 'Échec de l\'inscription',
    fullName: 'Nom complet',
    username: 'Nom d\'utilisateur',
    phone: 'Numéro de téléphone',
    gender: 'Sexe',
    female: 'Femme',
    male: 'Homme',
    age: 'Âge',
    profession: 'Profession',
    confirmPassword: 'Confirmer le mot de passe',
    charterAgreement: 'Accord de la Charte',
    iHaveReadCharter: 'J\'ai lu la Charte Cogency',
    readCharter: 'Lire la Charte',
    iAcceptCharter: 'J\'accepte la Charte et m\'engage à la respecter',
    iCommitNobleUse: 'Je m\'engage à utiliser Cogency à des fins nobles uniquement et non à des fins nuisibles',
    fullNameRequired: 'Le nom complet est requis',
    usernameRequired: 'Le nom d\'utilisateur est requis',
    usernameTooShort: 'Le nom d\'utilisateur doit comporter au moins 3 caractères',
    validEmailRequired: 'Un email valide est requis',
    phoneRequired: 'Le numéro de téléphone est requis',
    genderRequired: 'Le sexe est requis',
    validAgeRequired: 'L\'âge doit être compris entre 13 et 120 ans',
    professionRequired: 'La profession est requise',
    passwordMin6Chars: 'Le mot de passe doit comporter au moins 6 caractères',
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
    mustReadCharter: 'Vous devez lire la Charte',
    mustAcceptCharter: 'Vous devez accepter la Charte',
    mustCommitNobleUse: 'Vous devez vous engager à un usage noble',
    privacyTitle: 'Votre vie privée compte',
    privacyText: 'Nous respectons votre vie privée. Nous nous engageons à ne pas partager vos données avec des tiers. Vos informations sont utilisées uniquement pour améliorer votre expérience utilisateur.',
    privacyNoShare: 'Pas de partage de données avec des tiers',
    privacyExperience: 'Données utilisées uniquement pour améliorer l\'expérience',
    privacySecure: 'Stockage sécurisé et chiffré',
    understoodContinue: 'Compris, Continuer',
    fullNamePlaceholder: 'Jean Dupont',
    usernamePlaceholder: 'jean_dupont',
    phonePlaceholder: '+33 6 12 34 56 78',
    agePlaceholder: '25',
    professionPlaceholder: 'Ingénieur, Médecin, Étudiant...',
    passwordPlaceholder: '••••••',
    confirmPasswordPlaceholder: '••••••',
    noActiveSession: 'Aucune session active',
    pendingApproval: 'En attente d\'approbation',
    allUsers: 'Tous les utilisateurs',
    noUsersFound: 'Aucun utilisateur trouvé.',
    deleteUser: 'Supprimer l\'utilisateur',
    suspendUser: 'Suspendre l\'utilisateur',
    activateUser: 'Activer l\'utilisateur',
    ejectUser: 'Éjecter l\'utilisateur',
    notifyUsers: 'Notifier les utilisateurs',
    sendNotification: 'Envoyer la notification',
    notificationTitle: 'Titre de la notification',
    notificationMessage: 'Message de la notification',
    selectUsers: 'Sélectionner les utilisateurs',
    all: 'Tous',
    modelGrowth: 'Croissance du modèle',
    localModelStats: 'Statistiques du modèle local',
    services: 'Services',
    externalServices: 'Services externes',
    enableElevenLabs: 'Activer ElevenLabs',
    elevenLabsCaption: 'Utilise l\'API ElevenLabs pour des voix de synthèse haute qualité.',
    elevenLabsEnabled: 'ElevenLabs est activé.',
    elevenLabsDisabled: 'ElevenLabs est désactivé. La synthèse vocale native du navigateur est utilisée.',
    totalLocalCalls: 'Appels locaux totaux',
    totalTokens: 'Tokens totaux',
    sessionsWithLocal: 'Sessions locales',
    learningScore: 'Score d\'apprentissage',
    modelUsage: 'Utilisation des modèles',
    dailyGrowth: 'Croissance quotidienne',
    noData: 'Aucune donnée',
    userManagement: 'Gestion des utilisateurs',
    actions: 'Actions',
    suspended: 'Suspendu',
    active: 'Actif',
    deleted: 'Supprimé',
    ejected: 'Éjecté',
    confirmDeleteUser: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
    confirmSuspendUser: 'Êtes-vous sûr de vouloir suspendre cet utilisateur ?',
    confirmEjectUser: 'Êtes-vous sûr de vouloir éjecter cet utilisateur de toutes les sessions ?',
    resetPassword: 'Réinitialiser le mot de passe',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
    passwordResetSuccess: 'Mot de passe réinitialisé avec succès',
    passwordResetFailed: 'Échec de la réinitialisation du mot de passe',
    newSession: 'Nouvelle session',
    modeBypass: 'Mode Contournement — Le modérateur ne demande pas votre avis',
    modePresent: 'Mode Présent — Le modérateur attend votre commentaire',
    bypass: 'Contournement',
    present: 'Présent',
    notificationSent: 'Notification envoyée',
    usersOnline: 'Utilisateurs en ligne',
    accessibility: 'Accessibilité',
    accessibilityDesc: 'Personnalisez Cogency selon vos besoins.',
    largeText: 'Texte agrandi',
    largeTextDesc: 'Augmente la taille du texte de 15%',
    highContrast: 'Contraste élevé',
    highContrastDesc: 'Couleurs fortes pour une meilleure visibilité',
    reducedMotion: 'Réduire les animations',
    reducedMotionDesc: 'Minimise les animations',
    keyboardShortcuts: 'Raccourcis clavier',
    focusInput: 'Focus sur le champ de saisie',
    sendMessage: 'Envoyer le message',
    stopOrCancel: 'Arrêter la voix ou annuler',
    enableVoice: 'Activer les commandes vocales',
    disableVoice: 'Désactiver les commandes vocales',
    holdToSpeak: 'Maintenez pour parler',
    listening: 'Écoute...',
    heard: 'Entendu',
    voiceHint: 'Maintenez Espace ou cliquez sur le micro pour parler',
    voiceHintMobile: 'Appuyez sur le micro pour parler',
    voiceLogin: 'Ouverture de la connexion',
    voiceRegister: 'Ouverture de l\'inscription',
    voiceLogout: 'Déconnexion',
    voiceGoToChat: 'Ouverture du chat',
    voiceGoToSetup: 'Ouverture des paramètres',
    voiceGoToHistory: 'Ouverture de l\'historique',
    voiceHelpText: 'Vous pouvez dire : aller au chat, aller aux paramètres, ajouter un agent, demander suivi de votre question, taper nom du champ suivi de la valeur, envoyer, déconnexion.',
    voiceEnabled: 'Commandes vocales activées',
    voiceDisabled: 'Commandes vocales désactivées',
    voiceTyped: 'Saisi',
    voiceSubmitted: 'Envoyé',
    voiceAsking: 'Demande',
    voiceReadingLast: 'Lecture du dernier message',
    voiceReadingAll: 'Lecture de tous les messages',
    voiceStopped: 'Arrêté',
    voiceAgentAdded: 'Agent ajouté',
    voiceAgentRemoved: 'Agent supprimé',
    voiceDidNotUnderstand: 'Je n\'ai pas compris. Dites aide pour les commandes disponibles.',
    voiceNotSupported: 'La reconnaissance vocale n\'est pas prise en charge par ce navigateur.',
    policyWarning: 'AVERTISSEMENT POLITIQUE : Cette demande enfreint la Charte Cogency (les contenus liés aux conflits politiques ou religieux sont strictement interdits). Cette tentative a été enregistrée. Des tentatives supplémentaires déclencheront des mesures disciplinaires.',
    policyEnforcement: 'PROCÉDURE D\'APPLICATION : Votre compte a été suspendu pour violation de la Politique Interne et de la Charte de Cogency. Les contenus liés aux conflits politiques ou religieux sont strictement interdits. Contactez l\'administrateur.',
    viewCharter: 'Voir la Charte',
    policyNotice: 'Notice de politique',
    edit: 'Modifier',
    delete: 'Supprimer',
    cancel: 'Annuler',
    edited: 'modifié',
    cancelDebate: 'Annuler le débat',
    resume: 'Reprendre',
    liveSessions: 'Sessions actives',
    persist: 'Persister',
    dumpAll: 'Tout sauvegarder',
    inMemory: 'En mémoire',
    orphanedSessions: 'Orphelines',
    charterTitle: 'Charte d\'Utilisation et Politique Interne',
    charterVersion: 'Version 1.0',
    charterEffective: 'En vigueur à compter de la date de publication.',
    charterArt1Title: 'Objet et champ d\'application',
    charterArt1Text: 'Cogency est un outil pluridisciplinaire d\'aide à la décision, conçu pour faciliter la recherche scientifique, l\'analyse technique et l\'exploration collaborative de sujets complexes. Cette charte s\'applique à l\'ensemble des utilisateurs, abonnés, administrateurs et partenaires accédant à la plateforme.',
    charterArt2Title: 'Finalité strictement scientifique et technique',
    charterArt2Intro: 'Bien que Cogency soit un outil pluridisciplinaire d\'aide à la décision, sa finalité demeure strictement scientifique et technique. La plateforme ne doit en aucun cas être utilisée pour :',
    charterArt2Item1: 'alimenter, justifier ou prendre parti dans des conflits de quelque nature que ce soit ;',
    charterArt2Item2: 'promouvoir des idéologies politiques, religieuses ou sectaires ;',
    charterArt2Item3: 'inciter à la haine, à la discrimination ou à la violence ;',
    charterArt2Item4: 'produire des contenus de propagande, de désinformation ou de manipulation de l\'opinion.',
    charterArt3Title: 'Interdiction stricte des contenus politiques et religieux de nature conflictuelle',
    charterArt3Intro: 'Toute question, recherche, débat ou intervention portant sur des sujets d\'ordre politique ou religieux, notamment lorsqu\'ils se rapportent à des conflits, des mouvements extrémistes, des guerres, des persécutions ou des haines intercommunautaires, est strictement interdite.',
    charterArt3Item1: 'les termes et concepts liés aux conflits armés, au terrorisme, au génocide, au nettoyage ethnique, aux coups d\'État, aux dictatures, aux régimes totalitaires, aux idéologies suprémacistes ;',
    charterArt3Item2: 'les termes et concepts liés au djihad, aux croisades, aux inquisitions, aux fatwas, aux apostasies forcées, aux blasphèmes, aux hérésies, aux radicalisations religieuses, aux guerres saintes, aux haines religieuses.',
    charterArt4Title: 'Procédure de surveillance et de sanction',
    charterArt4_1Title: 'Journalisation',
    charterArt4_1Text: 'Toute tentative de soumission d\'un contenu en violation de la présente charte est automatiquement enregistrée avec horodatage, identifiant utilisateur et nature de la tentative.',
    charterArt4_2Title: 'Avertissement progressif',
    charterArt4_2Item1: 'Première et deuxième tentative — l\'utilisateur reçoit un avertissement explicite rappelant la charte et mentionnant que la tentative a été enregistrée.',
    charterArt4_2Item2: 'Troisième tentative — une procédure disciplinaire est automatiquement engagée en raison du non-respect de la charte. Cette procédure peut conduire à une suspension temporaire ou définitive de l\'accès.',
    charterArt4_3Title: 'Recours',
    charterArt4_3Text: 'Les utilisateurs peuvent contacter l\'administrateur en cas de désaccord avec une décision automatique, sous réserve de fournir des éléments justificatifs quant au caractère strictement scientifique ou technique de leur demande.',
    charterArt5Title: 'Responsabilités des utilisateurs',
    charterArt5Item1: 'respecter scrupuleusement la présente charte ;',
    charterArt5Item2: 'n\'utiliser Cogency que dans un cadre professionnel, académique ou de recherche ;',
    charterArt5Item3: 'signaler tout comportement ou contenu suspect à l\'administrateur.',
    charterArt6Title: 'Modification de la charte',
    charterArt6Text: 'Cogency se réserve le droit de modifier cette charte à tout moment. Les utilisateurs seront informés de toute mise à jour substantielle via la plateforme.',
    themes: 'Thèmes',
    themesIntro: 'Choisissez un look qui vous convient. Les thèmes avec images peuvent ajouter un arrière-plan visuel à l\'application.',
    chatTransparency: 'Transparence du chat',
    chatTransparencyHint: 'Rendre la carte du chat transparente pour voir l\'image d\'arrière-plan',
    attachDocument: 'Joindre un document',
    close: 'Fermer',
    noContactsToInvite: 'Aucun contact à inviter',
    selectUser: 'Sélectionner un utilisateur',
    manageContacts: 'Gérer les contacts',
    contactManager: 'Gestionnaire de contacts',
    friend: 'Ami',
    colleague: 'Collègue',
    superior: 'Supérieur hiérarchique',
    add: 'Ajouter',
    loading: 'Chargement',
    noContactsYet: 'Aucun contact pour le moment',
    confirmDeleteContact: 'Êtes-vous sûr de vouloir supprimer ce contact ?',
    next: 'Suivant →',
    step: 'Étape',
    yes: 'Oui',
    no: 'Non',
    decrease: 'Diminuer',
    increase: 'Augmenter',
    onboardingProgress: 'Progression de la configuration',
    onboardingWelcomeTitle: 'Bienvenue dans Cogency',
    onboardingWelcomeDesc: 'Je suis Cogency, votre assistante de réunion et de collaboration multidimensionnelle. Laissez-moi vous aider à configurer votre première session d\'agents.',
    onboardingStart: 'Commencer',
    howManyAgentsTitle: 'Combien d\'agents ?',
    howManyAgentsDesc: 'Choisissez le nombre d\'agents IA que vous souhaitez ajouter à cette session.',
    howManyAgents: 'Nombre d\'agents',
    howManyAgentsHelp: 'Vous pouvez ajouter jusqu\'à 10 agents experts.',
    configureAgentsTitle: 'Configurer les agents',
    configureAgentsDesc: 'Choisissez une persona et un modèle pour chaque agent.',
    selectPersona: 'Choisir une persona',
    selectModel: 'Choisir un modèle',
    moderationModeTitle: 'Mode de modération',
    moderationModeDesc: 'La session doit-elle faire des pauses entre les tours pour solliciter votre avis ?',
    presentMode: 'Présent',
    presentModeDesc: 'La session fait une pause entre chaque tour et attend votre intervention.',
    bypassMode: 'Contournement',
    bypassModeDesc: 'La session déroule tous les tours sans s\'arrêter.',
    inviteHumansTitle: 'Inviter des collaborateurs humains ?',
    inviteHumansDesc: 'Souhaitez-vous inviter des personnes de votre répertoire Cogency à rejoindre cette session ?',
    yesInviteHumans: 'Oui, inviter des contacts.',
    noInviteHumans: 'Non, agents seulement.',
    selectContactsTitle: 'Sélectionner les contacts',
    selectContactsDesc: 'Cochez les contacts que vous souhaitez inviter à cette session.',
    noContactsHelp: 'Vous pourrez inviter des contacts plus tard depuis l\'écran de discussion.',
    selectModeratorTitle: 'Choisir le modérateur',
    selectModeratorDesc: 'Quel agent sera le modérateur / analyste de cette session ?',
    noAgentsForModerator: 'Aucun agent n\'a été ajouté. Un analyste par défaut sera utilisé.',
    sessionTypeTitle: 'Type de session',
    sessionTypeDesc: 'Comment souhaitez-vous lancer cette session ?',
    ordinaryCollaboration: 'Collaboration ordinaire',
    ordinaryCollaborationDesc: 'Session privée — posez une question et les agents débattent.',
    sharedCollaboration: 'Collaboration partagée',
    sharedCollaborationDesc: 'Session ouverte — les contacts sélectionnés peuvent rejoindre en temps réel.',
    launchSession: 'Lancer la session',
    sessionReady: 'Session prête',
    preparingSession: 'Préparation...',
    applyingAgents: 'Application des agents...',
    creatingSession: 'Création de la session...',
    applyingModerationMode: 'Application du mode de modération...',
    sendingInvitations: 'Envoi des invitations...',
    launching: 'Lancement de la session...',
    applicationDomain: 'Domaine d\'application',
    freeSession: 'Session libre',
    getStarted: 'Démarrer',
    domainResearch: 'Recherche scientifique',
    domainMechanics: 'Mécanique',
    domainBiology: 'Biologie',
    domainAgriculture: 'Agriculture',
    domainMedicine: 'Médecine',
    domainIT: 'Informatique',
    domainLaw: 'Droit',
    domainEconomy: 'Économie',
    domainEducation: 'Éducation',
    domainEnergy: 'Énergie',
    domainEnvironment: 'Environnement',
    domainConstruction: 'BTP / Construction',
    domainFinance: 'Finance / Banque',
    domainMarketing: 'Marketing / Com',
    domainHR: 'RH / Gestion',
    domainCybersecurity: 'Cybersécurité',
    domainLogistics: 'Transport / Logistique',
    domainArts: 'Art / Culture',
    domainPublicHealth: 'Santé publique',
    domainMining: 'Mines / Géologie',
    domainOilGas: 'Pétrole / Gaz',
    domainTelecom: 'Télécommunications',
    domainRobotics: 'Robotique / IoT',
    domainPsychology: 'Psychologie',
    domainPhilosophy: 'Philosophie / Éthique',
    domainLinguistics: 'Linguistique / Langues',
    domainSpace: 'Aéronautique / Espace',
    domainClimate: 'Climat / Météo',
    tourWelcomeTitle: 'Bienvenue dans Cogency',
    tourWelcomeText: 'Cogency est une plateforme d\'intelligence collaborative. Au lieu de poser une question à une seule IA, vous réunissez plusieurs agents experts qui débattent, challengent et affinent ensemble la meilleure réponse.',
    tourDifferenceTitle: 'Ce qui différencie Cogency',
    tourDifferenceText: 'Les assistants classiques vous donnent une seule réponse. Cogency simule un conseil d\'experts : chaque agent apporte son point de vue, ses forces et ses limites, pour vous offrir une analyse plus complète, nuancée et fiable.',
    tourCollaborativeTitle: 'L\'intelligence collaborative',
    tourCollaborativeText: 'Cogency ne remplace pas la réflexion humaine, elle l\'amplifie. Les agents collaborent sous votre supervision : vous choisissez la question, les experts et le mode de modération. Le résultat final est une synthèse équilibrée de leurs échanges.',
    tourContextTitle: 'Restez dans le bon contexte',
    tourContextText: 'Cogency excelle sur des questions complexes, analytiques ou multidisciplinaires. Poser des questions sans lien avec un débat d\'experts — comme des requêtes triviales ou purement personnelles — ne tirera pas parti de sa force. Utilisez-la quand vous avez besoin d\'une réflexion approfondie.',
    tourFinish: 'Commencer',
    remainingConnexionTime: 'Temps de connexion restant',
    connectedTime: 'Temps de connexion',
    trialExpiredTitle: 'Période d\'essai terminée',
    trialExpiredText: 'Votre essai de 7 jours est terminé. Achetez un plan pour continuer à utiliser Cogency.',
    trialExpiredCta: 'Voir les forfaits',
    voice: 'Voix',
    mute: 'Muet',
    unmute: 'Activer le son',
    strategyConfiguration: 'Configuration stratégique',
    modeAuto: 'Auto',
    modeCustom: 'Personnalisé',
    autoModeHint: 'Cogency compose automatiquement le conseil stratégique selon le sujet.',
    globalStrategists: 'Stratèges mondiaux',
    arabStrategists: 'Stratèges arabes',
    strategistsSelected: 'stratège(s) sélectionné(s)',
    debateMode: 'Mode de débat',
    fiveRingsHint: 'Analyser selon le modèle des 5 anneaux de John Warden',
    fiveRingsLabel: '5 Anneaux',
    fiveRingsSynthesis: 'Synthèse par les 5 anneaux',
    showFiveRings: 'Voir les 5 anneaux',
    hideFiveRings: 'Masquer les 5 anneaux',
  
    financial: 'Financier',
    financialDesc: 'Utilisation des tokens, coûts en FCFA (XAF) et analyses détaillées',
    soundSettings: 'Paramètres audio',
    soundSettingsDesc: 'Personnaliser les sons de réflexion et de réponse.',
    mistralVoice: 'Voix Mistral (Voxtral)',
    mistralVoiceDesc: 'Synthèse vocale (texte → voix) et reconnaissance vocale (voix → texte) via les modèles Voxtral de Mistral.',
    mistralTts: 'Synthèse vocale (TTS)',
    mistralTtsDesc: 'Générer de la voix à partir du texte',
    mistralStt: 'Reconnaissance vocale (STT)',
    mistralSttDesc: 'Transcrire le texte à partir de la voix',
    mistralLangDesc: 'Langue par défaut pour TTS/STT',
    mistralVoiceId: 'Voice ID (TTS)',
    mistralVoiceIdDesc: 'Identifiant de voix Voxtral créé dans Mistral Studio (requis pour la synthèse).',
    mistralTtsTest: 'Tester la synthèse vocale',
    mistralTtsPlaceholder: 'Saisissez un texte à lire à voix haute...',
    mistralPlay: 'Lire',
    mistralSttTest: 'Tester la reconnaissance vocale',
    mistralSttTestDesc: 'Enregistrez votre voix pour la transcrire en texte',
    mistralRecord: 'Enregistrer',
    mistralStop: 'Arrêter',
    mistralSaved: 'Enregistré',
    mistralSaveError: "Échec de l'enregistrement",
    mistralTtsFailed: 'Échec TTS Mistral',
    mistralSttFailed: 'Échec STT Mistral',
    mistralUnavailableHint: 'Vérifiez la clé MISTRAL_API_KEY dans la configuration serveur.',
    groqVoice: 'Reconnaissance vocale Groq (Whisper)',
    groqVoiceDesc: 'Reconnaissance vocale (voix → texte) rapide via le modèle Whisper de Groq. Complément idéal à Grok pour le raisonnement.',
    groqStt: 'Reconnaissance vocale (STT)',
    groqLangDesc: 'Langue par défaut pour la transcription',
    groqModel: 'Modèle Whisper',
    groqModelDesc: 'turbo = plus rapide, v3 = plus précis',
    groqSttTest: 'Tester la reconnaissance vocale',
    groqSttFailed: 'Échec STT Groq',
    groqUnavailableHint: 'Vérifiez la clé GROQ_API_KEY dans la configuration serveur.',
    micError: 'Accès micro refusé',
    recording: 'Enregistrement...',
    transcribing: 'Transcription...',
    connected: 'Connecté',
    unavailable: 'Indisponible',
    thinkingSound: 'Son de réflexion',
    thinkingSoundDesc: 'Jouer pendant que les agents réfléchissent',
    answerDing: 'Son de réponse',
    answerDingDesc: 'Jouer lorsqu\'une réponse est reçue',
    volume: 'Volume',
    thinkingStyle: 'Style de réflexion',
    thinkingStyleDesc: 'Choisir le style de l\'horloge de réflexion',
    previewThinking: 'Prévisualiser la réflexion',
    previewDing: 'Prévisualiser le son',
    resetDefaults: 'Réinitialiser les paramètres par défaut',
    settingsReset: 'Paramètres réinitialisés aux valeurs par défaut',
    period: 'Période',
    days: 'jours',
    year: 'an',
    refreshing: 'Actualisation...',
    refresh: 'Actualiser',
    loadingFinancialData: 'Chargement des données financières...',
    totalSessions: 'Sessions totales',
    totalCostUSD: 'Coût total (USD)',
    totalCostFCFA: 'Coût total (FCFA)',
    tokenUsageBySession: 'Utilisation des tokens par session',
    tokenUsageByUser: 'Utilisation des tokens par utilisateur',
    provider: 'Fournisseur',
    calls: 'Appels',
    tokensIn: 'Tokens entrants',
    tokensOut: 'Tokens sortants',
    costUSD: 'Coût (USD)',
    costFCFA: 'Coût (FCFA)',
    user: 'Utilisateur',
    plan: 'Forfait',
    pricingRates: 'Tarifs (USD par 1M de tokens)',
    exchangeRate: 'Taux de change',
    dataPeriod: 'Période des données',
    noFinancialData: 'Aucune donnée financière disponible',
    trialBanner: 'Bannière d\'essai',
    trialBannerDesc: 'Définir une bannière en haut de l\'écran pour les utilisateurs en période d\'essai',
    enableBanner: 'Activer la bannière',
    enableBannerDesc: 'Afficher la bannière aux utilisateurs d\'essai sélectionnés',
    bannerMessage: 'Message de la bannière',
    bannerMessagePlaceholder: 'ex. Votre période d\'essai expire bientôt — abonnez-vous maintenant pour conserver l\'accès.',
    bannerMessageHint: 'Le HTML est autorisé (liens, gras, etc.).',
    backgroundColor: 'Couleur de fond',
    textColor: 'Couleur du texte',
    showBannerFor: 'Afficher la bannière pour',
    expiredTrialUsers: 'Utilisateurs d\'essai expirés',
    activeTrialUsers: 'Utilisateurs d\'essai actifs',
    preview: 'Aperçu',
    bannerPreviewPlaceholder: 'Votre bannière apparaîtra ici.',
    saveBanner: 'Sauvegarder la bannière',
    saving: 'Sauvegarde en cours...',
    menu: 'Menu',
    users: 'Utilisateurs',
    changePassword: 'Changer le mot de passe',
    currentPassword: 'Mot de passe actuel',
    fillAllFields: 'Veuillez remplir tous les champs',
    passwordChangedSuccess: 'Mot de passe modifié avec succès',
    passwordChangeFailed: 'Échec de la modification du mot de passe',
    failedToApplyBanner: 'Échec de l\'application de la bannière',
    failedToSendNotification: 'Échec de l\'envoi de la notification',
    notifyUser: 'Notifier l\'utilisateur',
    applyBanner: 'Appliquer la bannière',
    applyBannerConfirm: 'Voulez-vous appliquer la bannière à cet utilisateur ?',
    bannerApplied: 'Bannière appliquée avec succès',
    pricing: 'Tarification',
    exportPDF: 'Exporter en PDF',
    serviceCosts: 'Coûts des services',
    imageGeneration: 'Génération d\'images',
    costInput: 'Coût entrée',
    costOutput: 'Coût sortie',
    costsByAgent: 'Coûts par Agent / Modèle',
    sessionCosts: 'Coût des sessions',
    estimatedSessions: 'Sessions estimées',
    averageCostPerSession: 'Coût moyen par session',
    averageTokensInPerSession: 'Tokens entrée moyens / session',
    averageTokensOutPerSession: 'Tokens sortie moyens / session',
    voiceServices: 'Services vocaux',
    documentGeneration: 'Génération de documents',
    diagramGeneration: 'Génération de schémas',
    sortBy: 'Trier par',
    sortRecent: 'Récentes',
    sortOldest: 'Anciennes',
    sortLongest: 'Longues',
    sortWithImages: 'Avec images',
    sortWithFiles: 'Avec fichiers',
    sortCompleted: 'Complètes',
    sortActive: 'En cours',
    sessionCost: 'Coût de la session',
    
    fullscreen: 'Plein écran',},
  es: {
    login: 'Iniciar sesión',
    register: 'Suscríbete',
    email: 'Correo electrónico',
    password: 'Contraseña',
    name: 'Nombre completo',
    access: 'Acceso a Cogency',
    subscribersOnly: 'Sólo suscriptores',
    premiumPersonaMessage: 'Reservado para suscriptores con al menos un plan Premium',
    cannotStartTitle: 'Configuración no lista',
    cannotStartDetail: 'Todos los agentes y el sintetizador deben tener un modelo operativo para comenzar.',
    collapseSidebar: 'Contraer menú',
    expandSidebar: 'Expandir menú',
    pendingTitle: 'Suscripción pendiente',
    pendingDesc: 'Su cuenta está esperando la aprobación del administrador.',
    logout: 'Cerrar sesión',
    startCollaborating: 'Empezar a colaborar',
    configureAgents: 'Configure sus agentes',
    apiKeys: 'Claves API de la nube',
    discussionRounds: 'Rondas de discusión',
    addAgent: 'Agregar agente',
    synthesizer: 'sintetizador',
    readyToCollaborate: 'Listo para colaborar',
    askAnything: 'Pregunta cualquier cosa...',
    connected: 'Conectado',
    disconnected: 'desconectado',
    collaborators: 'Colaboradores',
    share: 'Compartir',
    invite: 'invitar',
    save: 'Guardar',
    reconfigure: 'Reconfigurar',
    howItWorks: 'como funciona',
    yourAgents: 'Tus agentes',
    settings: 'Configuración',
    interfaceSettings: 'Interfaz',
    interfaceSettingsDesc: 'Personaliza la apariencia de la aplicación y las opciones de compartir.',
    rounds: 'Rondas',
    session: 'Sesión',
    finalAnswer: 'Respuesta final',
    copy: 'Copiar',
    showDebate: 'Mostrar debate completo',
    hideDebate: 'Ocultar debate completo',
    adminPanel: 'Panel de administración',
    verifyUsers: 'Verificar suscriptores',
    noPendingUsers: 'No hay suscriptores pendientes',
    verify: 'verificar',
    footer: '© Synaptics Solutions and Technologies Ltd. Todos los derechos reservados.',
    poweredBy: 'Desarrollado por Cogency',
    joinSession: 'Unirse a la sesión',
    enterSessionId: 'Ingrese el ID de la sesión o el enlace',
    subscriberWelcome: '¡Bienvenido!Únase a una sesión para colaborar con agentes de IA.',
    lockedForAdmin: 'Configuración bloqueada: solo administrador',
    reject: 'Rechazar',
    inviteToSession: 'Invitar a la sesión',
    invite: 'invitar',
    invited: 'Invitado',
    subscribers: 'Suscriptores',
    plans: 'Planes',
    cogency: 'contundencia',
    status: 'Estado',
    agents: 'Agentes',
    admin: 'administrador',
    checkingProviders: 'Comprobación de proveedores',
    connecting: 'Conectando...',
    connectedTo: 'Conectado',
    noProvidersAvailable: 'No hay proveedores disponibles',
    availableModels: 'Modelos disponibles',
    loading: 'Cargando...',
    startSharedSession: 'Iniciar sesión compartida',
    sharedSessionsHint: 'Las sesiones compartidas permiten que otros vean y colaboren en tiempo real.',
    connectionFailed: 'Conexión fallida',
    noProvidersAvailableDetail: 'No hay proveedores de IA disponibles.Asegúrese de que Ollama se esté ejecutando o agregue claves API para proveedores de nube.',
    tryAgain: 'Inténtalo de nuevo',
    agent: 'Agente',
    remove: 'Quitar',
    persona: 'persona',
    model: 'modelo',
    powerUser: 'Usuario avanzado',
    locked: 'bloqueado',
    unlockPowerUser: 'Desbloquear usuario avanzado',
    enterUnlockCode: 'Ingrese el código de desbloqueo',
    unlock: 'Desbloquear',
    incorrectUnlockCode: 'Código de desbloqueo incorrecto.',
    addKeysDesc: 'Agregue claves para usar los modelos Kimi, Hugging Face o TchadGPT.Ollama trabaja sin llaves.',
    powerUserFeature: 'Función de usuario avanzado.Desbloquee para configurar proveedores de nube.',
    combinesAllAgentArguments: 'Combina todos los argumentos de los agentes en una respuesta clara y equilibrada.',
    eachRoundEveryAgentSpeaks: 'En cada ronda, cada agente habla una vez.Más rondas = debate más profundo.',
    backToHome: 'Volver a Inicio',
    help: 'Ayuda',
    collaborate: 'Colaborar',
    exportPDF: 'Exportar PDF',
    exportDOCX: 'Exportar DOCX',
    exportPPTX: 'Exportar PPTX',
    exportLaTeX: 'Exportar LaTeX',
    export: 'Exportar',
    processing: 'Procesando...',
    welcome: 'Bienvenido',
    startAsking: 'Escriba una pregunta a continuación o use el micrófono para hablar y observe cómo los agentes de IA debaten la respuesta.',
    initialAnalysis: 'Análisis inicial',
    debateRound1: 'Ronda de debate 1',
    debateRound2: 'Ronda de debate 2',
    send: 'enviar',
    listeningSpeakNow: 'Escuchando... Habla ahora',
    stop: 'Detener',
    processingYourVoice: 'Procesando tu voz...',
    cancel: 'Cancelar',
    enterYourIntervention: 'Introduzca su intervención...',
    pass: 'Pase',
    noIntervention: 'Sin intervención',
    pressEnterToSend: 'Pulsa Intro para enviar',
    useSendButton: 'Usa el botón Enviar para enviar',
    clickToSpeak: 'Haz clic 🎤 para hablar',
    voiceOutputOn: 'Salida de voz activada',
    textVoiceOutput: 'Salida de texto + voz',
    textOutputOnly: 'Sólo salida de texto',
    readAloud: 'leer en voz alta',
    mindMap: 'Mapa mental',
    analyzingContent: 'Analizando contenido...',
    generatingMindMapStructure: 'Generando estructura de mapa mental...',
    organizingBranches: 'Organizando sucursales...',
    finalizing: 'Finalizando...',
    complete: '¡Completo!',
    failedToGenerateMindMap: 'No se pudo generar el mapa mental',
    errorGeneratingMindMap: 'Error al generar mapa mental',
    failedToExportPDF: 'No se pudo exportar el PDF',
    error: 'error',
    you: 'tu',
    humanIntervention: 'Intervención humana',
    moderator: 'Moderador',
    voiceSettings: 'Configuración de voz',
    onlyAdministratorsCanChangeVoiceSettings: 'Sólo los administradores pueden cambiar la configuración de voz.',
    voiceInput: 'Entrada de voz',
    serverSTT: 'Servidor STT',
    browserSTT: 'Navegador STT',
    voiceOutput: 'Salida de voz',
    serverTTS: 'TTS del servidor',
    browserTTS: 'TTS del navegador',
    helpStep1Title: `1. El Anfitrión plantea la pregunta`,
    helpStep1Text: `El usuario — el Anfitrión — formula su pregunta o la problemática a tratar.`,
    helpStep2Title: `2. El primer agente de IA responde`,
    helpStep2Text: `El primer agente de IA da su respuesta directa a la pregunta.`,
    helpStep3Title: `3. El segundo agente responde y critica`,
    helpStep3Text: `El segundo agente de IA expone su propia respuesta, critica o complementa la del primer agente, y concluye su intervención.`,
    helpStep4Title: `4. Cada agente siguiente hace lo mismo`,
    helpStep4Text: `Cada agente siguiente reproduce el mismo mecanismo respecto a todas las respuestas de los agentes de IA y de los humanos que lo precedieron.`,
    helpStep5Title: `5. Participación de los invitados y fin de la ronda`,
    helpStep5Text: `La ronda termina con una invitación a los demás participantes — locales o remotos — y al Anfitrión para criticar o aportar un complemento. Cualquiera puede hacer clic en Pasar para dejar que el debate continúe.`,
    helpStep6Title: `6. Continuación de las rondas`,
    helpStep6Text: `Las rondas se desarrollan según el mismo esquema hasta la ronda final.`,
    helpStep7Title: `7. El moderador publica la respuesta final`,
    helpStep7Text: `El Moderador — agente de IA o humano — publica la respuesta final, síntesis de todas las intervenciones, analizada a la luz de los datos disponibles.`,
    helpStep8Title: `8. Mapa mental del debate`,
    helpStep8Text: `Un mapa mental generado automáticamente ilustra la estructura y los ejes del debate.`,
    helpStep9Title: `9. Exportar el contenido`,
    helpStep9Text: `El Anfitrión puede exportar todo el historial del debate en PDF, PPTX, DOCX y LaTeX, y cada respuesta individual también puede exportarse por separado.`,
    voiceOutputSettingsAdmin: 'Configuración de salida de voz (administrador)',
    stt: 'STT',
    serverWhisper: 'Servidor (susurro)',
    browserWebSpeech: 'Navegador (voz web)',
    tts: 'tts',
    serverEspeak: 'Servidor (eSpeak)',
    browserSpeechSynthesis: 'Navegador (SpeechSynthesis)',
    outputMode: 'Modo de salida',
    textOnly: 'Sólo texto',
    textOnlyDesc: 'Las respuestas aparecen solo como texto.',
    voiceOnly: 'Sólo voz',
    voiceOnlyDesc: 'Las respuestas se pronuncian en voz alta.',
    textAndVoice: 'Texto + Voz',
    textAndVoiceDesc: 'Salida de texto y voz.',
    voiceType: 'Tipo de voz',
    human: 'humano',
    artificial: 'artificiales',
    gender: 'Género',
    male: 'masculino',
    female: 'Mujer',
    age: 'edad',
    young: 'joven',
    old: 'viejo',
    language: 'Idioma',
    voiceEnabled: 'Voz habilitada',
    outputVoice: 'Voz de salida',
    voiceCommand: 'Comando de voz',
    voiceSelection: 'Selección de voz',
    voiceSelectionDesc: 'Elija la voz para leer las respuestas.',
    availableVoices: 'Voces disponibles',
    availableVoicesDesc: 'Seleccione una voz de las disponibles en su navegador.',
    noVoicesAvailable: 'No hay voces disponibles',
    voiceRate: 'Velocidad',
    voiceRateDesc: 'Velocidad del habla',
    voicePitch: 'Tono',
    voicePitchDesc: 'Tono de voz',
    testVoice: 'Probar voz',
    selectedVoice: 'Voz seleccionada',
    voiceTestText: 'Cogency está listo para ayudarle.',
    underDevelopment: 'En desarrollo',
    selectYourSkill: 'Seleccione su habilidad',
    selectYourSkillDesc: 'Elija su nivel de experiencia para personalizar su interfaz.',
    skillBeginner: 'Principiante',
    skillProfessional: 'Profesional',
    skillExpert: 'Experto',
    skillBeginnerDesc: 'Interfaz simplificada con guía paso a paso.',
    skillProfessionalDesc: 'Interfaz completa con todas las opciones.',
    skillExpertDesc: 'Modo avanzado con controles detallados.',
    skillComingSoon: 'Interfaz próximamente',
    skillComingSoonDesc: 'La interfaz {skill} está en desarrollo.',
    xaiVoice: 'Voz Grok (xAI)',
    xaiVoiceDesc: 'Texto a voz y voz a texto mediante la voz Grok de xAI.',
    xaiUnavailableHint: 'Verifique la clave XAI_VOICE_API_KEY en la configuración del servidor.',
    xaiTts: 'Texto a voz',
    xaiStt: 'Voz a texto',
    xaiVoiceSelect: 'Voz',
    xaiVoiceSelectDesc: 'Elija la voz de síntesis',
    xaiTtsTest: 'Probar texto a voz',
    xaiSttTest: 'Probar voz a texto',
    xaiTtsTestText: 'Hola, esta es una prueba de la voz Grok.',
    xaiTtsFailed: 'Error TTS Grok',
    xaiSttFailed: 'Error STT Grok',
    startRecording: 'Iniciar grabación',
    stopRecording: 'Detener',
    fullscreen: 'Pantalla completa',
    connectedAs: 'Conectado como',
    changeLogo: 'Cambiar logo',
    customizeLogo: 'Personalizar logo',
    logoUploaderHint: 'Elija una imagen para este disco (su foto, un logo, etc.). Solo se aplicará a esta barra.',
    exitFullscreen: 'Salir de pantalla completa',
    closeSession: 'Cerrar sesión',
    connectedAt: `Conectado desde`,
    ipAddress: `Dirección IP`,
    noConnectedAddresses: `No hay direcciones IP conectadas.`,
    connectedAddresses: `Direcciones conectadas`,
    tracking: `Seguimiento`,
    connectionLog: `Registro de conexiones`,
    connectionLogDesc: `Historial de conexiones con dirección IP, sistema operativo y tipo de dispositivo.`,
    deviceType: `Dispositivo`,
    uniqueIps: `IPs únicas`,
    entries: `entradas`,
    noConnectionLog: `No hay conexiones registradas.`,
    searchConnectionLog: `Buscar IP, SO, dispositivo, navegador...`,
    sortRecent: `Más reciente`,
    sortOldest: `Más antigua`,
    sortByCountry: `País`,
    sortByDevice: `Tipo de dispositivo`,
    sortByOs: `Sistema operativo`,
    sortByBrowser: `Navegador`,
    sortByUser: `Usuario`,
    sortByAction: `Estado de la conexión`,
    scrollToBottom: `Desplazarse hacia abajo`,
    refresh: `Actualizar`,
    connect: `Conectar`,
    disconnect: `Desconectar`,
    date: `Fecha`,
    action: `Acción`,
    sharedSessionHint: `Las sesiones compartidas permiten que otros observen y colaboren en tiempo real.`,
    startSharedSession: `Iniciar sesión compartida`,
    startCollaborating: `Comenzar a colaborar`,
    brandTagline: 'El éxito es continuar donde otros se detuvieron',
    statusThinking: '{label}: todos los agentes están pensando en paralelo...',
    moderationPrompt: 'Ronda {round} completada. ¿Algún participante desea intervenir antes de la ronda {nextRound}?',
    on: 'encendido',
    off: 'Apagado',
    saving: 'Guardando...',
    saveSettings: '💾 Guardar configuración',
    settingsSavedSuccessfully: '✅ Configuración guardada exitosamente',
    failedToSaveSettings: '❌ No se pudo guardar la configuración',
    howItWorksTitle: 'Cómo funciona',
    youAskAQuestion: 'Usted hace una pregunta',
    typeAnything: 'Escriba cualquier cosa, desde preguntas sencillas hasta debates complejos.',
    multipleAgentsAnalyze: 'Análisis de múltiples agentes',
    eachAgentBringsPerspective: 'Cada agente aporta su perspectiva y modelo únicos.',
    theyDebateInRounds: 'Debaten en rondas',
    everyRoundEachAgentResponds: 'En cada ronda, cada agente responde a la conversación completa hasta el momento.',
    youGetTheBestAnswer: 'Obtienes la mejor respuesta',
    synthesizerCombinesBestPoints: 'El sintetizador combina sus mejores puntos en una respuesta clara.',
    helpIntro: `A diferencia de la IA individual o la IA por consenso, Cogency no se limita a darle una respuesta directa. Usted plantea su pregunta o tema, y varios agentes de IA debaten juntos. Donde las IA clásicas buscan la respuesta solas, Cogency le da voz: en cada ronda, puede dar su opinión, añadir un complemento, criticar una respuesta o hacer clic en Pasar para dejar que el debate continúe. Usted participa activamente en la elaboración de la respuesta e influye en el análisis de los agentes mientras trabajan.`,
    helpCoreTitle: 'Cómo funciona',
    helpFeaturesTitle: 'Funciones clave',
    helpMultiAgentTitle: 'Agentes especializados',
    helpMultiAgentText: `Cada agente tiene su propia personalidad, modelo y experiencia para enriquecer el debate.`,
    helpDebateRoundsTitle: 'Rondas de debate',
    helpDebateRoundsText: `Los agentes intercambian varias respuestas, refinan sus argumentos y reaccionan a las ideas de los demás.`,
    helpSynthesisTitle: 'Respuesta final',
    helpSynthesisText: `Un agente sintetizador reúne los mejores argumentos en una conclusión estructurada y accionable.`,
    helpInterventionTitle: 'Intervención humana',
    helpInterventionText: `Puedes intervenir en cualquier momento para orientar, corregir o profundizar la discusión.`,
    helpMoreTitle: 'También',
    helpVoiceTitle: 'Control por voz',
    helpVoiceText: `Habla para hacer tus preguntas y deja que la aplicación lea las respuestas en voz alta.`,
    helpAgentsPersonasTitle: 'Personalización',
    helpAgentsPersonasText: `Elige agentes predefinidos o crea tus propias personalidades y modelos.`,
    helpExportTitle: 'Exportar',
    helpExportText: `Descarga la conversación o la síntesis en PDF, DOCX, PPTX o LaTeX.`,
    helpHistoryTitle: 'Historial',
    helpHistoryText: `Encuentra, reanuda y revisa tus sesiones anteriores en cualquier momento.`,
    helpCollaborationTitle: 'Sesiones compartidas',
    helpCollaborationText: `Inicia una sesión pública e invita a otros usuarios a seguir el debate en directo.`,
    helpAccessibilityTitle: 'Accesibilidad',
    helpAccessibilityText: `Ajusta el contraste, el tamaño del texto, las animaciones y los sonidos según tus necesidades.`,
    helpCommandsTitle: 'Comandos rápidos',
    helpCommandImage: `los agentes pueden incluir automáticamente una imagen generada cuando ayude a ilustrar su respuesta.`,
    helpCommandMindMap: 'genera un mapa mental automático a partir del tema.',
    helpCommandIntervene: 'inserta tu propio mensaje en el debate.',
    helpDebateMechanismTitle: `Cómo funciona el debate`,
    helpDebateMechanismText: `En la primera ronda, el primer agente da su respuesta directa a la pregunta. Desde el segundo agente, cada uno presenta su propia versión y también critica la respuesta del anterior. Así sucesivamente, todos los agentes (y los humanos también) dan su versión y critican las contribuciones anteriores, enriqueciendo el debate y orientando el análisis hacia una mejor respuesta.`,
    helpAddedValueTitle: `Valor añadido`,
    helpAddedValueText: `Las respuestas y orientaciones que ofrece Cogency se distinguen por su carácter estandarizado, ya que se basan en un análisis que cruza dos dimensiones contextuales esenciales. La primera es local: tiene en cuenta la situación, el perfil y las necesidades específicas del usuario que formula la pregunta. La segunda es global: integra los últimos desarrollos, actualizaciones y tendencias observables a escala mundial. La respuesta final no es, pues, una mera información bruta: constituye una conclusión estructurada, fruto de un análisis profundo y multifacético.`,
    helpCommandVoice: 'activa o desactiva el reconocimiento de voz.',
    helpCommandExport: 'exporta inmediatamente la última respuesta en el formato elegido.',
    helpPlansTitle: 'Planes y prueba',
    helpPlansText: `Comienza con una prueba gratuita y elige el plan que se adapte a tu uso. Los administradores pueden gestionar suscripciones desde el panel de administración.`,
    helpPrivacyTitle: 'Privacidad',
    helpPrivacyText: `Tus conversaciones están vinculadas a tu cuenta. Cogency puede funcionar con modelos locales (Ollama) para mantener tus datos en la máquina.`,
    helpTipTitle: '💡 Consejo',
    helpTipText: `Sé preciso en tus preguntas y aumenta el número de rondas para obtener análisis más profundos.`,
    inviteCollaborators: 'Invitar colaboradores',
    shareSessionLink: '🔗 Compartir enlace de sesión',
    anyoneWithThisLink: 'Cualquiera que tenga este enlace puede unirse y ver el debate en tiempo real.',
    createSessionAndCopyLink: '💾 Crear sesión y copiar enlace',
    inviteAIAgent: '🤖 Invitar a un agente de IA',
    addAnotherAIAgent: 'Agregue otro agente de IA a la lista para el próximo debate.',
    addAgent: 'Agregar agente',
    currentParticipants: '👥 Participantes actuales',
    noParticipantsYet: 'Aún no hay participantes',
    back: '← Volver',
    sessionHistory: '📜 Historial de sesiones',
    history: 'Historial',
    sessions: 'sesiones',
    loadingSessions: 'Cargando sesiones…',
    noSavedSessionsYet: 'Aún no hay sesiones guardadas.',
    completedDebatesWillAppear: 'Los debates completados aparecerán aquí automáticamente.',
    selectSessionToViewDetails: 'Seleccione una sesión para ver los detalles',
    loadingSession: 'Cargando sesión…',
    untitledSession: 'Sesión sin título',
    purgeEmptySessions: '🧹 Purgar sesiones vacías',
    confirmPurgeEmptySessions: '¿Eliminar todas las sesiones sin mensajes? Esta acción no se puede deshacer.',
    purgedEmptySessions: 'Sesiones vacías purgadas',
    purgeFailed: 'Error al purgar sesiones',
    translateToFrench: 'Traducir al francés',
    translateToArabic: 'Traducir al árabe',
    translationFailed: 'Error de traducción',
    round: 'redondo',
    debateHistory: '🗣️ Historia del debate',
    sendSessionByEmail: '📧 Enviar sesión por correo electrónico',
    recipientEmail: 'destinatario@ejemplo.com',
    sending: 'Enviando…',
    deleteSessionConfirm: '¿Está seguro de que desea eliminar permanentemente esta sesión?',
    failedToLoadSessions: 'No se pudieron cargar las sesiones',
    failedToLoadSessionDetail: 'No se pudieron cargar los detalles de la sesión',
    exportFailed: 'Exportación fallida',
    generatingDocument: `Generando documento…`,
    deleteFailed: 'Error al eliminar',
    failedToExportDOCX: 'No se pudo exportar DOCX',
    failedToExportPPTX: 'No se pudo exportar PPTX',
    pythonExecutionFailed: 'Error al ejecutar Python',
    failedToSendEmail: 'No se pudo enviar el correo electrónico',
    pleaseEnterValidEmail: 'Por favor introduce una dirección de correo electrónico válida',
    emailSentSuccessfully: '¡Correo electrónico enviado exitosamente!',
    teamChat: '💬 Chat de equipo',
    typeAMessage: 'Escribe un mensaje...',
    mindMapTitle: '🧠 Mapa mental',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    reset: 'Reiniciar',
    scrollToZoom: '🖱 Desplácese para ampliar',
    dragToPan: 'Arrastrar para desplazarse',
    clickBranchesToExpandCollapse: 'Haga clic en las ramas para expandir/contraer',
    copySource: '📋 Copiar fuente',
    sourceTextCopied: '¡Texto fuente copiado al portapapeles!',
    authenticating: 'Autenticando...',
    loginFailed: 'Error al iniciar sesión',
    networkErrorPleaseTryAgain: 'Error de red.Por favor inténtalo de nuevo.',
    registrationSuccessful: '¡Registro exitoso!',
    pleaseWaitForAdminApproval: 'Espere la aprobación del administrador.',
    registering: 'Registrando...',
    registrationFailed: 'Registro fallido',
    fullName: 'Nombre completo',
    username: 'Nombre de usuario',
    phone: 'Número de teléfono',
    gender: 'Género',
    female: 'Mujer',
    male: 'Hombre',
    age: 'Edad',
    profession: 'Profesión',
    confirmPassword: 'Confirmar contraseña',
    charterAgreement: 'Acuerdo de la Carta',
    iHaveReadCharter: 'He leído la Carta de Cogency',
    readCharter: 'Leer la Carta',
    iAcceptCharter: 'Acepto la Carta y me comprometo a respetarla',
    iCommitNobleUse: 'Me comprometo a usar Cogency solo para fines nobles y no para fines dañinos',
    fullNameRequired: 'El nombre completo es obligatorio',
    usernameRequired: 'El nombre de usuario es obligatorio',
    usernameTooShort: 'El nombre de usuario debe tener al menos 3 caracteres',
    validEmailRequired: 'Se requiere un correo electrónico válido',
    phoneRequired: 'El número de teléfono es obligatorio',
    genderRequired: 'El género es obligatorio',
    validAgeRequired: 'La edad debe estar entre 13 y 120 años',
    professionRequired: 'La profesión es obligatoria',
    passwordMin6Chars: 'La contraseña debe tener al menos 6 caracteres',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    mustReadCharter: 'Debes leer la Carta',
    mustAcceptCharter: 'Debes aceptar la Carta',
    mustCommitNobleUse: 'Debes comprometerte a un uso noble',
    privacyTitle: 'Tu privacidad importa',
    privacyText: 'Respetamos tu privacidad. Nos comprometemos a no compartir tus datos con terceros. Tu información se utiliza únicamente para mejorar tu experiencia de usuario.',
    privacyNoShare: 'No compartimos datos con terceros',
    privacyExperience: 'Datos usados solo para mejorar la experiencia',
    privacySecure: 'Almacenamiento seguro y encriptado',
    understoodContinue: 'Entendido, Continuar',
    fullNamePlaceholder: 'Juan Pérez',
    usernamePlaceholder: 'juan_perez',
    phonePlaceholder: '+34 612 345 678',
    agePlaceholder: '25',
    professionPlaceholder: 'Ingeniero, Médico, Estudiante...',
    passwordPlaceholder: '••••••',
    confirmPasswordPlaceholder: '••••••',
    noActiveSession: 'Ninguna sesión activa',
    pendingApproval: 'Pendiente de aprobación',
    allUsers: 'Todos los usuarios',
    noUsersFound: 'No se encontraron usuarios.',
    deleteUser: 'Eliminar usuario',
    suspendUser: 'Suspender usuario',
    activateUser: 'Activar usuario',
    ejectUser: 'Expulsar usuario',
    notifyUsers: 'Notificar a los usuarios',
    sendNotification: 'Enviar notificación',
    notificationTitle: 'Título de la notificación',
    notificationMessage: 'Mensaje de notificación',
    selectUsers: 'Seleccionar usuarios',
    all: 'Todos',
    modelGrowth: 'Crecimiento del modelo',
    localModelStats: 'Estadísticas del modelo local',
    services: 'Servicios',
    externalServices: 'Servicios externos',
    enableElevenLabs: 'Habilitar ElevenLabs',
    elevenLabsCaption: 'Usa la API de ElevenLabs para voces de alta calidad.',
    elevenLabsEnabled: 'ElevenLabs está habilitado.',
    elevenLabsDisabled: 'ElevenLabs está deshabilitado. Se utiliza la síntesis nativa del navegador.',
    totalLocalCalls: 'Total de llamadas locales',
    totalTokens: 'Fichas totales',
    sessionsWithLocal: 'Sesiones con locales',
    learningScore: 'Puntuación de aprendizaje',
    modelUsage: 'Uso del modelo',
    dailyGrowth: 'Crecimiento diario',
    noData: 'Sin datos',
    userManagement: 'Gestión de usuarios',
    actions: 'Acciones',
    suspended: 'suspendido',
    active: 'Activo',
    deleted: 'Eliminado',
    ejected: 'expulsado',
    confirmDeleteUser: '¿Estás seguro de que deseas eliminar este usuario?',
    confirmSuspendUser: '¿Estás seguro de que deseas suspender a este usuario?',
    confirmEjectUser: '¿Está seguro de que desea expulsar a este usuario de todas las sesiones?',
    resetPassword: 'Restablecer contraseña',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    passwordTooShort: 'La contraseña debe tener al menos 6 caracteres.',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    passwordResetSuccess: 'Restablecimiento de contraseña exitoso',
    passwordResetFailed: 'No se pudo restablecer la contraseña',
    newSession: 'Nueva sesión',
    modeBypass: 'Modo de omisión: el moderador nunca solicita su opinión',
    modePresent: 'Modo presente: el moderador espera su comentario',
    bypass: 'bypass',
    present: 'presente',
    notificationSent: 'Notificación enviada',
    usersOnline: 'Usuarios en línea',
    accessibility: 'Accesibilidad',
    accessibilityDesc: 'Personalice Cogency según sus necesidades.',
    largeText: 'Texto grande',
    largeTextDesc: 'Aumentar el tamaño del texto en un 15%',
    highContrast: 'Alto contraste',
    highContrastDesc: 'Colores fuertes para una mejor visibilidad.',
    reducedMotion: 'Movimiento reducido',
    reducedMotionDesc: 'Minimizar animaciones',
    keyboardShortcuts: 'Atajos de teclado',
    focusInput: 'Campo de entrada de enfoque',
    sendMessage: 'enviar mensaje',
    stopOrCancel: 'Detener voz o cancelar',
    enableVoice: 'Habilitar comandos de voz',
    disableVoice: 'Deshabilitar los comandos de voz',
    holdToSpeak: 'Mantenga para hablar',
    listening: 'Escuchando…',
    heard: 'escuchado',
    voiceHint: 'Mantenga presionada la barra espaciadora o haga clic en el micrófono para hablar',
    voiceHintMobile: 'Toque el micrófono para hablar',
    voiceLogin: 'Abrir sesión',
    voiceRegister: 'Inscripción de apertura',
    voiceLogout: 'Cerrar sesión',
    voiceGoToChat: 'Abriendo chat',
    voiceGoToSetup: 'Configuración de apertura',
    voiceGoToHistory: 'Historial de apertura',
    voiceHelpText: 'Puede decir: ir al chat, ir a configuración, agregar agente, preguntar seguido de su pregunta, escribir el nombre del campo seguido del valor, enviar, cerrar sesión.',
    voiceEnabled: 'Comandos de voz habilitados',
    voiceDisabled: 'Comandos de voz deshabilitados',
    voiceTyped: 'mecanografiado',
    voiceSubmitted: 'Enviado',
    voiceAsking: 'preguntando',
    voiceReadingLast: 'Leyendo el último mensaje',
    voiceReadingAll: 'Leyendo todos los mensajes',
    voiceStopped: 'Detenido',
    voiceAgentAdded: 'Agente agregado',
    voiceAgentRemoved: 'Agente eliminado',
    voiceDidNotUnderstand: 'No lo entendí.Di ayuda para los comandos disponibles.',
    voiceNotSupported: 'El reconocimiento de voz no es compatible con este navegador.',
    policyWarning: 'ADVERTENCIA DE POLÍTICA: Esta solicitud viola la Carta de Cogency (el contenido relacionado con conflictos políticos y religiosos está estrictamente prohibido).Este intento ha sido registrado.Nuevos intentos provocarán la aplicación de la ley.',
    policyEnforcement: 'CUMPLIMIENTO: Su cuenta ha sido suspendida por violar la Política Interna y los Estatutos de Cogency.El contenido relacionado con conflictos políticos y religiosos está estrictamente prohibido.Póngase en contacto con el administrador.',
    viewCharter: 'Ver carta',
    policyNotice: 'Aviso de política',
    edit: 'Editar',
    delete: 'Eliminar',
    cancel: 'Cancelar',
    edited: 'editado',
    cancelDebate: 'Cancelar debate',
    resume: 'Currículum',
    liveSessions: 'Sesiones en vivo',
    persist: 'persistir',
    dumpAll: 'Volcar todo',
    inMemory: 'En la memoria',
    orphanedSessions: 'huérfano',
    charterTitle: 'Carta de uso y política interna',
    charterVersion: 'Versión 1.0',
    charterEffective: 'Vigente a partir de la fecha de publicación.',
    charterArt1Title: 'Propósito y alcance',
    charterArt1Text: 'Cogency es una herramienta multidisciplinaria de apoyo a la toma de decisiones diseñada para facilitar la investigación científica, el análisis técnico y la exploración colaborativa de temas complejos.Esta carta se aplica a todos los usuarios, suscriptores, administradores y socios que acceden a la plataforma.',
    charterArt2Title: 'Finalidad estrictamente científica y técnica',
    charterArt2Intro: 'Aunque Cogency es una herramienta multidisciplinaria de apoyo a la toma de decisiones, su propósito sigue siendo estrictamente científico y técnico.La plataforma nunca debe usarse para:',
    charterArt2Item1: 'alimentar, justificar o defender conflictos de cualquier tipo;',
    charterArt2Item2: 'promover ideologías políticas, religiosas o sectarias;',
    charterArt2Item3: 'incitar al odio, la discriminación o la violencia;',
    charterArt2Item4: 'producir contenido de propaganda, desinformación o manipulación de opiniones.',
    charterArt3Title: 'Prohibición estricta del contenido de conflictos políticos y religiosos',
    charterArt3Intro: 'Cualquier pregunta, investigación, debate o intervención sobre temas políticos o religiosos, especialmente cuando se relacionen con conflictos, movimientos extremistas, guerras, persecuciones u odios entre comunidades, está estrictamente prohibido.',
    charterArt3Item1: 'Términos y conceptos relacionados con conflictos armados, terrorismo, genocidio, limpieza étnica, golpes de Estado, regímenes totalitarios;',
    charterArt3Item2: 'Términos y conceptos relacionados con la yihad, cruzadas, inquisiciones, fatwas, apostasía forzada, blasfemia, radicalización religiosa, guerras santas.',
    charterArt4Title: 'Procedimiento de seguimiento y ejecución',
    charterArt4_1Title: 'Registro',
    charterArt4_1Text: 'Cualquier intento de enviar contenido que viole esta carta se registra automáticamente con la marca de tiempo, la identificación del usuario y la naturaleza del intento.',
    charterArt4_2Title: 'Advertencia progresiva',
    charterArt4_2Item1: 'Primer y segundo intento: el usuario recibe una advertencia explícita que le recuerda la carta y le indica que el intento se ha registrado.',
    charterArt4_2Item2: 'Tercer intento: se inicia automáticamente un procedimiento disciplinario por incumplimiento de los estatutos y la política interna de Cogency.Esto puede dar lugar a una suspensión temporal o permanente.',
    charterArt4_3Title: 'Apelación',
    charterArt4_3Text: 'Los usuarios podrán ponerse en contacto con el administrador si no están de acuerdo con una decisión automática, siempre que aporten pruebas que justifiquen el carácter estrictamente científico o técnico de su solicitud.',
    charterArt5Title: 'Responsabilidades del usuario',
    charterArt5Item1: 'Cumplir estrictamente con esta carta;',
    charterArt5Item2: 'Utilice Cogency únicamente en un contexto profesional, académico o de investigación;',
    charterArt5Item3: 'Informe cualquier comportamiento o contenido sospechoso al administrador.',
    charterArt6Title: 'Enmienda a los Estatutos',
    charterArt6Text: 'Cogency se reserva el derecho de modificar esta carta en cualquier momento.Los usuarios serán informados de cualquier actualización sustancial a través de la plataforma.',
    themes: 'Temas',
    themesIntro: 'Elige un look que se adapte a ti.Los temas con imágenes pueden agregar un fondo visual a la aplicación.',
    chatTransparency: 'Transparencia del chat',
    chatTransparencyHint: 'Haz que la tarjeta de chat sea transparente para ver la imagen de fondo.',
    attachDocument: 'Adjuntar documento',
    close: 'Cerrar',
    noContactsToInvite: 'No hay contactos para invitar',
    selectUser: 'Seleccione un usuario',
    manageContacts: 'Administrar contactos',
    contactManager: 'Gerente de contacto',
    friend: 'amigo',
    colleague: 'colega',
    superior: 'superiores',
    add: 'Añadir',
    loading: 'Cargando',
    noContactsYet: 'Aún no hay contactos',
    confirmDeleteContact: '¿Estás seguro de que deseas eliminar este contacto?',
    next: 'Siguiente →',
    step: 'paso',
    yes: 'si',
    no: 'No',
    decrease: 'Disminución',
    increase: 'aumentar',
    onboardingProgress: 'Progreso de la configuración',
    onboardingWelcomeTitle: 'Bienvenido a Cogency',
    onboardingWelcomeDesc: 'Soy Cogency, su asistente multidimensional de reuniones y colaboración.Déjame ayudarte a configurar tu primera sesión de agente.',
    howManyAgentsTitle: '¿Cuantos agentes?',
    howManyAgentsDesc: 'Elija cuántos agentes de IA desea agregar a esta sesión.',
    howManyAgents: 'Número de agentes',
    howManyAgentsHelp: 'Puede agregar hasta 10 agentes expertos.',
    configureAgentsTitle: 'Configurar agentes',
    configureAgentsDesc: 'Elija una persona y un modelo para cada agente.',
    selectPersona: 'Selecciona una persona',
    selectModel: 'Selecciona un modelo',
    moderationModeTitle: 'Modo moderador',
    moderationModeDesc: '¿Debería la sesión hacer una pausa entre rondas para solicitar su opinión?',
    presentMode: 'presente',
    presentModeDesc: 'La sesión se detiene entre rondas y espera tu comentario.',
    bypassMode: 'bypass',
    bypassModeDesc: 'La sesión transcurre durante todas las rondas sin parar.',
    inviteHumansTitle: '¿Invitar a colaboradores humanos?',
    inviteHumansDesc: '¿Le gustaría invitar a personas de su directorio de Cogency a unirse a esta sesión?',
    yesInviteHumans: 'Sí, invitar contactos.',
    noInviteHumans: 'No, sólo agentes.',
    selectContactsTitle: 'Seleccionar contactos',
    selectContactsDesc: 'Elija los contactos que desea invitar a esta sesión.',
    noContactsHelp: 'Puedes invitar contactos más tarde desde la pantalla de chat.',
    selectModeratorTitle: 'Elige el moderador',
    selectModeratorDesc: '¿Qué agente será el moderador/analista de esta sesión?',
    noAgentsForModerator: 'No se agregaron agentes.Se utilizará un analista de incumplimiento.',
    sessionTypeTitle: 'Tipo de sesión',
    sessionTypeDesc: '¿Cómo le gustaría llevar a cabo esta sesión?',
    ordinaryCollaboration: 'Colaboración ordinaria',
    ordinaryCollaborationDesc: 'Sesión privada: haga una pregunta y los agentes debaten.',
    sharedCollaboration: 'Colaboración compartida',
    sharedCollaborationDesc: 'Sesión abierta: los contactos seleccionados pueden unirse en tiempo real.',
    launchSession: 'Iniciar sesión',
    sessionReady: 'Sesión lista',
    preparingSession: 'Preparando...',
    applyingAgents: 'Aplicando agentes...',
    creatingSession: 'Creando sesión...',
    applyingModerationMode: 'Aplicando el modo moderador...',
    sendingInvitations: 'Enviando invitaciones...',
    launching: 'Sesión de lanzamiento...',
    applicationDomain: 'Dominio de aplicación',
    freeSession: 'Sesión Gratuita',
    getStarted: 'Empezar',
    domainResearch: 'Investigación científica',
    domainMechanics: 'mecanica',
    domainBiology: 'biología',
    domainAgriculture: 'agricultura',
    domainMedicine: 'Medicina',
    domainIT: 'Ciencias de la Computación',
    domainLaw: 'ley',
    domainEconomy: 'Economía',
    domainEducation: 'educación',
    domainEnergy: 'Energía',
    domainEnvironment: 'Medio ambiente',
    domainConstruction: 'Construcción',
    domainFinance: 'Finanzas / Banca',
    domainMarketing: 'Marketing / Comunicaciones',
    domainHR: 'RRHH / Gestión',
    domainCybersecurity: 'Ciberseguridad',
    domainLogistics: 'Transporte / Logística',
    domainArts: 'Arte / Cultura',
    domainPublicHealth: 'Salud Pública',
    domainMining: 'Minería / Geología',
    domainOilGas: 'Petróleo/Gas',
    domainTelecom: 'Telecomunicaciones',
    domainRobotics: 'Robótica / IoT',
    domainPsychology: 'Psicología',
    domainPhilosophy: 'Filosofía / Ética',
    domainLinguistics: 'Lingüística / Idiomas',
    domainSpace: 'Aeronáutica / Espacio',
    domainClimate: 'Clima / Tiempo',
    tourWelcomeTitle: 'Bienvenido a Cogency',
    tourWelcomeText: 'Cogency es una plataforma de inteligencia colaborativa.En lugar de preguntarle a una sola IA, reúne a varios agentes expertos que debaten, desafían y perfeccionan juntos la mejor respuesta.',
    tourDifferenceTitle: '¿Qué hace que Cogency sea diferente?',
    tourDifferenceText: 'Los asistentes clásicos te dan una única respuesta.Cogency simula un panel de expertos: cada agente aporta su propia perspectiva, fortalezas y límites para ofrecer un análisis más completo, matizado y confiable.',
    tourCollaborativeTitle: 'Inteligencia colaborativa',
    tourCollaborativeText: 'La contundencia no reemplaza el pensamiento humano: lo amplifica.Los agentes colaboran bajo tu supervisión: tú eliges la pregunta, los expertos y el modo de moderación.El resultado final es una síntesis equilibrada de su discusión.',
    tourContextTitle: 'Manténgase en el contexto correcto',
    tourContextText: 'La contundencia brilla en cuestiones complejas, analíticas o multidisciplinarias.Hacer preguntas no relacionadas con un debate de expertos (como solicitudes triviales o puramente personales) no aprovechará su fortaleza.Úselo cuando necesite pensar en profundidad.',
    tourFinish: 'Comenzar',
    remainingConnexionTime: 'Tiempo restante de conexión',
    connectedTime: 'Tiempo de conexión',
    trialExpiredTitle: 'Período de prueba finalizado',
    trialExpiredText: 'Tu prueba de 7 días ha finalizado.Compra un plan para seguir usando Cogency.',
    trialExpiredCta: 'Ver planos',
    voice: 'Voz',
    mute: 'Silenciar',
    unmute: 'Dejar de silenciar',
  
    fullscreen: 'Pantalla completa',},
  de: {
    login: 'Anmelden',
    register: 'Abonnieren',
    email: 'E-Mail',
    password: 'Passwort',
    name: 'Vollständiger Name',
    access: 'Greifen Sie auf Cogency zu',
    subscribersOnly: 'Nur für Abonnenten',
    premiumPersonaMessage: 'Für Abonnenten mit mindestens einem Premium-Tarif reserviert',
    cannotStartTitle: 'Konfiguration nicht bereit',
    cannotStartDetail: 'Alle Agenten und der Synthesizer müssen ein betriebsbereites Modell haben, um zu starten.',
    collapseSidebar: 'Menü einklappen',
    expandSidebar: 'Menü ausklappen',
    pendingTitle: 'Abonnement ausstehend',
    pendingDesc: 'Ihr Konto wartet auf die Genehmigung durch den Administrator.',
    logout: 'Abmelden',
    startCollaborating: 'Beginnen Sie mit der Zusammenarbeit',
    configureAgents: 'Konfigurieren Sie Ihre Agenten',
    apiKeys: 'Cloud-API-Schlüssel',
    discussionRounds: 'Diskussionsrunden',
    addAgent: 'Agent hinzufügen',
    synthesizer: 'Synthesizer',
    readyToCollaborate: 'Bereit zur Zusammenarbeit',
    askAnything: 'Fragen Sie alles...',
    connected: 'Verbunden',
    disconnected: 'Nicht verbunden',
    collaborators: 'Mitarbeiter',
    share: 'Teilen',
    invite: 'Einladen',
    save: 'Speichern',
    reconfigure: 'Neu konfigurieren',
    howItWorks: 'Wie es funktioniert',
    yourAgents: 'Ihre Agenten',
    settings: 'Einstellungen',
    interfaceSettings: 'Oberfläche',
    interfaceSettingsDesc: 'Passen Sie das Erscheinungsbild der App und die Freigabeoptionen an.',
    rounds: 'Runden',
    session: 'Sitzung',
    finalAnswer: 'Endgültige Antwort',
    copy: 'Kopieren',
    showDebate: 'Vollständige Debatte anzeigen',
    hideDebate: 'Vollständige Debatte ausblenden',
    adminPanel: 'Admin-Panel',
    verifyUsers: 'Abonnenten überprüfen',
    noPendingUsers: 'Keine ausstehenden Abonnenten',
    verify: 'Überprüfen',
    footer: '© Synaptics Solutions and Technologies Ltd. Alle Rechte vorbehalten.',
    poweredBy: 'Unterstützt durch Cogency',
    joinSession: 'Treten Sie der Sitzung bei',
    enterSessionId: 'Geben Sie die Sitzungs-ID oder den Link ein',
    subscriberWelcome: 'Willkommen!Nehmen Sie an einer Sitzung teil, um mit KI-Agenten zusammenzuarbeiten.',
    lockedForAdmin: 'Konfiguration gesperrt – nur für Administratoren',
    reject: 'Ablehnen',
    inviteToSession: 'Zur Sitzung einladen',
    invite: 'Einladen',
    invited: 'Eingeladen',
    subscribers: 'Abonnenten',
    plans: 'Pläne',
    cogency: 'Zwanghaftigkeit',
    status: 'Status',
    agents: 'Agenten',
    admin: 'Admin',
    checkingProviders: 'Anbieter prüfen',
    connecting: 'Verbinden...',
    connectedTo: 'Verbunden',
    noProvidersAvailable: 'Keine Anbieter verfügbar',
    availableModels: 'Verfügbare Modelle',
    loading: 'Laden...',
    startSharedSession: 'Gemeinsame Sitzung starten',
    sharedSessionsHint: 'Durch gemeinsame Sitzungen können andere in Echtzeit zuschauen und zusammenarbeiten.',
    connectionFailed: 'Verbindung fehlgeschlagen',
    noProvidersAvailableDetail: 'Es sind keine KI-Anbieter verfügbar.Stellen Sie sicher, dass Ollama ausgeführt wird, oder fügen Sie API-Schlüssel für Cloud-Anbieter hinzu.',
    tryAgain: 'Versuchen Sie es erneut',
    agent: 'Agent',
    remove: 'Entfernen',
    persona: 'Persona',
    model: 'Modell',
    powerUser: 'Power-User',
    locked: 'Gesperrt',
    unlockPowerUser: 'Poweruser entsperren',
    enterUnlockCode: 'Geben Sie den Entsperrcode ein',
    unlock: 'Entsperren',
    incorrectUnlockCode: 'Falscher Freischaltcode.',
    addKeysDesc: 'Fügen Sie Schlüssel hinzu, um die Modelle Kimi, Hugging Face oder TchadGPT zu verwenden.Ollama funktioniert ohne Schlüssel.',
    powerUserFeature: 'Power-User-Funktion.Entsperren, um Cloud-Anbieter zu konfigurieren.',
    combinesAllAgentArguments: 'Fasst alle Agentenargumente in einer klaren, ausgewogenen Antwort zusammen.',
    eachRoundEveryAgentSpeaks: 'In jeder Runde spricht jeder Agent einmal.Mehr Runden = tiefere Debatte.',
    backToHome: 'Zurück nach Hause',
    help: 'Hilfe',
    collaborate: 'Zusammenarbeiten',
    exportPDF: 'PDF exportieren',
    exportDOCX: 'DOCX exportieren',
    exportPPTX: 'PPTX exportieren',
    exportLaTeX: 'LaTeX exportieren',
    export: 'Exportieren',
    processing: 'Verarbeitung...',
    welcome: 'Willkommen',
    startAsking: 'Geben Sie unten eine Frage ein oder nutzen Sie das Mikrofon, um zu sprechen, und beobachten Sie, wie KI-Agenten über die Antwort diskutieren.',
    initialAnalysis: 'Erste Analyse',
    debateRound1: 'Debattenrunde 1',
    debateRound2: 'Debattenrunde 2',
    send: 'Senden',
    listeningSpeakNow: 'Zuhören... Sprechen Sie jetzt',
    stop: 'Stopp',
    processingYourVoice: 'Verarbeiten Sie Ihre Stimme...',
    cancel: 'Abbrechen',
    enterYourIntervention: 'Geben Sie Ihre Intervention ein...',
    pass: 'Pass',
    noIntervention: 'Kein Eingriff',
    pressEnterToSend: 'Drücken Sie zum Senden die Eingabetaste',
    useSendButton: 'Verwenden Sie die Senden-Schaltfläche',
    clickToSpeak: 'Klicken Sie auf 🎤, um zu sprechen',
    voiceOutputOn: 'Sprachausgabe EIN',
    textVoiceOutput: 'Text- und Sprachausgabe',
    textOutputOnly: 'Nur Textausgabe',
    readAloud: 'Vorlesen',
    mindMap: 'Mindmap',
    analyzingContent: 'Inhalt analysieren...',
    generatingMindMapStructure: 'Mindmap-Struktur erstellen...',
    helpStep1Title: `1. Der Gastgeber stellt die Frage`,
    helpStep1Text: `Der Nutzer — der Gastgeber — formuliert seine Frage oder das zu behandelnde Problem.`,
    helpStep2Title: `2. Der erste KI-Agent antwortet`,
    helpStep2Text: `Der erste KI-Agent gibt seine direkte Antwort auf die Frage.`,
    helpStep3Title: `3. Der zweite Agent antwortet und kritisiert`,
    helpStep3Text: `Der zweite KI-Agent stellt seine eigene Antwort dar, kritisiert oder ergänzt die des ersten Agents und schließt seinen Beitrag mit einem Fazit ab.`,
    helpStep4Title: `4. Jeder folgende Agent verfährt ebenso`,
    helpStep4Text: `Jeder folgende Agent wendet denselben Mechanismus auf alle Antworten der KI-Agents und Menschen an, die ihm vorausgegangen sind.`,
    helpStep5Title: `5. Teilnahme der Gäste und Rundenende`,
    helpStep5Text: `Die Runde endet mit einer Einladung an die anderen Teilnehmer — lokal oder remote — sowie den Gastgeber, zu kritisieren oder etwas hinzuzufügen. Jeder kann auf Weiter klicken, um die Debatte fortzusetzen.`,
    helpStep6Title: `6. Die Runden setzen sich fort`,
    helpStep6Text: `Die Runden verlaufen nach demselben Schema bis zur letzten Runde.`,
    helpStep7Title: `7. Der Moderator veröffentlicht die finale Antwort`,
    helpStep7Text: `Der Moderator — KI-Agent oder Mensch — veröffentlicht die finale Antwort, eine Synthese aller Beiträge, analysiert im Lichte der verfügbaren Daten.`,
    helpStep8Title: `8. Mindmap der Debatte`,
    helpStep8Text: `Eine automatisch generierte Mindmap veranschaulicht Struktur und Kernthemen der Debatte.`,
    helpStep9Title: `9. Inhalt exportieren`,
    helpStep9Text: `Der Gastgeber kann die gesamte Debattenhistorie als PDF, PPTX, DOCX und LaTeX exportieren, und jede einzelne Antwort kann separat exportiert werden.`,
    organizingBranches: 'Filialen organisieren...',
    finalizing: 'Finalisierung...',
    complete: 'Komplett!',
    failedToGenerateMindMap: 'Mindmap konnte nicht erstellt werden',
    errorGeneratingMindMap: 'Fehler beim Generieren der Mindmap',
    failedToExportPDF: 'PDF konnte nicht exportiert werden',
    error: 'Fehler',
    you: 'Du',
    humanIntervention: 'Menschliches Eingreifen',
    moderator: 'Moderator',
    voiceSettings: 'Spracheinstellungen',
    onlyAdministratorsCanChangeVoiceSettings: 'Nur Administratoren können Spracheinstellungen ändern.',
    voiceInput: 'Spracheingabe',
    serverSTT: 'Server-STT',
    browserSTT: 'Browser-STT',
    voiceOutput: 'Sprachausgabe',
    serverTTS: 'Server-TTS',
    browserTTS: 'Browser-TTS',
    voiceOutputSettingsAdmin: 'Sprachausgabeeinstellungen (Admin)',
    stt: 'STT',
    serverWhisper: 'Server (Flüstern)',
    browserWebSpeech: 'Browser (Web-Sprache)',
    tts: 'TTS',
    serverEspeak: 'Server (eSpeak)',
    browserSpeechSynthesis: 'Browser (SpeechSynthesis)',
    outputMode: 'Ausgabemodus',
    textOnly: 'Nur Text',
    textOnlyDesc: 'Antworten werden nur als Text angezeigt',
    voiceOnly: 'Nur Stimme',
    voiceOnlyDesc: 'Antworten werden laut gesprochen',
    textAndVoice: 'Text + Stimme',
    textAndVoiceDesc: 'Sowohl Text- als auch Sprachausgabe',
    voiceType: 'Sprachtyp',
    human: 'Menschlich',
    artificial: 'Künstlich',
    gender: 'Geschlecht',
    male: 'Männlich',
    female: 'Weiblich',
    age: 'Alter',
    young: 'Jung',
    old: 'Alt',
    language: 'Sprache',
    voiceEnabled: 'Sprachaktiviert',
    outputVoice: 'Ausgabestimme',
    voiceCommand: 'Sprachbefehl',
    voiceSelection: 'Sprachauswahl',
    voiceSelectionDesc: 'Wählen Sie die Stimme zum Vorlesen der Antworten aus.',
    availableVoices: 'Verfügbare Stimmen',
    availableVoicesDesc: 'Wählen Sie eine Stimme aus den im Browser verfügbaren aus.',
    noVoicesAvailable: 'Keine Stimmen verfügbar',
    voiceRate: 'Geschwindigkeit',
    voiceRateDesc: 'Sprechgeschwindigkeit',
    voicePitch: 'Tonhöhe',
    voicePitchDesc: 'Stimmlage',
    testVoice: 'Stimme testen',
    selectedVoice: 'Ausgewählte Stimme',
    voiceTestText: 'Cogency ist bereit, Ihnen zu helfen.',
    underDevelopment: 'In Entwicklung',
    selectYourSkill: 'Wählen Sie Ihre Fähigkeit',
    selectYourSkillDesc: 'Wählen Sie Ihr Erfahrungslevel, um Ihre Oberfläche anzupassen.',
    skillBeginner: 'Anfänger',
    skillProfessional: 'Professionell',
    skillExpert: 'Experte',
    skillBeginnerDesc: 'Vereinfachte Oberfläche mit Schritt-für-Schritt-Anleitung.',
    skillProfessionalDesc: 'Vollständige Oberfläche mit allen Optionen.',
    skillExpertDesc: 'Erweiterter Modus mit detaillierten Steuerungen.',
    skillComingSoon: 'Oberfläche in Kürze verfügbar',
    skillComingSoonDesc: 'Die {skill}-Oberfläche befindet sich in der Entwicklung.',
    xaiVoice: 'Grok-Stimme (xAI)',
    xaiVoiceDesc: 'Text-zu-Sprache und Sprache-zu-Text über xAI Grok Voice.',
    xaiUnavailableHint: 'Überprüfen Sie den XAI_VOICE_API_KEY in der Serverkonfiguration.',
    xaiTts: 'Text-zu-Sprache',
    xaiStt: 'Sprache-zu-Text',
    xaiVoiceSelect: 'Stimme',
    xaiVoiceSelectDesc: 'Wählen Sie die Synthesestimme',
    xaiTtsTest: 'TTS testen',
    xaiSttTest: 'STT testen',
    xaiTtsTestText: 'Hallo, dies ist ein Test der Grok-Stimme.',
    xaiTtsFailed: 'Grok TTS fehlgeschlagen',
    xaiSttFailed: 'Grok STT fehlgeschlagen',
    startRecording: 'Aufnahme starten',
    stopRecording: 'Stopp',
    fullscreen: 'Vollbild',
    connectedAs: 'Verbunden als',
    changeLogo: 'Logo ändern',
    customizeLogo: 'Logo anpassen',
    logoUploaderHint: 'Wählen Sie ein Bild für diese Scheibe (Ihr Foto, ein Logo usw.). Es gilt nur für diese Leiste.',
    exitFullscreen: 'Vollbild beenden',
    closeSession: 'Sitzung schließen',
    connectedAt: `Verbunden seit`,
    ipAddress: `IP-Adresse`,
    noConnectedAddresses: `Keine verbundenen IP-Adressen.`,
    connectedAddresses: `Verbundene Adressen`,
    tracking: `Tracking`,
    connectionLog: `Verbindungsprotokoll`,
    connectionLogDesc: `Verbindungsverlauf mit IP-Adresse, Betriebssystem und Gerätetyp.`,
    deviceType: `Gerät`,
    uniqueIps: `Eindeutige IPs`,
    entries: `Einträge`,
    noConnectionLog: `Keine Verbindungen aufgezeichnet.`,
    searchConnectionLog: `Suche nach IP, OS, Gerät, Browser...`,
    sortRecent: `Neueste`,
    sortOldest: `Älteste`,
    sortByCountry: `Land`,
    sortByDevice: `Gerätetyp`,
    sortByOs: `Betriebssystem`,
    sortByBrowser: `Browser`,
    sortByUser: `Benutzer`,
    sortByAction: `Verbindungsstatus`,
    scrollToBottom: `Nach unten scrollen`,
    refresh: `Aktualisieren`,
    connect: `Verbinden`,
    disconnect: `Trennen`,
    date: `Datum`,
    action: `Aktion`,
    sharedSessionHint: `Geteilte Sitzungen ermöglichen es anderen, in Echtzeit zuzusehen und zusammenzuarbeiten.`,
    startSharedSession: `Geteilte Sitzung starten`,
    startCollaborating: `Zusammenarbeit starten`,
    brandTagline: 'Erfolg bedeutet, dort weiterzumachen, wo andere aufgehört haben',
    statusThinking: '{label}: Alle Agenten denken parallel nach...',
    moderationPrompt: 'Runde {round} abgeschlossen. Möchte ein Teilnehmer vor Runde {nextRound} eingreifen?',
    on: 'Auf',
    off: 'Aus',
    saving: 'Sparen...',
    saveSettings: '💾 Einstellungen speichern',
    settingsSavedSuccessfully: '✅ Einstellungen erfolgreich gespeichert',
    failedToSaveSettings: '❌ Einstellungen konnten nicht gespeichert werden',
    howItWorksTitle: 'Wie es funktioniert',
    youAskAQuestion: 'Sie stellen eine Frage',
    typeAnything: 'Geben Sie alles ein – von einfachen Fragen bis hin zu komplexen Debatten.',
    multipleAgentsAnalyze: 'Mehrere Agenten analysieren',
    eachAgentBringsPerspective: 'Jeder Agent bringt seine einzigartige Perspektive und sein einzigartiges Modell mit.',
    theyDebateInRounds: 'Sie debattieren in Runden',
    everyRoundEachAgentResponds: 'In jeder Runde antwortet jeder Agent auf das gesamte bisherige Gespräch.',
    youGetTheBestAnswer: 'Sie erhalten die beste Antwort',
    synthesizerCombinesBestPoints: 'Der Synthesizer vereint ihre besten Punkte in einer klaren Antwort.',
    helpIntro: `Im Gegensatz zu einzelner KI oder Konsens-KI gibt Cogency Ihnen nicht einfach eine direkte Antwort. Sie stellen Ihre Frage oder Ihr Thema, dann debattieren mehrere KI-Agenten gemeinsam. Während klassische KIs die Antwort allein suchen, gibt Cogency Ihnen ein Wort: in jeder Runde können Sie Ihre Meinung äußern, eine Ergänzung hinzufügen, eine Antwort kritisieren oder auf Weiter klicken, um die Debatte fortzusetzen. Sie wirken aktiv an der Formulierung der Antwort mit und beeinflussen die Analyse der Agenten während ihrer Arbeit.`,
    helpCoreTitle: 'Ablauf',
    helpFeaturesTitle: 'Wichtige Funktionen',
    helpMultiAgentTitle: 'Spezialisierte Agenten',
    helpMultiAgentText: `Jeder Agent hat seine eigene Persönlichkeit, sein eigenes Modell und seine eigene Expertise, um die Debatte zu bereichern.`,
    helpDebateRoundsTitle: 'Debattenrunden',
    helpDebateRoundsText: `Die Agenten tauschen mehrere Antworten aus, verfeinern ihre Argumente und reagieren auf die Ideen der anderen.`,
    helpSynthesisTitle: 'Finale Antwort',
    helpSynthesisText: `Ein Synthese-Agent fasst die besten Argumente in einer strukturierten, umsetzbaren Schlussfolgerung zusammen.`,
    helpInterventionTitle: 'Menschliches Eingreifen',
    helpInterventionText: `Sie können jederzeit eingreifen, um die Diskussion zu steuern, zu korrigieren oder zu vertiefen.`,
    helpMoreTitle: 'Außerdem',
    helpVoiceTitle: 'Sprachsteuerung',
    helpVoiceText: `Sprechen Sie, um Ihre Fragen zu stellen, und lassen Sie die App die Antworten laut vorlesen.`,
    helpAgentsPersonasTitle: 'Anpassung',
    helpAgentsPersonasText: `Wählen Sie vordefinierte Agenten oder erstellen Sie Ihre eigenen Persönlichkeiten und Modelle.`,
    helpExportTitle: 'Export',
    helpExportText: `Laden Sie das Gespräch oder die Synthese als PDF, DOCX, PPTX oder LaTeX herunter.`,
    helpHistoryTitle: 'Verlauf',
    helpHistoryText: `Finden, fortsetzen und überprüfen Sie Ihre vorherigen Sitzungen jederzeit.`,
    helpCollaborationTitle: 'Geteilte Sitzungen',
    helpCollaborationText: `Starten Sie eine öffentliche Sitzung und laden Sie andere Benutzer ein, der Debatte live zu folgen.`,
    helpAccessibilityTitle: 'Barrierefreiheit',
    helpAccessibilityText: `Passen Sie Kontrast, Textgröße, Animationen und Sounds Ihren Bedürfnissen an.`,
    helpCommandsTitle: 'Schnellbefehle',
    helpCommandImage: `Agenten können automatisch ein generiertes Bild einfügen, wenn es ihre Antwort veranschaulicht.`,
    helpDebateMechanismTitle: `Wie die Debatte funktioniert`,
    helpDebateMechanismText: `In der ersten Runde gibt der erste Agent seine direkte Antwort auf die Frage. Ab dem zweiten Agenten stellt jeder seine eigene Version vor und kritisiert auch die Antwort seines Vorgängers. So äußern nach und nach alle Agenten (und auch Menschen) ihre Meinung und kritisieren vorherige Beiträge, was die Debatte bereichert und die Analyse in Richtung einer besseren Antwort lenkt.`,
    helpAddedValueTitle: `Mehrwert`,
    helpAddedValueText: `Die von Cogency gelieferten Antworten und Orientierungen zeichnen sich durch ihren standardisierten Charakter aus, da sie auf einer Analyse beruhen, die zwei wesentliche kontextuelle Dimensionen verknüpft. Die erste ist lokal: sie berücksichtigt die Situation, das Profil und die spezifischen Bedürfnisse des Nutzers, der die Frage stellt. Die zweite ist global: sie integriert die neuesten Entwicklungen, Aktualisierungen und weltweit beobachtbaren Trends. Die finale Antwort ist daher keine bloße Rohinformation: sie bildet ein strukturiertes Fazit, das aus einer tiefgehenden, vielseitigen Analyse hervorgeht.`,
    helpCommandMindMap: 'erstellt automatisch eine Mindmap zum Thema.',
    helpCommandIntervene: 'fügt Ihre eigene Nachricht in die Debatte ein.',
    helpCommandVoice: 'aktiviert oder deaktiviert die Spracherkennung.',
    helpCommandExport: 'exportiert die letzte Antwort sofort im gewählten Format.',
    helpPlansTitle: 'Tarife und Test',
    helpPlansText: `Beginnen Sie mit einer kostenlosen Testphase und wählen Sie dann den passenden Tarif. Administratoren können Abonnements im Admin-Panel verwalten.`,
    helpPrivacyTitle: 'Datenschutz',
    helpPrivacyText: `Ihre Gespräche sind mit Ihrem Konto verknüpft. Cogency kann mit lokalen Modellen (Ollama) betrieben werden, um Daten auf dem Gerät zu halten.`,
    helpTipTitle: '💡 Tipp',
    helpTipText: `Seien Sie präzise in Ihren Fragen und erhöhen Sie die Anzahl der Runden für tiefere Analysen.`,
    inviteCollaborators: 'Laden Sie Mitarbeiter ein',
    shareSessionLink: '🔗 Sitzungslink teilen',
    anyoneWithThisLink: 'Jeder, der über diesen Link verfügt, kann beitreten und die Debatte in Echtzeit verfolgen.',
    createSessionAndCopyLink: '💾 Sitzung erstellen und Link kopieren',
    inviteAIAgent: '🤖 KI-Agent einladen',
    addAnotherAIAgent: 'Fügen Sie der Liste für die nächste Debatte einen weiteren KI-Agenten hinzu.',
    addAgent: 'Agent hinzufügen',
    currentParticipants: '👥 Aktuelle Teilnehmer',
    noParticipantsYet: 'Noch keine Teilnehmer',
    back: '← Zurück',
    sessionHistory: '📜 Sitzungsverlauf',
    history: 'Verlauf',
    sessions: 'Sitzungen',
    loadingSessions: 'Sitzungen werden geladen…',
    noSavedSessionsYet: 'Noch keine gespeicherten Sitzungen.',
    completedDebatesWillAppear: 'Abgeschlossene Debatten werden hier automatisch angezeigt.',
    selectSessionToViewDetails: 'Wählen Sie eine Sitzung aus, um Details anzuzeigen',
    loadingSession: 'Sitzung wird geladen…',
    untitledSession: 'Sitzung ohne Titel',
    purgeEmptySessions: '🧹 Leere Sitzungen bereinigen',
    confirmPurgeEmptySessions: 'Alle Sitzungen ohne Nachrichten löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    purgedEmptySessions: 'Leere Sitzungen bereinigt',
    purgeFailed: 'Bereinigung fehlgeschlagen',
    translateToFrench: 'Auf Französisch übersetzen',
    translateToArabic: 'Auf Arabisch übersetzen',
    translationFailed: 'Übersetzung fehlgeschlagen',
    round: 'Rund',
    debateHistory: '🗣️ Debattengeschichte',
    sendSessionByEmail: '📧 Sitzung per E-Mail senden',
    recipientEmail: 'empfänger@example.com',
    sending: 'Senden…',
    deleteSessionConfirm: 'Sind Sie sicher, dass Sie diese Sitzung dauerhaft löschen möchten?',
    failedToLoadSessions: 'Sitzungen konnten nicht geladen werden',
    failedToLoadSessionDetail: 'Sitzungsdetails konnten nicht geladen werden',
    exportFailed: 'Der Export ist fehlgeschlagen',
    generatingDocument: `Dokument wird erstellt…`,
    deleteFailed: 'Das Löschen ist fehlgeschlagen',
    failedToExportDOCX: 'DOCX konnte nicht exportiert werden',
    failedToExportPPTX: 'PPTX konnte nicht exportiert werden',
    pythonExecutionFailed: 'Python-Ausführung fehlgeschlagen',
    failedToSendEmail: 'E-Mail konnte nicht gesendet werden',
    pleaseEnterValidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    emailSentSuccessfully: 'E-Mail erfolgreich gesendet!',
    teamChat: '💬 Team-Chat',
    typeAMessage: 'Geben Sie eine Nachricht ein...',
    mindMapTitle: '🧠 Mindmap',
    zoomIn: 'Vergrößern',
    zoomOut: 'Herauszoomen',
    reset: 'Zurücksetzen',
    scrollToZoom: '🖱 Scrollen Sie zum Zoomen',
    dragToPan: 'Zum Schwenken ziehen',
    clickBranchesToExpandCollapse: 'Klicken Sie auf die Zweige, um sie zu erweitern/zu reduzieren',
    copySource: '📋 Quelle kopieren',
    sourceTextCopied: 'Quelltext in die Zwischenablage kopiert!',
    authenticating: 'Authentifizierung...',
    loginFailed: 'Die Anmeldung ist fehlgeschlagen',
    networkErrorPleaseTryAgain: 'Netzwerkfehler.Bitte versuchen Sie es erneut.',
    registrationSuccessful: 'Registrierung erfolgreich!',
    pleaseWaitForAdminApproval: 'Bitte warten Sie auf die Genehmigung durch den Administrator.',
    registering: 'Registrieren...',
    registrationFailed: 'Die Registrierung ist fehlgeschlagen',
    fullName: 'Vollständiger Name',
    username: 'Benutzername',
    phone: 'Telefonnummer',
    gender: 'Geschlecht',
    female: 'Weiblich',
    male: 'Männlich',
    age: 'Alter',
    profession: 'Beruf',
    confirmPassword: 'Passwort bestätigen',
    charterAgreement: 'Charta-Vereinbarung',
    iHaveReadCharter: 'Ich habe die Cogency-Charta gelesen',
    readCharter: 'Charta lesen',
    iAcceptCharter: 'Ich akzeptiere die Charta und verpflichte mich, sie zu respektieren',
    iCommitNobleUse: 'Ich verpflichte mich, Cogency nur für noble Zwecke zu nutzen und nicht für schädliche Zwecke',
    fullNameRequired: 'Vollständiger Name ist erforderlich',
    usernameRequired: 'Benutzername ist erforderlich',
    usernameTooShort: 'Benutzername muss mindestens 3 Zeichen lang sein',
    validEmailRequired: 'Gültige E-Mail ist erforderlich',
    phoneRequired: 'Telefonnummer ist erforderlich',
    genderRequired: 'Geschlecht ist erforderlich',
    validAgeRequired: 'Alter muss zwischen 13 und 120 Jahren liegen',
    professionRequired: 'Beruf ist erforderlich',
    passwordMin6Chars: 'Passwort muss mindestens 6 Zeichen lang sein',
    passwordsDoNotMatch: 'Passwörter stimmen nicht überein',
    mustReadCharter: 'Sie müssen die Charta lesen',
    mustAcceptCharter: 'Sie müssen die Charta akzeptieren',
    mustCommitNobleUse: 'Sie müssen sich zu noble Nutzung verpflichten',
    privacyTitle: 'Ihre Privatsphäre ist uns wichtig',
    privacyText: 'Wir respektieren Ihre Privatsphäre. Wir verpflichten uns, Ihre Daten nicht an Dritte weiterzugeben. Ihre Informationen werden ausschließlich zur Verbesserung Ihrer Benutzererfahrung verwendet.',
    privacyNoShare: 'Keine Weitergabe von Daten an Dritte',
    privacyExperience: 'Daten nur zur Verbesserung der Erfahrung verwendet',
    privacySecure: 'Sichere und verschlüsselte Speicherung',
    understoodContinue: 'Verstanden, Weiter',
    fullNamePlaceholder: 'Max Mustermann',
    usernamePlaceholder: 'max_mustermann',
    phonePlaceholder: '+49 170 1234567',
    agePlaceholder: '25',
    professionPlaceholder: 'Ingenieur, Arzt, Student...',
    passwordPlaceholder: '••••••',
    confirmPasswordPlaceholder: '••••••',
    noActiveSession: 'Keine aktive Sitzung',
    pendingApproval: 'Ausstehende Genehmigung',
    allUsers: 'Alle Benutzer',
    noUsersFound: 'Keine Benutzer gefunden.',
    deleteUser: 'Benutzer löschen',
    suspendUser: 'Benutzer sperren',
    activateUser: 'Benutzer aktivieren',
    ejectUser: 'Benutzer auswerfen',
    notifyUsers: 'Benutzer benachrichtigen',
    sendNotification: 'Benachrichtigung senden',
    notificationTitle: 'Titel der Benachrichtigung',
    notificationMessage: 'Benachrichtigungsnachricht',
    selectUsers: 'Wählen Sie Benutzer aus',
    all: 'Alle',
    modelGrowth: 'Modellwachstum',
    localModelStats: 'Lokale Modellstatistiken',
    services: 'Dienste',
    externalServices: 'Externe Dienste',
    enableElevenLabs: 'ElevenLabs aktivieren',
    elevenLabsCaption: 'Nutze die ElevenLabs API für hochwertige Text-to-Speech-Stimmen.',
    elevenLabsEnabled: 'ElevenLabs ist aktiviert.',
    elevenLabsDisabled: 'ElevenLabs ist deaktiviert. Die native Browser-TTS wird verwendet.',
    totalLocalCalls: 'Gesamtzahl der Ortsgespräche',
    totalTokens: 'Gesamtzahl der Token',
    sessionsWithLocal: 'Sitzungen mit Local',
    learningScore: 'Lernergebnis',
    modelUsage: 'Modellverwendung',
    dailyGrowth: 'Tägliches Wachstum',
    noData: 'Keine Daten',
    userManagement: 'Benutzerverwaltung',
    actions: 'Aktionen',
    suspended: 'Suspendiert',
    active: 'Aktiv',
    deleted: 'Gelöscht',
    ejected: 'Ausgeworfen',
    confirmDeleteUser: 'Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?',
    confirmSuspendUser: 'Möchten Sie diesen Benutzer wirklich sperren?',
    confirmEjectUser: 'Möchten Sie diesen Benutzer wirklich aus allen Sitzungen ausschließen?',
    resetPassword: 'Passwort zurücksetzen',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Passwort bestätigen',
    passwordTooShort: 'Das Passwort muss mindestens 6 Zeichen lang sein',
    passwordsDoNotMatch: 'Passwörter stimmen nicht überein',
    passwordResetSuccess: 'Passwort erfolgreich zurückgesetzt',
    passwordResetFailed: 'Passwort konnte nicht zurückgesetzt werden',
    newSession: 'Neue Sitzung',
    modeBypass: 'Bypass-Modus – Der Moderator fragt nie nach Ihrer Eingabe',
    modePresent: 'Präsentationsmodus – Der Moderator wartet auf Ihren Kommentar',
    bypass: 'Bypass',
    present: 'Anwesend',
    notificationSent: 'Benachrichtigung gesendet',
    usersOnline: 'Benutzer online',
    accessibility: 'Barrierefreiheit',
    accessibilityDesc: 'Passen Sie Cogency an Ihre Bedürfnisse an.',
    largeText: 'Großer Text',
    largeTextDesc: 'Textgröße um 15 % erhöhen',
    highContrast: 'Hoher Kontrast',
    highContrastDesc: 'Kräftige Farben für bessere Sichtbarkeit',
    reducedMotion: 'Reduzierte Bewegung',
    reducedMotionDesc: 'Animationen minimieren',
    keyboardShortcuts: 'Tastaturkürzel',
    focusInput: 'Fokus-Eingabefeld',
    sendMessage: 'Nachricht senden',
    stopOrCancel: 'Stimme stoppen oder abbrechen',
    enableVoice: 'Aktivieren Sie Sprachbefehle',
    disableVoice: 'Deaktivieren Sie Sprachbefehle',
    holdToSpeak: 'Halten Sie gedrückt, um zu sprechen',
    listening: 'Zuhören…',
    heard: 'Gehört',
    voiceHint: 'Halten Sie die Leertaste gedrückt oder klicken Sie auf das Mikrofon, um zu sprechen',
    voiceHintMobile: 'Tippen Sie auf das Mikrofon, um zu sprechen',
    voiceLogin: 'Login öffnen',
    voiceRegister: 'Eröffnungsregistrierung',
    voiceLogout: 'Abmelden',
    voiceGoToChat: 'Chat eröffnen',
    voiceGoToSetup: 'Einstellungen öffnen',
    voiceGoToHistory: 'Eröffnungsgeschichte',
    voiceHelpText: 'Sie können sagen: Zum Chat gehen, zu den Einstellungen gehen, Agenten hinzufügen, stellen, gefolgt von Ihrer Frage, Feldnamen gefolgt von Wert eingeben, absenden, abmelden.',
    voiceEnabled: 'Sprachbefehle aktiviert',
    voiceDisabled: 'Sprachbefehle deaktiviert',
    voiceTyped: 'Getippt',
    voiceSubmitted: 'Eingereicht',
    voiceAsking: 'Fragen',
    voiceReadingLast: 'Letzte Nachricht wird gelesen',
    voiceReadingAll: 'Alle Nachrichten lesen',
    voiceStopped: 'Angehalten',
    voiceAgentAdded: 'Agent hinzugefügt',
    voiceAgentRemoved: 'Agent entfernt',
    voiceDidNotUnderstand: 'Ich habe es nicht verstanden.Sagen Sie Hilfe zu den verfügbaren Befehlen.',
    voiceNotSupported: 'Die Spracherkennung wird in diesem Browser nicht unterstützt.',
    policyWarning: 'RICHTLINIENWARNUNG: Diese Anfrage verstößt gegen die Cogency-Charta (Inhalte mit Bezug zu politischen und religiösen Konflikten sind strengstens untersagt).Dieser Versuch wurde protokolliert.Weitere Versuche werden die Vollstreckung auslösen.',
    policyEnforcement: 'DURCHSETZUNG: Ihr Konto wurde wegen Verstoßes gegen die internen Richtlinien und die Charta von Cogency gesperrt.Inhalte mit Bezug zu politischen und religiösen Konflikten sind strengstens untersagt.Kontaktieren Sie den Administrator.',
    viewCharter: 'Charta ansehen',
    policyNotice: 'Richtlinienhinweis',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    cancel: 'Abbrechen',
    edited: 'bearbeitet',
    cancelDebate: 'Debatte abbrechen',
    resume: 'Lebenslauf',
    liveSessions: 'Live-Sitzungen',
    persist: 'Bleiben Sie bestehen',
    dumpAll: 'Alles wegwerfen',
    inMemory: 'In Erinnerung',
    orphanedSessions: 'Verwaist',
    charterTitle: 'Nutzungscharta und interne Richtlinie',
    charterVersion: 'Version 1.0',
    charterEffective: 'Gültig ab dem Datum der Veröffentlichung.',
    charterArt1Title: 'Zweck und Umfang',
    charterArt1Text: 'Cogency ist ein multidisziplinäres Tool zur Entscheidungsunterstützung, das die wissenschaftliche Forschung, technische Analyse und die gemeinsame Erforschung komplexer Themen erleichtern soll.Diese Charta gilt für alle Benutzer, Abonnenten, Administratoren und Partner, die auf die Plattform zugreifen.',
    charterArt2Title: 'Streng wissenschaftlicher und technischer Zweck',
    charterArt2Intro: 'Obwohl es sich bei Cogency um ein multidisziplinäres Entscheidungsunterstützungsinstrument handelt, bleibt sein Zweck rein wissenschaftlich und technisch.Die Plattform darf niemals verwendet werden für:',
    charterArt2Item1: 'Konflikte jeglicher Art schüren, rechtfertigen oder verteidigen;',
    charterArt2Item2: 'Förderung politischer, religiöser oder sektiererischer Ideologien;',
    charterArt2Item3: 'Hass, Diskriminierung oder Gewalt anstiften;',
    charterArt2Item4: 'Propaganda-, Desinformations- oder Meinungsmanipulationsinhalte produzieren.',
    charterArt3Title: 'Striktes Verbot politischer und religiöser Konfliktinhalte',
    charterArt3Intro: 'Jegliche Fragen, Recherchen, Debatten oder Interventionen zu politischen oder religiösen Themen, insbesondere wenn sie sich auf Konflikte, extremistische Bewegungen, Kriege, Verfolgungen oder interkommunalen Hass beziehen, sind strengstens untersagt.',
    charterArt3Item1: 'Begriffe und Konzepte im Zusammenhang mit bewaffneten Konflikten, Terrorismus, Völkermord, ethnischen Säuberungen, Staatsstreichen und totalitären Regimen;',
    charterArt3Item2: 'Begriffe und Konzepte im Zusammenhang mit Dschihad, Kreuzzügen, Inquisitionen, Fatwas, erzwungenem Abfall vom Glauben, Blasphemie, religiöser Radikalisierung und heiligen Kriegen.',
    charterArt4Title: 'Überwachungs- und Durchsetzungsverfahren',
    charterArt4_1Title: 'Protokollierung',
    charterArt4_1Text: 'Jeder Versuch, Inhalte einzureichen, die gegen diese Charta verstoßen, wird automatisch mit Zeitstempel, Benutzer-ID und Art des Versuchs protokolliert.',
    charterArt4_2Title: 'Progressive Warnung',
    charterArt4_2Item1: 'Erster und zweiter Versuch – der Benutzer erhält eine ausdrückliche Warnung, die ihn an die Charter erinnert und darauf hinweist, dass der Versuch protokolliert wurde.',
    charterArt4_2Item2: 'Dritter Versuch – es wird automatisch ein Disziplinarverfahren wegen Nichteinhaltung der Cogency-Charta und der internen Richtlinien eingeleitet.Dies kann zu einer vorübergehenden oder dauerhaften Aussetzung führen.',
    charterArt4_3Title: 'Berufung',
    charterArt4_3Text: 'Benutzer können sich an den Administrator wenden, wenn sie mit einer automatischen Entscheidung nicht einverstanden sind, sofern sie Beweise vorlegen, die den rein wissenschaftlichen oder technischen Charakter ihrer Anfrage rechtfertigen.',
    charterArt5Title: 'Verantwortlichkeiten des Benutzers',
    charterArt5Item1: 'Halten Sie sich strikt an diese Charta;',
    charterArt5Item2: 'Verwenden Sie Cogency nur in einem beruflichen, akademischen oder Forschungskontext;',
    charterArt5Item3: 'Melden Sie verdächtiges Verhalten oder verdächtige Inhalte dem Administrator.',
    charterArt6Title: 'Charta-Änderung',
    charterArt6Text: 'Cogency behält sich das Recht vor, diese Satzung jederzeit zu ändern.Benutzer werden über jede wesentliche Aktualisierung über die Plattform informiert.',
    themes: 'Themen',
    themesIntro: 'Wählen Sie einen Look, der zu Ihnen passt.Themes mit Bildern können der App einen visuellen Hintergrund hinzufügen.',
    chatTransparency: 'Chat-Transparenz',
    chatTransparencyHint: 'Machen Sie die Chatkarte transparent, um das Hintergrundbild anzuzeigen',
    attachDocument: 'Dokument anhängen',
    close: 'Schließen',
    noContactsToInvite: 'Keine Kontakte zum Einladen vorhanden',
    selectUser: 'Wählen Sie einen Benutzer aus',
    manageContacts: 'Kontakte verwalten',
    contactManager: 'Kontaktmanager',
    friend: 'Freund',
    colleague: 'Kollege',
    superior: 'Überlegen',
    add: 'Hinzufügen',
    loading: 'Laden',
    noContactsYet: 'Noch keine Kontakte',
    confirmDeleteContact: 'Sind Sie sicher, dass Sie diesen Kontakt löschen möchten?',
    next: 'Weiter →',
    step: 'Schritt',
    yes: 'Ja',
    no: 'Nein',
    decrease: 'Abnahme',
    increase: 'Erhöhen',
    onboardingProgress: 'Einrichtungsfortschritt',
    onboardingWelcomeTitle: 'Willkommen bei Cogency',
    onboardingWelcomeDesc: 'Ich bin Cogency, Ihr multidimensionaler Meeting- und Kollaborationsassistent.Gerne helfe ich Ihnen bei der Einrichtung Ihrer ersten Agentensitzung.',
    howManyAgentsTitle: 'Wie viele Agenten?',
    howManyAgentsDesc: 'Wählen Sie aus, wie viele KI-Agenten Sie zu dieser Sitzung hinzufügen möchten.',
    howManyAgents: 'Anzahl der Agenten',
    howManyAgentsHelp: 'Sie können bis zu 10 Expertenagenten hinzufügen.',
    configureAgentsTitle: 'Konfigurieren Sie Agenten',
    configureAgentsDesc: 'Wählen Sie für jeden Agenten eine Persona und ein Modell aus.',
    selectPersona: 'Wählen Sie eine Person aus',
    selectModel: 'Wählen Sie ein Modell aus',
    moderationModeTitle: 'Moderatormodus',
    moderationModeDesc: 'Sollte die Sitzung zwischen den Runden pausieren, um Sie um Ihren Input zu bitten?',
    presentMode: 'Anwesend',
    presentModeDesc: 'Die Sitzung pausiert zwischen den Runden und wartet auf Ihren Kommentar.',
    bypassMode: 'Bypass',
    bypassModeDesc: 'Die Sitzung durchläuft alle Runden ohne Unterbrechung.',
    inviteHumansTitle: 'Menschliche Mitarbeiter einladen?',
    inviteHumansDesc: 'Möchten Sie Personen aus Ihrem Cogency-Verzeichnis zur Teilnahme an dieser Sitzung einladen?',
    yesInviteHumans: 'Ja, Kontakte einladen.',
    noInviteHumans: 'Nein, nur Agenten.',
    selectContactsTitle: 'Wählen Sie Kontakte aus',
    selectContactsDesc: 'Wählen Sie die Kontakte aus, die Sie zu dieser Sitzung einladen möchten.',
    noContactsHelp: 'Sie können Kontakte später über den Chat-Bildschirm einladen.',
    selectModeratorTitle: 'Wählen Sie den Moderator',
    selectModeratorDesc: 'Welcher Agent fungiert als Moderator/Analyst für diese Sitzung?',
    noAgentsForModerator: 'Es wurden keine Agenten hinzugefügt.Es wird ein Standardanalyst verwendet.',
    sessionTypeTitle: 'Sitzungstyp',
    sessionTypeDesc: 'Wie möchten Sie diese Sitzung durchführen?',
    ordinaryCollaboration: 'Gewöhnliche Zusammenarbeit',
    ordinaryCollaborationDesc: 'Private Sitzung – stellen Sie eine Frage und die Agenten diskutieren.',
    sharedCollaboration: 'Gemeinsame Zusammenarbeit',
    sharedCollaborationDesc: 'Offene Sitzung – ausgewählte Kontakte können in Echtzeit beitreten.',
    launchSession: 'Sitzung starten',
    sessionReady: 'Sitzung bereit',
    preparingSession: 'Vorbereiten...',
    applyingAgents: 'Auftragen von Agenten...',
    creatingSession: 'Sitzung erstellen...',
    applyingModerationMode: 'Moderatormodus wird angewendet...',
    sendingInvitations: 'Einladungen werden versendet...',
    launching: 'Sitzung wird gestartet...',
    applicationDomain: 'Anwendungsdomäne',
    freeSession: 'Kostenlose Sitzung',
    getStarted: 'Legen Sie los',
    domainResearch: 'Wissenschaftliche Forschung',
    domainMechanics: 'Mechanik',
    domainBiology: 'Biologie',
    domainAgriculture: 'Landwirtschaft',
    domainMedicine: 'Medizin',
    domainIT: 'Informatik',
    domainLaw: 'Gesetz',
    domainEconomy: 'Wirtschaft',
    domainEducation: 'Bildung',
    domainEnergy: 'Energie',
    domainEnvironment: 'Umwelt',
    domainConstruction: 'Bau',
    domainFinance: 'Finanzen / Bankwesen',
    domainMarketing: 'Marketing / Kommunikation',
    domainHR: 'HR / Management',
    domainCybersecurity: 'Cybersicherheit',
    domainLogistics: 'Transport / Logistik',
    domainArts: 'Kunst / Kultur',
    domainPublicHealth: 'Öffentliche Gesundheit',
    domainMining: 'Bergbau / Geologie',
    domainOilGas: 'Öl / Gas',
    domainTelecom: 'Telekommunikation',
    domainRobotics: 'Robotik / IoT',
    domainPsychology: 'Psychologie',
    domainPhilosophy: 'Philosophie / Ethik',
    domainLinguistics: 'Linguistik / Sprachen',
    domainSpace: 'Luftfahrt / Raumfahrt',
    domainClimate: 'Klima / Wetter',
    tourWelcomeTitle: 'Willkommen bei Cogency',
    tourWelcomeText: 'Cogency ist eine kollaborative Intelligence-Plattform.Anstatt eine einzelne KI zu fragen, bringen Sie mehrere Expertenagenten zusammen, die gemeinsam diskutieren, hinterfragen und die beste Antwort verfeinern.',
    tourDifferenceTitle: 'Was macht Cogency anders?',
    tourDifferenceText: 'Klassische Assistenten geben Ihnen eine einzige Antwort.Cogency simuliert ein Expertengremium: Jeder Agent bringt seine eigene Perspektive, Stärken und Grenzen ein, um eine umfassendere, differenziertere und zuverlässigere Analyse zu liefern.',
    tourCollaborativeTitle: 'Kollaborative Intelligenz',
    tourCollaborativeText: 'Überzeugungskraft ersetzt das menschliche Denken nicht – sie verstärkt es.Die Agenten arbeiten unter Ihrer Aufsicht zusammen: Sie wählen die Frage, die Experten und den Moderationsmodus.Das Endergebnis ist eine ausgewogene Synthese ihrer Diskussion.',
    tourContextTitle: 'Bleiben Sie im richtigen Kontext',
    tourContextText: 'Überzeugungskraft glänzt bei komplexen, analytischen oder multidisziplinären Fragen.Das Stellen von Fragen, die nichts mit einer Expertendebatte zu tun haben – etwa triviale oder rein persönliche Anliegen – wird seine Stärke nicht ausnutzen.Verwenden Sie es, wenn Sie tiefgreifende Überlegungen benötigen.',
    tourFinish: 'Start',
    remainingConnexionTime: 'Verbleibende Verbindungszeit',
    connectedTime: 'Verbindungszeit',
    trialExpiredTitle: 'Probezeit beendet',
    trialExpiredText: 'Ihre 7-tägige Testversion ist beendet.Erwerben Sie einen Plan, um Cogency weiterhin nutzen zu können.',
    trialExpiredCta: 'Siehe Pläne',
    voice: 'Stimme',
    mute: 'Stumm',
    unmute: 'Stummschaltung aufheben',
  
    fullscreen: 'Vollbild',},
  zh: {
    login: '登录',
    register: '订阅',
    email: '电子邮件',
    password: '密码',
    name: '全名',
    access: '访问 Cogency',
    subscribersOnly: '仅限订阅者',
    premiumPersonaMessage: '仅限至少拥有高级订阅的用户',
    cannotStartTitle: '配置未就绪',
    cannotStartDetail: '所有代理和合成器必须具有可运行的模型才能启动。',
    collapseSidebar: '折叠菜单',
    expandSidebar: '展开菜单',
    pendingTitle: '订阅待定',
    pendingDesc: '您的帐户正在等待管理员批准。',
    logout: '退出',
    startCollaborating: '开始合作',
    configureAgents: '配置您的代理',
    apiKeys: '云 API 密钥',
    discussionRounds: '讨论轮次',
    addAgent: '添加代理',
    synthesizer: '合成器',
    readyToCollaborate: '准备好合作',
    askAnything: '有什么问...',
    connected: '已连接',
    disconnected: '已断开连接',
    collaborators: '合作者',
    share: '分享',
    invite: '邀请',
    save: '保存',
    reconfigure: '重新配置',
    howItWorks: '它是如何运作的',
    yourAgents: '您的代理人',
    settings: '设置',
    interfaceSettings: '界面',
    interfaceSettingsDesc: '自定义应用程序外观和分享选项。',
    rounds: '回合',
    session: '会议',
    finalAnswer: '最终答案',
    copy: '复制',
    showDebate: '显示完整辩论',
    hideDebate: '隐藏完整辩论',
    adminPanel: '管理面板',
    verifyUsers: '验证订阅者',
    noPendingUsers: '没有待定订阅者',
    verify: '验证',
    footer: '© Synaptics 解决方案和技术有限公司。保留所有权利。',
    poweredBy: '由 Cogency 提供支持',
    joinSession: '加入会话',
    enterSessionId: '输入会话 ID 或链接',
    subscriberWelcome: '欢迎！加入会话与 AI 代理协作。',
    lockedForAdmin: '配置已锁定 - 仅限管理员',
    reject: '拒绝',
    inviteToSession: '邀请参加会议',
    invite: '邀请',
    invited: '受邀',
    subscribers: '订阅者',
    plans: '计划',
    cogency: '说服力',
    status: '状态',
    agents: '代理商',
    admin: '管理员',
    checkingProviders: '检查提供商',
    connecting: '正在连接...',
    connectedTo: '已连接',
    noProvidersAvailable: '没有可用的提供商',
    availableModels: '可用型号',
    loading: '正在加载...',
    startSharedSession: '开始共享会话',
    sharedSessionsHint: '共享会话让其他人可以实时观看和协作。',
    connectionFailed: '连接失败',
    noProvidersAvailableDetail: '没有可用的人工智能提供商。确保 Ollama 正在运行，或为云提供商添加 API 密钥。',
    tryAgain: '再试一次',
    agent: '代理',
    remove: '删除',
    persona: '人格面具',
    model: '型号',
    powerUser: '高级用户',
    locked: '锁定',
    unlockPowerUser: '解锁高级用户',
    enterUnlockCode: '输入解锁码',
    unlock: '解锁',
    incorrectUnlockCode: '解锁码不正确。',
    addKeysDesc: '添加关键点以使用 Claude、Kimi、Hugging Face 或 TchadGPT 模型。奥拉玛无需钥匙即可工作。',
    powerUserFeature: '高级用户功能。解锁以配置云提供商。',
    combinesAllAgentArguments: '将所有代理论点合并为一个清晰、平衡的答案。',
    eachRoundEveryAgentSpeaks: '每轮，每个特工发言一次。更多回合=更深入的辩论。',
    backToHome: '返回首页',
    help: '帮助',
    collaborate: '协作',
    exportPDF: '导出PDF',
    exportDOCX: '导出DOCX',
    exportPPTX: '导出PPTX',
    exportLaTeX: '导出LaTeX',
    export: '导出',
    processing: '处理中...',
    welcome: '欢迎',
    startAsking: '在下面输入问题或使用麦克风说话，然后观看人工智能代理辩论答案。',
    initialAnalysis: '初步分析',
    debateRound1: '辩论第一轮',
    debateRound2: '辩论第二轮',
    helpStep1Title: `1. 主持人提出问题`,
    helpStep1Text: `用户——主持人——提出需要讨论的问题或议题。`,
    helpStep2Title: `2. 第一个 AI 智能体回答`,
    helpStep2Text: `第一个 AI 智能体直接回答问题。`,
    helpStep3Title: `3. 第二个智能体回答并批评`,
    helpStep3Text: `第二个 AI 智能体给出自己的回答，然后批评或补充第一个智能体的回答，并以总结结束。`,
    helpStep4Title: `4. 后续每个智能体以此类推`,
    helpStep4Text: `后续每个智能体都对其之前所有 AI 智能体和人类的回答进行同样的操作。`,
    helpStep5Title: `5. 嘉宾参与并结束本轮`,
    helpStep5Text: `本轮结束时邀请其他参与者——本地或远程——以及主持人进行评论或补充。每个人都可以点击跳过，让辩论继续。`,
    helpStep6Title: `6. 轮次继续`,
    helpStep6Text: `各轮按照相同模式进行，直到最后一轮。`,
    helpStep7Title: `7. 主持人发布最终答案`,
    helpStep7Text: `主持人——AI 智能体或人类——发布最终答案，综合所有参与者的发言，并结合可用数据进行分析。`,
    helpStep8Title: `8. 辩论思维导图`,
    helpStep8Text: `自动生成思维导图，展示辩论的结构和要点。`,
    helpStep9Title: `9. 导出内容`,
    helpStep9Text: `主持人可以将整场辩论历史导出为 PDF、PPTX、DOCX 和 LaTeX，每个单独回答也可以分别导出。`,
    send: '发送',
    listeningSpeakNow: '正在听……现在说话',
    stop: '停止',
    processingYourVoice: '正在处理您的声音...',
    cancel: '取消',
    enterYourIntervention: '输入您的干预...',
    pass: '通行证',
    noIntervention: '不干预',
    pressEnterToSend: '按 Enter 发送',
    useSendButton: '点击发送按钮发送',
    clickToSpeak: '点击🎤发言',
    voiceOutputOn: '语音输出开启',
    textVoiceOutput: '文字+语音输出',
    textOutputOnly: '仅文本输出',
    readAloud: '大声朗读',
    mindMap: '思维导图',
    analyzingContent: '正在分析内容...',
    generatingMindMapStructure: '生成思维导图结构...',
    organizingBranches: '组织分支机构...',
    finalizing: '正在敲定...',
    complete: '完成！',
    failedToGenerateMindMap: '生成思维导图失败',
    errorGeneratingMindMap: '生成思维导图时出错',
    failedToExportPDF: '导出 PDF 失败',
    error: '错误',
    you: '你',
    humanIntervention: '人为干预',
    moderator: '主持人',
    voiceSettings: '语音设置',
    onlyAdministratorsCanChangeVoiceSettings: '只有管理员可以更改语音设置。',
    voiceInput: '语音输入',
    serverSTT: '服务器STT',
    browserSTT: '浏览器STT',
    voiceOutput: '语音输出',
    serverTTS: '服务器语音合成',
    browserTTS: '浏览器语音合成',
    voiceOutputSettingsAdmin: '语音输出设置（管理员）',
    stt: '短时传输时间',
    serverWhisper: '服务器（耳语）',
    browserWebSpeech: '浏览器（网络语音）',
    tts: '语音合成',
    serverEspeak: '服务器（eSpeak）',
    browserSpeechSynthesis: '浏览器（语音合成）',
    outputMode: '输出方式',
    textOnly: '仅文本',
    textOnlyDesc: '回复仅显示为文本',
    voiceOnly: '仅语音',
    voiceOnlyDesc: '大声说出回应',
    textAndVoice: '文字+语音',
    textAndVoiceDesc: '文本和语音输出',
    voiceType: '语音类型',
    human: '人类',
    artificial: '人工',
    gender: '性别',
    male: '男',
    female: '女',
    age: '年龄',
    young: '年轻',
    old: '老',
    language: '语言',
    voiceEnabled: '语音启用',
    outputVoice: '输出语音',
    voiceCommand: '语音命令',
    voiceSelection: '语音选择',
    voiceSelectionDesc: '选择用于朗读答案的语音。',
    availableVoices: '可用语音',
    availableVoicesDesc: '从浏览器可用的语音中选择。',
    noVoicesAvailable: '无可用语音',
    voiceRate: '语速',
    voiceRateDesc: '语音速度',
    voicePitch: '音调',
    voicePitchDesc: '语音音调',
    testVoice: '测试语音',
    selectedVoice: '已选语音',
    voiceTestText: 'Cogency 已准备好为您提供帮助。',
    underDevelopment: '开发中',
    selectYourSkill: '选择您的技能水平',
    selectYourSkillDesc: '选择您的经验水平以自定义界面。',
    skillBeginner: '初学者',
    skillProfessional: '专业版',
    skillExpert: '专家版',
    skillBeginnerDesc: '带有分步指导的简化界面。',
    skillProfessionalDesc: '包含所有选项的完整界面。',
    skillExpertDesc: '具有精细控制的高级模式。',
    skillComingSoon: '界面即将推出',
    skillComingSoonDesc: '{skill} 界面正在开发中。',
    xaiVoice: 'Grok 语音 (xAI)',
    xaiVoiceDesc: '通过 xAI Grok Voice 进行文本转语音和语音转文本。',
    xaiUnavailableHint: '请检查服务器配置中的 XAI_VOICE_API_KEY。',
    xaiTts: '文本转语音',
    xaiStt: '语音转文本',
    xaiVoiceSelect: '语音',
    xaiVoiceSelectDesc: '选择合成语音',
    xaiTtsTest: '测试文本转语音',
    xaiSttTest: '测试语音转文本',
    xaiTtsTestText: '你好，这是 Grok 语音的测试。',
    xaiTtsFailed: 'Grok 文本转语音失败',
    xaiSttFailed: 'Grok 语音转文本失败',
    startRecording: '开始录音',
    stopRecording: '停止',
    fullscreen: '全屏',
    connectedAs: '已连接为',
    changeLogo: '更改徽标',
    customizeLogo: '自定义徽标',
    logoUploaderHint: '选择此磁盘的图像（您的照片、徽标等）。仅适用于此栏。',
    exitFullscreen: '退出全屏',
    closeSession: '关闭会话',
    connectedAt: `连接时间`,
    ipAddress: `IP 地址`,
    noConnectedAddresses: `没有已连接的 IP 地址。`,
    connectedAddresses: `已连接地址`,
    tracking: `追踪`,
    connectionLog: `连接日志`,
    connectionLogDesc: `包含 IP 地址、操作系统和设备类型的连接历史记录。`,
    deviceType: `设备`,
    uniqueIps: `唯一 IP`,
    entries: `条目`,
    noConnectionLog: `没有记录连接。`,
    searchConnectionLog: `搜索 IP、操作系统、设备、浏览器...`,
    sortRecent: `最新`,
    sortOldest: `最早`,
    sortByCountry: `国家`,
    sortByDevice: `设备类型`,
    sortByOs: `操作系统`,
    sortByBrowser: `浏览器`,
    sortByUser: `用户`,
    sortByAction: `连接状态`,
    scrollToBottom: `滚动到底部`,
    refresh: `刷新`,
    connect: `连接`,
    disconnect: `断开连接`,
    date: `日期`,
    action: `操作`,
    sharedSessionHint: `共享会话允许其他人实时观看和协作。`,
    startSharedSession: `开始共享会话`,
    startCollaborating: `开始协作`,
    brandTagline: '成功就是当别人停下时继续前行',
    statusThinking: '{label}: 所有代理正在并行思考...',
    moderationPrompt: '第 {round} 轮完成。是否有参与者希望在第 {nextRound} 轮之前进行干预？',
    on: '开',
    off: '关闭',
    saving: '正在保存...',
    saveSettings: '💾 保存设置',
    settingsSavedSuccessfully: '✅ 设置成功保存',
    failedToSaveSettings: '❌ 保存设置失败',
    howItWorksTitle: '它是如何运作的',
    youAskAQuestion: '你问一个问题',
    typeAnything: '输入任何内容 - 从简单的问题到复杂的辩论。',
    multipleAgentsAnalyze: '多代理分析',
    eachAgentBringsPerspective: '每个代理商都带来了他们独特的视角和模式。',
    theyDebateInRounds: '他们进行回合辩论',
    everyRoundEachAgentResponds: '每一轮，每个代理都会对迄今为止的完整对话做出回应。',
    youGetTheBestAnswer: '你会得到最佳答案',
    synthesizerCombinesBestPoints: '合成器将他们的最佳观点结合成一个清晰的答案。',
    helpIntro: `与单个 AI 或共识式 AI 不同，Cogency 不仅仅给您一个直接答案。您提出问题或主题，然后多个 AI 智能体一起辩论。经典 AI 独自寻找答案，而 Cogency 让您发声：每一轮，您都可以发表意见、补充内容、批评某个回答，或点击跳过让辩论继续。您积极参与答案的构建，并在智能体工作时影响它们的分析。`,
    helpCoreTitle: '工作流程',
    helpFeaturesTitle: '核心功能',
    helpMultiAgentTitle: '专业智能体',
    helpMultiAgentText: `每个智能体都有自己的角色、模型和专业知识，以丰富辩论。`,
    helpDebateRoundsTitle: '辩论轮次',
    helpDebateRoundsText: `智能体交换多轮回复，完善论点，并相互回应想法。`,
    helpSynthesisTitle: '最终答案',
    helpSynthesisText: `综合智能体将最佳论点整理成一个结构化、可执行的结论。`,
    helpInterventionTitle: '人工干预',
    helpInterventionText: `您可以随时介入，引导、纠正或深化讨论。`,
    helpMoreTitle: '还有',
    helpVoiceTitle: '语音控制',
    helpVoiceText: `用语音提问，让应用朗读答案。`,
    helpAgentsPersonasTitle: '自定义',
    helpAgentsPersonasText: `选择预定义智能体或创建自己的角色和模型。`,
    helpExportTitle: '导出',
    helpExportText: `将对话或综合结果下载为 PDF、DOCX、PPTX 或 LaTeX。`,
    helpHistoryTitle: '历史记录',
    helpHistoryText: `随时查找、恢复和查看之前的会话。`,
    helpCollaborationTitle: '共享会话',
    helpCollaborationText: `开始公开会话，邀请其他用户实时跟随辩论。`,
    helpAccessibilityTitle: '无障碍',
    helpAccessibilityText: `根据需求调整对比度、文字大小、动画和声音。`,
    helpDebateMechanismTitle: `辩论机制`,
    helpDebateMechanismText: `第一轮，第一个智能体直接回答问题。从第二个智能体开始，每个智能体都会给出自己的版本，并批评前一个智能体的回答。依此类推，所有智能体（以及人类）都会表达观点并批评之前的贡献，从而丰富辩论并将分析引向更好的答案。`,
    helpAddedValueTitle: `附加价值`,
    helpAddedValueText: `Cogency 提供的回答和方向具有标准化特征，因为其分析结合了两个重要的情境维度。第一个是本地维度：它考虑提问用户的具体情况、个人资料和特定需求。第二个是全球维度：它整合全球范围内的最新发展、更新和趋势。因此，最终回答不仅仅是原始信息：而是一个结构化结论，源于深入、多维的分析。`,
    helpCommandsTitle: '快捷命令',
    helpCommandImage: `智能体可以在有助于说明其回答时自动生成并插入图片。`,
    helpCommandMindMap: '根据主题自动生成思维导图。',
    helpCommandIntervene: '在辩论中插入您自己的消息。',
    helpCommandVoice: '启用或禁用语音识别。',
    helpCommandExport: '立即以所选格式导出最新答案。',
    helpPlansTitle: '套餐与试用',
    helpPlansText: `从免费试用开始，然后选择适合您使用的套餐。管理员可以在管理面板中管理订阅。`,
    helpPrivacyTitle: '隐私',
    helpPrivacyText: `您的对话与您的账户关联。Cogency 可以与本地模型（Ollama）一起运行，以将数据保留在本地。`,
    helpTipTitle: '💡 提示',
    helpTipText: `提问时尽量具体，并增加轮次以获得更深入的分析。`,
    inviteCollaborators: '邀请合作者',
    shareSessionLink: '🔗 分享会议链接',
    anyoneWithThisLink: '知道此链接的任何人都可以加入并实时观看辩论。',
    createSessionAndCopyLink: '💾 创建会话并复制链接',
    inviteAIAgent: '🤖 邀请AI代理',
    addAnotherAIAgent: '在下一次辩论的名册中添加另一个人工智能代理。',
    addAgent: '添加代理',
    currentParticipants: '👥 当前参与者',
    noParticipantsYet: '还没有参与者',
    back: '← 返回',
    sessionHistory: '📜 会话历史记录',
    history: '历史记录',
    sessions: '会议',
    loadingSessions: '正在加载会话...',
    noSavedSessionsYet: '尚未保存会话。',
    completedDebatesWillAppear: '已完成的辩论将自动出现在此处。',
    selectSessionToViewDetails: '选择一个会话以查看详细信息',
    loadingSession: '正在加载会话...',
    untitledSession: '无标题会议',
    purgeEmptySessions: '🧹 清除空会话',
    confirmPurgeEmptySessions: '删除所有没有消息的会话？此操作无法撤消。',
    purgedEmptySessions: '已清除空会话',
    purgeFailed: '清除失败',
    translateToFrench: '翻译成法语',
    translateToArabic: '翻译成阿拉伯语',
    translationFailed: '翻译失败',
    round: '圆形',
    debateHistory: '🗣️辩论历史',
    sendSessionByEmail: '📧 通过电子邮件发送会话',
    recipientEmail: '收件人@example.com',
    sending: '正在发送...',
    deleteSessionConfirm: '您确定要永久删除此会话吗？',
    failedToLoadSessions: '无法加载会话',
    failedToLoadSessionDetail: '无法加载会话详细信息',
    exportFailed: '导出失败',
    generatingDocument: `正在生成文档…`,
    deleteFailed: '删除失败',
    failedToExportDOCX: '导出 DOCX 失败',
    failedToExportPPTX: '导出 PPTX 失败',
    pythonExecutionFailed: 'Python 执行失败',
    failedToSendEmail: '发送电子邮件失败',
    pleaseEnterValidEmail: '请输入有效的电子邮件地址',
    emailSentSuccessfully: '邮件发送成功！',
    teamChat: '💬 团队聊天',
    typeAMessage: '输入消息...',
    mindMapTitle: '🧠 思维导图',
    zoomIn: '放大',
    zoomOut: '缩小',
    reset: '重置',
    scrollToZoom: '🖱 滚动缩放',
    dragToPan: '拖动平移',
    clickBranchesToExpandCollapse: '单击分支以展开/折叠',
    copySource: '📋复制来源',
    sourceTextCopied: '源文本已复制到剪贴板！',
    authenticating: '正在验证...',
    loginFailed: '登录失败',
    networkErrorPleaseTryAgain: '网络错误。请再试一次。',
    registrationSuccessful: '注册成功！',
    pleaseWaitForAdminApproval: '请等待管理员批准。',
    registering: '正在注册...',
    registrationFailed: '注册失败',
    fullName: '全名',
    username: '用户名',
    phone: '电话号码',
    gender: '性别',
    female: '女',
    male: '男',
    age: '年龄',
    profession: '职业',
    confirmPassword: '确认密码',
    charterAgreement: '宪章协议',
    iHaveReadCharter: '我已阅读Cogency宪章',
    readCharter: '阅读宪章',
    iAcceptCharter: '我接受宪章并承诺遵守它',
    iCommitNobleUse: '我承诺仅将Cogency用于崇高目的，不用于任何有害目的',
    fullNameRequired: '全名是必填项',
    usernameRequired: '用户名是必填项',
    usernameTooShort: '用户名必须至少3个字符',
    validEmailRequired: '需要有效的电子邮件',
    phoneRequired: '电话号码是必填项',
    genderRequired: '性别是必填项',
    validAgeRequired: '年龄必须在13至120岁之间',
    professionRequired: '职业是必填项',
    passwordMin6Chars: '密码必须至少6个字符',
    passwordsDoNotMatch: '密码不匹配',
    mustReadCharter: '您必须阅读宪章',
    mustAcceptCharter: '您必须接受宪章',
    mustCommitNobleUse: '您必须承诺崇高用途',
    privacyTitle: '您的隐私很重要',
    privacyText: '我们尊重您的隐私。我们承诺不与第三方共享您的数据。您的信息仅用于改善您的用户体验。',
    privacyNoShare: '不与第三方共享数据',
    privacyExperience: '数据仅用于改善体验',
    privacySecure: '安全加密存储',
    understoodContinue: '明白了，继续',
    fullNamePlaceholder: '张三',
    usernamePlaceholder: 'zhang_san',
    phonePlaceholder: '+86 138 1234 5678',
    agePlaceholder: '25',
    professionPlaceholder: '工程师、医生、学生...',
    passwordPlaceholder: '••••••',
    confirmPasswordPlaceholder: '••••••',
    noActiveSession: '没有活动会话',
    pendingApproval: '待批准',
    allUsers: '所有用户',
    noUsersFound: '没有找到用户。',
    deleteUser: '删除用户',
    suspendUser: '暂停用户',
    activateUser: '激活用户',
    ejectUser: '弹出用户',
    notifyUsers: '通知用户',
    sendNotification: '发送通知',
    notificationTitle: '通知标题',
    notificationMessage: '通知消息',
    selectUsers: '选择用户',
    all: '全部',
    modelGrowth: '模型增长',
    localModelStats: '本地模型统计数据',
    services: '服务',
    externalServices: '外部服务',
    enableElevenLabs: '启用 ElevenLabs',
    elevenLabsCaption: '使用 ElevenLabs API 获得高质量语音合成。',
    elevenLabsEnabled: 'ElevenLabs 已启用。',
    elevenLabsDisabled: 'ElevenLabs 已禁用。将使用浏览器原生语音合成。',
    totalLocalCalls: '本地通话总数',

    totalTokens: '代币总数',
    sessionsWithLocal: '与当地人的会议',
    learningScore: '学习成绩',
    modelUsage: '型号用途',
    dailyGrowth: '每日成长',
    noData: '无数据',
    userManagement: '用户管理',
    actions: '行动',
    suspended: '暂停',
    active: '活跃',
    deleted: '已删除',
    ejected: '被弹出',
    confirmDeleteUser: '您确定要删除该用户吗？',
    confirmSuspendUser: '您确定要暂停该用户吗？',
    confirmEjectUser: '您确定要从所有会话中驱逐该用户吗？',
    resetPassword: '重置密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    passwordTooShort: '密码必须至少为 6 个字符',
    passwordsDoNotMatch: '密码不匹配',
    passwordResetSuccess: '密码重置成功',
    passwordResetFailed: '重置密码失败',
    newSession: '新会议',
    modeBypass: '旁路模式 - 主持人从不询问您的意见',
    modePresent: '演示模式——主持人等待您的评论',
    bypass: '旁路',
    present: '现在',
    notificationSent: '通知已发送',
    usersOnline: '用户在线',
    accessibility: '无障碍',
    accessibilityDesc: '根据您的需求定制 Cogency。',
    largeText: '大文本',
    largeTextDesc: '将文本大小增加 15%',
    highContrast: '高对比度',
    highContrastDesc: '强烈的色彩带来更好的可视性',
    reducedMotion: '减少运动',
    reducedMotionDesc: '最小化动画',
    keyboardShortcuts: '键盘快捷键',
    focusInput: '焦点输入字段',
    sendMessage: '发送消息',
    stopOrCancel: '停止语音或取消',
    enableVoice: '启用语音命令',
    disableVoice: '禁用语音命令',
    holdToSpeak: '按住说话',
    listening: '正在听……',
    heard: '赫德',
    voiceHint: '按住空格键或单击麦克风讲话',
    voiceHintMobile: '点击麦克风说话',
    voiceLogin: '开通登录',
    voiceRegister: '开业登记',
    voiceLogout: '注销',
    voiceGoToChat: '打开聊天',
    voiceGoToSetup: '打开设置',
    voiceGoToHistory: '开业历史',
    voiceHelpText: '您可以说：转到聊天，转到设置，添加代理，询问您的问题，输入字段名称，然后输入值，提交，注销。',
    voiceEnabled: '语音命令已启用',
    voiceDisabled: '语音命令已禁用',
    voiceTyped: '打字的',
    voiceSubmitted: '已提交',
    voiceAsking: '询问',
    voiceReadingLast: '正在阅读最后一条消息',
    voiceReadingAll: '阅读所有消息',
    voiceStopped: '已停止',
    voiceAgentAdded: '已添加代理',
    voiceAgentRemoved: '已删除代理',
    voiceDidNotUnderstand: '我不明白。说出可用命令的帮助。',
    voiceNotSupported: '此浏览器不支持语音识别。',
    policyWarning: '政策警告：此请求违反了《权力宪章》（严格禁止与政治和宗教冲突相关的内容）。此尝试已被记录。进一步的尝试将触发执法。',
    policyEnforcement: '执行：您的帐户因违反 Cogency 内部政策和章程而被暂停。严禁与政治和宗教冲突相关的内容。联系管理员。',
    viewCharter: '查看章程',
    policyNotice: '政策通知',
    edit: '编辑',
    delete: '删除',
    cancel: '取消',
    edited: '已编辑',
    cancelDebate: '取消辩论',
    resume: '简历',
    liveSessions: '现场会议',
    persist: '坚持',
    dumpAll: '全部转储',
    inMemory: '记忆中',
    orphanedSessions: '孤儿',
    charterTitle: '使用章程和内部政策',
    charterVersion: '1.0版本',
    charterEffective: '自发布之日起生效。',
    charterArt1Title: '目的和范围',
    charterArt1Text: 'Cogency 是一种多学科决策支持工具，旨在促进科学研究、技术分析和复杂主题的协作探索。本章程适用于访问该平台的所有用户、订阅者、管理员和合作伙伴。',
    charterArt2Title: '严格的科学技术目的',
    charterArt2Intro: '尽管 Cogency 是一种多学科决策支持工具，但其目的仍然是严格的科学和技术性的。该平台不得用于：',
    charterArt2Item1: '助长、证明或捍卫任何类型的冲突；',
    charterArt2Item2: '宣扬政治、宗教或宗派意识形态；',
    charterArt2Item3: '煽动仇恨、歧视或暴力；',
    charterArt2Item4: '制作宣传、虚假信息或舆论操纵内容。',
    charterArt3Title: '严禁政治、宗教冲突内容',
    charterArt3Intro: '严格禁止有关政治或宗教主题的任何问题、研究、辩论或干预，特别是与冲突、极端主义运动、战争、迫害或族群间仇恨有关的问题、研究、辩论或干预。',
    charterArt3Item1: '与武装冲突、恐怖主义、种族灭绝、种族清洗、政变、极权政权有关的术语和概念；',
    charterArt3Item2: '与圣战、十字军东征、宗教裁判所、法特瓦、强迫叛教、亵渎、宗教激进化、圣战相关的术语和概念。',
    charterArt4Title: '监督和执行程序',
    charterArt4_1Title: '记录',
    charterArt4_1Text: '任何提交违反本章程的内容的尝试都会自动记录，并包含时间戳、用户 ID 和尝试的性质。',
    charterArt4_2Title: '渐进式警告',
    charterArt4_2Item1: '第一次和第二次尝试 - 用户收到明确的警告，提醒他们章程并注意到该尝试已被记录。',
    charterArt4_2Item2: '第三次尝试——对不遵守 Cogency 章程和内部政策的行为自动启动纪律程序。这可能会导致暂时或永久暂停。',
    charterArt4_3Title: '上诉',
    charterArt4_3Text: '如果用户不同意自动决定，则可以联系管理员，只要他们提交证据证明其请求具有严格的科学或技术性质。',
    charterArt5Title: '用户的责任',
    charterArt5Item1: '严格遵守本章程；',
    charterArt5Item2: '仅在专业、学术或研究环境中使用 Cogency；',
    charterArt5Item3: '向管理员报告任何可疑行为或内容。',
    charterArt6Title: '宪章修正案',
    charterArt6Text: 'Cogency 保留随时修改本章程的权利。用户将通过平台获悉任何重大更新。',
    themes: '主题',
    themesIntro: '选择适合您的外观。带有图像的主题可以为应用程序添加视觉背景。',
    chatTransparency: '聊天透明度',
    chatTransparencyHint: '将聊天卡设置为透明以查看背景图片',
    attachDocument: '附上文件',
    close: '关闭',
    noContactsToInvite: '没有可邀请的联系人',
    selectUser: '选择一个用户',
    manageContacts: '管理联系人',
    contactManager: '联系经理',
    friend: '朋友',
    colleague: '同事',
    superior: '高级',
    add: '添加',
    loading: '加载中',
    noContactsYet: '还没有联系方式',
    confirmDeleteContact: '您确定要删除此联系人吗？',
    next: '下一页 →',
    step: '步骤',
    yes: '是的',
    no: '否',
    decrease: '减少',
    increase: '增加',
    onboardingProgress: '设置进度',
    onboardingWelcomeTitle: '欢迎来到 Cogency',
    onboardingWelcomeDesc: '我是 Cogency，您的多维会议和协作助手。让我帮助您设置您的第一次代理会话。',
    howManyAgentsTitle: '有多少代理？',
    howManyAgentsDesc: '选择要添加到此会话的 AI 代理数量。',
    howManyAgents: '代理人数',
    howManyAgentsHelp: '您最多可以添加 10 位专家代理。',
    configureAgentsTitle: '配置代理',
    configureAgentsDesc: '为每个代理选择角色和模型。',
    selectPersona: '选择一个角色',
    selectModel: '选择型号',
    moderationModeTitle: '主持人模式',
    moderationModeDesc: '会议是否应该在各轮之间暂停以征求您的意见？',
    presentMode: '现在',
    presentModeDesc: '会话在各轮之间暂停并等待您的评论。',
    bypassMode: '旁路',
    bypassModeDesc: '会议贯穿各个回合，不间断。',
    inviteHumansTitle: '邀请人类合作者？',
    inviteHumansDesc: '您想邀请 Cogency 目录中的人员参加本次会议吗？',
    yesInviteHumans: '是的，邀请联系人。',
    noInviteHumans: '不可以，仅限代理。',
    selectContactsTitle: '选择联系人',
    selectContactsDesc: '选择您想要邀请参加此会话的联系人。',
    noContactsHelp: '您可以稍后从聊天屏幕邀请联系人。',
    selectModeratorTitle: '选择主持人',
    selectModeratorDesc: '哪位代理将担任本次会议的主持人/分析师？',
    noAgentsForModerator: '没有添加任何代理。将使用默认分析师。',
    sessionTypeTitle: '会话类型',
    sessionTypeDesc: '您想如何举办本次会议？',
    ordinaryCollaboration: '普通协作',
    ordinaryCollaborationDesc: '私人会议——提出问题，代理人进行辩论。',
    sharedCollaboration: '共享协作',
    sharedCollaborationDesc: '开放会话 — 选定的联系人可以实时加入。',
    launchSession: '开始会话',
    sessionReady: '会议准备就绪',
    preparingSession: '正在准备...',
    applyingAgents: '申请代理...',
    creatingSession: '正在创建会话...',
    applyingModerationMode: '正在应用主持人模式...',
    sendingInvitations: '正在发送邀请...',
    launching: '启动会议...',
    applicationDomain: '应用领域',
    freeSession: '免费课程',
    getStarted: '开始使用',
    domainResearch: '科学研究',
    domainMechanics: '力学',
    domainBiology: '生物学',
    domainAgriculture: '农业',
    domainMedicine: '医学',
    domainIT: '计算机科学',
    domainLaw: '法律',
    domainEconomy: '经济',
    domainEducation: '教育',
    domainEnergy: '能源',
    domainEnvironment: '环境',
    domainConstruction: '建筑工程',
    domainFinance: '金融/银行',
    domainMarketing: '营销/传播',
    domainHR: '人力资源/管理',
    domainCybersecurity: '网络安全',
    domainLogistics: '运输/物流',
    domainArts: '艺术/文化',
    domainPublicHealth: '公共卫生',
    domainMining: '采矿/地质',
    domainOilGas: '石油/天然气',
    domainTelecom: '电信',
    domainRobotics: '机器人/物联网',
    domainPsychology: '心理学',
    domainPhilosophy: '哲学/伦理学',
    domainLinguistics: '语言学/语言',
    domainSpace: '航空/航天',
    domainClimate: '气候/天气',
    tourWelcomeTitle: '欢迎来到 Cogency',
    tourWelcomeText: 'Cogency 是一个协作智能平台。您不需要询问单个人工智能，而是将多个专家代理聚集在一起，共同辩论、挑战和完善最佳答案。',
    tourDifferenceTitle: '是什么让 Cogency 与众不同',
    tourDifferenceText: '经典助手为您提供单一答案。Cogency 模拟专家小组：每个代理都有自己的观点、优势和局限性，以提供更完整、细致和可靠的分析。',
    tourCollaborativeTitle: '协同智能',
    tourCollaborativeText: '说服力并不会取代人类思维，而是放大了人类思维。代理在您的监督下进行协作：您选择问题、专家和审核模式。最终结果是他们的讨论的平衡综合。',
    tourContextTitle: '保持在正确的环境中',
    tourContextText: '说服力擅长解决复杂的、分析性的或多学科的问题。提出与专家辩论无关的问题——例如琐碎或纯粹的个人请求——不会发挥其优势。当你需要深入思考时使用它。',
    tourFinish: '开始',
    remainingConnexionTime: '剩余连接时间',
    connectedTime: '连接时间',
    trialExpiredTitle: '试用期结束',
    trialExpiredText: '您的 7 天试用期已结束。购买计划以继续使用 Cogency。',
    trialExpiredCta: '查看计划',
    voice: '语音',
    mute: '静音',
    unmute: '取消静音',
  
    fullscreen: '全屏',},
};

export const I18nContext = createContext(null);
export const useI18n = () => useContext(I18nContext);

export function I18nProvider({ children }) {
  const [geoChecked, setGeoChecked] = useState(false);
  const [lang, setLang] = useState(() => {
    // Priority: explicit in-app choice, then landing-page choice, then browser default, then French.
    const savedAppLang = localStorage.getItem('cogency_lang');
    const savedLandingLang = localStorage.getItem('cogency-landing-lang');
    const browserLang = typeof navigator !== 'undefined' ? (navigator.language || navigator.userLanguage || 'fr').slice(0, 2).toLowerCase() : 'fr';
    const detected = savedAppLang || savedLandingLang || browserLang || 'fr';
    return translations[detected] ? detected : 'fr';
  });
  const dir = lang === 'ar' ? 'rtl' : 'ltr';

  // Fetch IP-based language on first visit if no saved preference
  useEffect(() => {
    const savedAppLang = localStorage.getItem('cogency_lang');
    const savedLandingLang = localStorage.getItem('cogency-landing-lang');
    if (geoChecked || savedAppLang || savedLandingLang) return;
    setGeoChecked(true);
    fetch('/api/detect-language')
      .then(r => r.json())
      .then(data => {
        if (data.lang && data.lang !== 'fr' && data.lang !== lang) {
          setLang(data.lang);
          localStorage.setItem('cogency_lang', data.lang);
        }
      })
      .catch(() => {});
  }, [geoChecked, lang]);
  const t = (key, params) => {
    let text = translations[lang]?.[key] || key;
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        text = text.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
      });
    }
    return text;
  };
  const switchLang = (l) => {
    setLang(l);
    localStorage.setItem('cogency_lang', l);
    // Keep landing-page language in sync so returning to the landing page feels consistent.
    try { localStorage.setItem('cogency-landing-lang', l); } catch {}
    document.documentElement.lang = l;
    document.documentElement.dir = l === 'ar' ? 'rtl' : 'ltr';
  };
  // Set initial dir/lang on mount
  useState(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
  });
  return (
    <I18nContext.Provider value={{ lang, dir, t, switchLang }}>
      {children}
    </I18nContext.Provider>
  );
}
